import React from 'react';

export const HomeBannerImage = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1485.937'
			height='805.897'
			viewBox='0 0 1485.937 805.897'
			preserveAspectRatio='xMidYMid slice'
		>
			<g>
				<g id='BACKGROUND'>
					<rect
						id='Rectangle_5'
						data-name='Rectangle 5'
						width='1485.937'
						height='805.897'
						fill='#f1c1a4'
					/>
					<rect
						id='Rectangle_6'
						data-name='Rectangle 6'
						width='1485.937'
						height='252.339'
						transform='translate(0 553.558)'
						fill='#e8b091'
					/>
					<path
						id='Path_3'
						data-name='Path 3'
						d='M1175.35,829.34l-7.122-.2h0c-.841-5.726-3.572-11.3-7.993-16.69h0l6-.608c.8-.083,1.366-.645,1.261-1.253v-.045a1.456,1.456,0,0,0-1.651-.961l-7.167.75a1.15,1.15,0,0,0-.218.052h0a79.933,79.933,0,0,0-14.124-11.94h0l5.156-1.336c.75-.2,1.178-.833.916-1.418v-.06a1.606,1.606,0,0,0-1.861-.7l-6.837,1.771a160.412,160.412,0,0,0-19.6-10.582l4.15-1.081c.75-.2,1.178-.833.923-1.418v-.06a1.606,1.606,0,0,0-1.861-.7l-6.612,1.711h0q-9.006-3.951-19.332-7.58h0l4.173-1.839a.991.991,0,0,0,.54-1.5l-.045-.053a1.734,1.734,0,0,0-2-.413l-6.056,2.664q-3.452-1.171-7.032-2.3C1035.191,756.574,959.086,746,874.635,746c-79.708,0-151.986,9.388-204.879,24.646q-8.473,2.432-16.27,5.073l-6.056-2.664a1.734,1.734,0,0,0-2,.413l-.037.052a.991.991,0,0,0,.533,1.5l4.158,1.824c-6.889,2.424-13.351,4.961-19.332,7.595h0l-6.634-1.666a1.6,1.6,0,0,0-1.861.7v.06c-.263.585.15,1.223.916,1.418l4.135,1.073h0a161.569,161.569,0,0,0-19.61,10.574h0l-6.807-1.756a1.606,1.606,0,0,0-1.861.7v.06c-.263.585.15,1.223.916,1.418l5.118,1.328a79.554,79.554,0,0,0-14.146,11.97h0a2.132,2.132,0,0,0-.21-.053l-7.16-.75a1.448,1.448,0,0,0-1.636,1.028v.068c-.105.608.458,1.171,1.261,1.253l5.936.608c-4.413,5.388-7.152,10.972-7.992,16.7h0l-7.1.2a1.28,1.28,0,0,0-1.411,1.163v.06a1.358,1.358,0,0,0,1.5,1.081l6.754-.2h0c0,.533-.045,1.058-.045,1.583,0,6.807,2.634,13.433,7.647,19.79l-6.552,2.161c-.75.255-1.081.916-.75,1.5l.038.06a1.681,1.681,0,0,0,1.936.57l6.6-2.251a1.285,1.285,0,0,0,.248-.128c13.509,15.52,41.043,29.366,78.447,40.263l-4.27,3.257a.931.931,0,0,0,0,1.576l.06.053a1.809,1.809,0,0,0,2.071,0l5.111-3.895c.038,0,.053-.068.09-.1h0c9.246,2.612,19.085,5.066,29.426,7.31l-2.5,4.443c-.323.57,0,1.223.75,1.5h.083a1.651,1.651,0,0,0,1.921-.585l2.664-4.72c10.709,2.251,21.959,4.323,33.674,6.154h0l-1.989,5.253c-.225.593.225,1.216,1.006,1.388h.083a1.568,1.568,0,0,0,1.816-.75l2.011-5.253v-.128h0q16.615,2.522,34.379,4.42h0a.248.248,0,0,0-.045.075l-1.433,5.4c-.165.608.345,1.193,1.141,1.321h.09a1.5,1.5,0,0,0,1.726-.878l1.433-5.4a.752.752,0,0,0,0-.225h.038q18.011,1.869,37.043,3h0v5.081a1.328,1.328,0,0,0,1.5,1.118h.083a1.328,1.328,0,0,0,1.5-1.118v-4.908c14.064.833,28.518,1.343,43.227,1.546l-.39,4.5c-.06.615.555,1.148,1.366,1.186h.083a1.389,1.389,0,0,0,1.561-1.043l.405-4.615c3.475.053,6.964.068,10.507.068q11.933,0,23.61-.278l.428,4.826a1.388,1.388,0,0,0,1.561,1.043h.083c.81-.038,1.426-.57,1.366-1.186l-.413-4.766c10.2-.263,20.263-.69,30.132-1.268h0v4.908a1.321,1.321,0,0,0,1.5,1.118h.09a1.321,1.321,0,0,0,1.5-1.118v-5.111h0c12.676-.75,25.051-1.786,37.051-3h0a.851.851,0,0,0,0,.24l1.433,5.4a1.5,1.5,0,0,0,1.734.878h.083c.8-.128,1.306-.75,1.148-1.321l-1.433-5.4a.088.088,0,0,0-.045-.075h0q17.741-1.9,34.357-4.435h0a.485.485,0,0,0,0,.143l2,5.253a1.584,1.584,0,0,0,1.824.75h.083c.751-.173,1.223-.8,1-1.388l-1.989-5.253h0c11.715-1.839,22.972-3.895,33.681-6.154l2.664,4.72a1.658,1.658,0,0,0,1.929.585h.075c.75-.248,1.088-.9.75-1.5l-2.514-4.45h0q15.52-3.377,29.418-7.31h0a1.328,1.328,0,0,0,.1.113l5.111,3.895a1.808,1.808,0,0,0,2.071,0l.068-.052a.938.938,0,0,0,0-1.576l-4.285-3.265q15.175-4.413,28.075-9.456h0a.474.474,0,0,0,.113.12l5.313,3.752a1.816,1.816,0,0,0,2.071-.068l.06-.053a.938.938,0,0,0-.082-1.576l-4.661-3.272h0a191.366,191.366,0,0,0,26.394-12.841l5.1,3.115a1.793,1.793,0,0,0,2.064-.165l.053-.053a.953.953,0,0,0-.225-1.576l-4.593-2.807A83.969,83.969,0,0,0,1159.26,854.8h0a1.274,1.274,0,0,0,.262.143l6.612,2.251a1.689,1.689,0,0,0,1.936-.57v-.06c.33-.563,0-1.223-.75-1.5l-6.5-2.191c4.991-6.356,7.625-12.983,7.625-19.79,0-.525,0-1.051-.052-1.583h0l6.754.2a1.366,1.366,0,0,0,1.5-1.081v-.06C1176.791,829.88,1176.16,829.363,1175.35,829.34Z'
						transform='translate(-142.879 -190.761)'
						fill='#a8787b'
						opacity='0.1'
					/>
					<path
						id='Path_4'
						data-name='Path 4'
						d='M1171.218,829.425c0,6.807-2.634,13.433-7.632,19.79-.51.638-1.036,1.291-1.6,1.929a81.826,81.826,0,0,1-18.762,15.362c-.75.5-1.568.976-2.394,1.5a190.53,190.53,0,0,1-26.394,12.826c-.923.375-1.884.751-2.837,1.118q-12.878,5.021-28.083,9.456c-1.021.308-2.026.6-3.062.886q-13.869,3.94-29.419,7.31l-2.934.645c-10.709,2.251-21.966,4.315-33.681,6.146l-3,.458q-16.582,2.544-34.357,4.428c-.976.105-1.966.218-2.949.3q-18.011,1.891-37.051,3c-1.006.068-2,.128-3,.18-9.869.578-19.94,1.006-30.139,1.268-1.006.037-2.011.06-3,.083q-11.662.293-23.61.278c-3.512,0-7,0-10.507-.06h-3c-14.709-.2-29.163-.751-43.235-1.546-1.006-.052-2.011-.105-3-.18q-19.017-1.148-37.043-3c-.991-.1-1.981-.2-2.949-.315q-17.749-1.876-34.379-4.42c-.991-.15-1.974-.3-3-.465-11.715-1.831-22.972-3.887-33.681-6.146l-2.919-.63c-10.349-2.251-20.188-4.7-29.433-7.31-1.036-.285-2.041-.593-3.062-.893-37.411-10.9-64.976-24.766-78.462-40.27-.555-.638-1.081-1.291-1.576-1.929-5.013-6.356-7.647-12.983-7.647-19.79,0-.525,0-1.058.045-1.583.052-.75.135-1.546.248-2.319.841-5.726,3.58-11.317,7.993-16.706.593-.713,1.186-1.418,1.846-2.109A79.619,79.619,0,0,1,607.65,794.76c.856-.578,1.749-1.156,2.649-1.741a159.481,159.481,0,0,1,19.61-10.574c1.141-.525,2.251-1.043,3.445-1.546q9.006-3.951,19.332-7.595c1.118-.39,2.251-.751,3.392-1.156,5.193-1.756,10.634-3.452,16.285-5.073,52.931-15.257,125.209-24.646,204.879-24.646,84.451,0,160.6,10.544,214.193,27.422q3.58,1.126,7.039,2.3l3.392,1.171c6.889,2.416,13.351,4.946,19.332,7.58,1.171.518,2.3,1.028,3.422,1.546a159.959,159.959,0,0,1,19.61,10.582c.908.578,1.8,1.156,2.657,1.749a79.627,79.627,0,0,1,14.124,11.94c.638.705,1.253,1.411,1.824,2.124,4.42,5.388,7.152,10.964,7.993,16.69.12.751.2,1.539.248,2.319A6.567,6.567,0,0,1,1171.218,829.425Z'
						transform='translate(-145.576 -189.87)'
						fill='#ce7f57'
					/>
					<ellipse
						id='Ellipse_3'
						data-name='Ellipse 3'
						cx='267.446'
						cy='76.473'
						rx='267.446'
						ry='76.473'
						transform='translate(464.31 560.372)'
						fill='none'
						stroke='#fff'
						strokeWidth='0.88'
						opacity='0.48'
					/>
					<ellipse
						id='Ellipse_4'
						data-name='Ellipse 4'
						cx='257.562'
						cy='67.25'
						rx='257.562'
						ry='67.25'
						transform='translate(474.194 569.656)'
						fill='none'
						stroke='#fff'
						strokeWidth='0.81'
						opacity='0.48'
					/>
					<path
						id='Path_5'
						data-name='Path 5'
						d='M669.482,778.883l.038-.06a1.741,1.741,0,0,1,2-.405l6.266,2.754a.983.983,0,0,1,.533,1.5l-.045.06a1.726,1.726,0,0,1-2,.405l-6.259-2.747a.991.991,0,0,1-.533-1.508Z'
						transform='translate(-167.01 -198.261)'
						fill='#efbfab'
					/>
					<path
						id='Path_6'
						data-name='Path 6'
						d='M694.535,945.505l-.06-.045a.938.938,0,0,1,0-1.583l5.111-3.9a1.808,1.808,0,0,1,2.071,0l.06.053a.931.931,0,0,1,0,1.576l-5.111,3.895a1.809,1.809,0,0,1-2.071,0Z'
						transform='translate(-173.182 -239.083)'
						fill='#efbfab'
					/>
					<path
						id='Path_7'
						data-name='Path 7'
						d='M741.089,957.378h-.083a1.037,1.037,0,0,1-.75-1.5l2.852-5.066a1.674,1.674,0,0,1,1.929-.585h.075a1.038,1.038,0,0,1,.75,1.5l-2.829,5.058a1.666,1.666,0,0,1-1.944.593Z'
						transform='translate(-184.681 -241.695)'
						fill='#efbfab'
					/>
					<path
						id='Path_8'
						data-name='Path 8'
						d='M790.82,967.284h-.083c-.75-.173-1.231-.788-1.006-1.381l2.011-5.253a1.576,1.576,0,0,1,1.816-.75h.082c.75.173,1.231.75,1.006,1.381l-2.011,5.253a1.569,1.569,0,0,1-1.816.75Z'
						transform='translate(-197.045 -244.119)'
						fill='#efbfab'
					/>
					<path
						id='Path_9'
						data-name='Path 9'
						d='M841.4,973.954h-.09c-.8-.12-1.306-.705-1.141-1.313l1.433-5.4a1.5,1.5,0,0,1,1.726-.878h.09c.75.12,1.306.75,1.141,1.321l-1.433,5.4a1.5,1.5,0,0,1-1.726.871Z'
						transform='translate(-209.637 -245.738)'
						fill='#efbfab'
					/>
					<rect
						id='Rectangle_7'
						data-name='Rectangle 7'
						width='3.024'
						height='7.745'
						rx='0.92'
						transform='translate(672.004 723.21)'
						fill='#efbfab'
					/>
					<path
						id='Path_10'
						data-name='Path 10'
						d='M958,979.166h-.083c-.81-.037-1.426-.57-1.366-1.193l.48-5.493a1.381,1.381,0,0,1,1.561-1.036h.083c.811.045,1.426.578,1.366,1.193l-.48,5.493A1.388,1.388,0,0,1,958,979.166Z'
						transform='translate(-238.683 -247.011)'
						fill='#efbfab'
					/>
					<path
						id='Path_11'
						data-name='Path 11'
						d='M638.694,792.142v-.06a1.6,1.6,0,0,1,1.861-.7l6.837,1.771c.75.2,1.178.833.923,1.418v.06a1.606,1.606,0,0,1-1.861.7l-6.844-1.771C638.844,793.365,638.431,792.728,638.694,792.142Z'
						transform='translate(-159.351 -201.539)'
						fill='#efbfab'
					/>
					<path
						id='Path_12'
						data-name='Path 12'
						d='M607.7,808.222v-.06a1.621,1.621,0,0,1,1.861-.705l6.844,1.771c.75.2,1.178.841.916,1.418v.068a1.613,1.613,0,0,1-1.861.7l-6.807-1.771C607.854,809.437,607.441,808.807,607.7,808.222Z'
						transform='translate(-151.619 -205.58)'
						fill='#efbfab'
					/>
					<path
						id='Path_13'
						data-name='Path 13'
						d='M584.926,828.069V828a1.441,1.441,0,0,1,1.651-.961l7.159.75c.8.082,1.366.645,1.261,1.261v.06a1.433,1.433,0,0,1-1.643.961l-7.167-.75C585.384,829.254,584.821,828.677,584.926,828.069Z'
						transform='translate(-145.951 -210.513)'
						fill='#efbfab'
					/>
					<path
						id='Path_14'
						data-name='Path 14'
						d='M572.54,854.587v-.045a1.314,1.314,0,0,1,1.411-1.156l7.227-.21a1.358,1.358,0,0,1,1.5,1.073v.068a1.325,1.325,0,0,1-1.411,1.163l-7.227.2a1.358,1.358,0,0,1-1.5-1.1Z'
						transform='translate(-142.864 -217.086)'
						fill='#efbfab'
					/>
					<path
						id='Path_15'
						data-name='Path 15'
						d='M584.015,888.385l-.038-.068c-.33-.563,0-1.223.75-1.5l6.6-2.251a1.681,1.681,0,0,1,1.936.57l.038.06c.33.57,0,1.231-.75,1.5l-6.6,2.251A1.666,1.666,0,0,1,584.015,888.385Z'
						transform='translate(-145.686 -225.31)'
						fill='#efbfab'
					/>
					<path
						id='Path_16'
						data-name='Path 16'
						d='M1277.641,778.883l-.045-.06a1.741,1.741,0,0,0-2-.405l-6.259,2.754a.983.983,0,0,0-.54,1.5l.045.06a1.734,1.734,0,0,0,2,.405l6.259-2.747a.991.991,0,0,0,.54-1.509Z'
						transform='translate(-316.555 -198.261)'
						fill='#efbfab'
					/>
					<path
						id='Path_17'
						data-name='Path 17'
						d='M1252.939,945.5l.068-.045a.946.946,0,0,0,0-1.583l-5.111-3.895a1.816,1.816,0,0,0-2.079,0l-.06.053a.938.938,0,0,0,0,1.576l5.111,3.895A1.809,1.809,0,0,0,1252.939,945.5Z'
						transform='translate(-310.743 -239.083)'
						fill='#efbfab'
					/>
					<path
						id='Path_18'
						data-name='Path 18'
						d='M1294.658,931.493l.06-.053a.938.938,0,0,0-.083-1.576l-5.313-3.752a1.809,1.809,0,0,0-2.071.068l-.06.045a.946.946,0,0,0,.083,1.583l5.313,3.752a1.809,1.809,0,0,0,2.071-.068Z'
						transform='translate(-321.091 -235.631)'
						fill='#efbfab'
					/>
					<path
						id='Path_19'
						data-name='Path 19'
						d='M1333.01,911.892l.052-.045a.953.953,0,0,0-.225-1.576l-5.629-3.452a1.809,1.809,0,0,0-2.064.172l-.052.053a.945.945,0,0,0,.218,1.568l5.636,3.452A1.779,1.779,0,0,0,1333.01,911.892Z'
						transform='translate(-330.565 -230.828)'
						fill='#efbfab'
					/>
					<path
						id='Path_20'
						data-name='Path 20'
						d='M1207.135,957.378h.075a1.038,1.038,0,0,0,.75-1.5l-2.852-5.066a1.681,1.681,0,0,0-1.929-.585h-.083a1.038,1.038,0,0,0-.75,1.5l2.852,5.066A1.681,1.681,0,0,0,1207.135,957.378Z'
						transform='translate(-299.985 -241.696)'
						fill='#efbfab'
					/>
					<path
						id='Path_21'
						data-name='Path 21'
						d='M1157.708,967.284h.083c.75-.173,1.223-.788,1-1.381l-2.011-5.253a1.569,1.569,0,0,0-1.816-.75h-.083c-.75.173-1.223.75-1,1.381l2,5.253A1.583,1.583,0,0,0,1157.708,967.284Z'
						transform='translate(-287.91 -244.119)'
						fill='#efbfab'
					/>
					<path
						id='Path_22'
						data-name='Path 22'
						d='M1107.3,973.953h.083c.8-.12,1.306-.705,1.148-1.313l-1.434-5.4a1.5,1.5,0,0,0-1.733-.878h-.083c-.8.12-1.306.75-1.148,1.321l1.433,5.4a1.5,1.5,0,0,0,1.734.871Z'
						transform='translate(-275.503 -245.738)'
						fill='#efbfab'
					/>
					<rect
						id='Rectangle_8'
						data-name='Rectangle 8'
						width='3.024'
						height='7.745'
						rx='0.92'
						transform='translate(788.53 723.21)'
						fill='#efbfab'
					/>
					<path
						id='Path_23'
						data-name='Path 23'
						d='M1008.488,979.166h.082c.811-.037,1.426-.57,1.366-1.193l-.48-5.493a1.381,1.381,0,0,0-1.561-1.036h-.09c-.8.045-1.418.578-1.366,1.193l.488,5.493a1.388,1.388,0,0,0,1.561,1.036Z'
						transform='translate(-251.133 -247.011)'
						fill='#efbfab'
					/>
					<path
						id='Path_24'
						data-name='Path 24'
						d='M1308.235,792.143v-.06a1.606,1.606,0,0,0-1.861-.7l-6.844,1.771c-.75.2-1.178.833-.916,1.418v.06a1.606,1.606,0,0,0,1.861.7l6.844-1.771C1308.085,793.366,1308.49,792.728,1308.235,792.143Z'
						transform='translate(-324.019 -201.539)'
						fill='#efbfab'
					/>
					<path
						id='Path_25'
						data-name='Path 25'
						d='M1339.225,808.222v-.06a1.621,1.621,0,0,0-1.861-.705l-6.844,1.771c-.75.2-1.178.841-.916,1.418v.068a1.613,1.613,0,0,0,1.861.7l6.844-1.771C1339.075,809.437,1339.488,808.807,1339.225,808.222Z'
						transform='translate(-331.752 -205.58)'
						fill='#efbfab'
					/>
					<path
						id='Path_26'
						data-name='Path 26'
						d='M1361.885,828.069V828a1.448,1.448,0,0,0-1.651-.961l-7.167.75c-.8.083-1.366.645-1.261,1.261v.06a1.441,1.441,0,0,0,1.651.961l7.159-.75C1361.427,829.255,1361.99,828.677,1361.885,828.069Z'
						transform='translate(-337.308 -210.513)'
						fill='#efbfab'
					/>
					<path
						id='Path_27'
						data-name='Path 27'
						d='M1374.271,854.588v-.045a1.314,1.314,0,0,0-1.411-1.156l-7.22-.21a1.366,1.366,0,0,0-1.5,1.073v.068a1.325,1.325,0,0,0,1.411,1.163l7.219.2A1.366,1.366,0,0,0,1374.271,854.588Z'
						transform='translate(-340.389 -217.087)'
						fill='#efbfab'
					/>
					<path
						id='Path_28'
						data-name='Path 28'
						d='M1362.976,888.385v-.068c.33-.563,0-1.223-.75-1.5l-6.612-2.251a1.689,1.689,0,0,0-1.936.57v.06c-.33.57,0,1.231.75,1.5l6.612,2.251a1.674,1.674,0,0,0,1.936-.563Z'
						transform='translate(-337.747 -225.31)'
						fill='#efbfab'
					/>
				</g>
				<g id='OBJECTS' transform='translate(422.045)'>
					<rect
						id='Rectangle_9'
						data-name='Rectangle 9'
						width='155.243'
						height='10.589'
						rx='1.5'
						transform='translate(45.92 367.432)'
						fill='#c6764a'
						opacity='0.11'
					/>
					<ellipse
						id='Ellipse_5'
						data-name='Ellipse 5'
						cx='44.533'
						cy='14.514'
						rx='44.533'
						ry='14.514'
						transform='translate(439.251 589.594)'
						fill='#5b2101'
						opacity='0.17'
					/>
					<path
						id='Path_29'
						data-name='Path 29'
						d='M1194.475,632.61a168.94,168.94,0,0,0-42.424,5.831,4.187,4.187,0,0,0-2.672,4.285c.218,8.428,1.088,55.257,4.5,78.252,4.158,27.858,15.858,46.469,28.923,46.469h23.325c13.066,0,24.766-18.612,28.923-46.469,3.422-22.972,4.3-69.794,4.5-78.229a4.156,4.156,0,0,0-2.687-4.285C1230.363,636.715,1213.034,632.61,1194.475,632.61Z'
						transform='translate(-708.845 -160.472)'
						fill='#ff9500'
					/>
					<path
						id='Path_30'
						data-name='Path 30'
						d='M1237.3,642.275c-1.186,4.1-18.364,7.5-41.021,7.5s-42.3-2.251-42.3-6.552c0-3.8,19.647-5.749,42.3-5.749S1238.046,639.679,1237.3,642.275Z'
						transform='translate(-709.991 -161.687)'
						fill='#703c01'
					/>
					<path
						id='Path_31'
						data-name='Path 31'
						d='M1203.37,424.87c-3.955,14.477-12.615,27.46-18.146,41.5a99.811,99.811,0,0,0-6.349,48.383c3.752,31.092,22.574,58.822,22.7,90.32,10.3-22.807,19.948-50.424,22.042-74.92,3.084-36.128.8-45.944-20.263-105.284'
						transform='translate(-716.037 -108.635)'
						fill='#448933'
					/>
					<path
						id='Path_32'
						data-name='Path 32'
						d='M1208.822,429.305c-5.418,27.565-14.859,54.3-11.257,82.282,1.854,14.439,5.193,28.586,7.16,43.01a257.629,257.629,0,0,1,2.079,46.177c0,.8,1.351.8,1.426,0,2.9-29.156-4.233-57.1-8.585-85.344-4.555-29.524,5.081-56.826,9.681-86.057.045-.308-.428-.368-.488-.06Z'
						transform='translate(-720.67 -109.693)'
						fill='#449134'
					/>
					<g
						id='Group_8'
						data-name='Group 8'
						transform='translate(486.255 316.323)'
						opacity='0.5'
					>
						<path
							id='Path_33'
							data-name='Path 33'
							d='M1210.916,425.455c3.122,13.554,1.5,27.2,1.1,41.088-.405,14.844,1.561,29.449,3.04,44.09,3.062,30.139.623,60.135-4.743,90.312-.157.863,1.193,1.028,1.351.165,5.546-30.379,8.038-60.323,4.893-90.672-1.553-15.047-3.587-30.072-3.1-45.329.435-13.569,1.891-26.859-1.9-39.91-.128-.42-.75-.15-.646.255Z'
							transform='translate(-1210.303 -424.988)'
							fill='#449134'
						/>
					</g>
					<path
						id='Path_34'
						data-name='Path 34'
						d='M1213.356,434.83c5.253,27.242,10.934,54.649,11.257,82.732.323,28.946-6.522,57.2-14.432,85.284-.24.878,1.253,1.268,1.5.4,8.653-27.017,14.619-55.272,14.477-83.228-.15-29.043-6.079-57.366-12.3-85.329-.068-.285-.578-.15-.525.143Z'
						transform='translate(-724.011 -111.046)'
						fill='#449134'
					/>
					<path
						id='Path_35'
						data-name='Path 35'
						d='M1205.06,425.766c-9.921,29.966-21.509,57.786-18.011,89.306,3.3,29.786,17.171,57.036,16.593,87.468,0,.668,1.133.66,1.186,0,2.251-28.608-11.415-54.694-15.542-82.244a123.313,123.313,0,0,1,2.251-49.6c3.895-15.107,9.666-29.771,13.861-44.818.06-.21-.3-.308-.368-.1Z'
						transform='translate(-718.086 -108.834)'
						fill='#449134'
					/>
					<path
						id='Path_36'
						data-name='Path 36'
						d='M1286.358,470.42c-6.417,21.644-26.694,35.6-41.359,52.766a117.291,117.291,0,0,0-26.169,55.347c-2.116,11.9-2.379,24.09-5.111,35.858,11.91-19.332,34.312-29.569,49.148-46.754,18.762-21.764,33.456-76.886,23.49-97.216'
						transform='translate(-724.901 -120.001)'
						fill='#55aa43'
					/>
					<path
						id='Path_37'
						data-name='Path 37'
						d='M1286.1,471c3.407,12.758-5.8,26.109-11.047,37.156-6.529,13.741-12.826,26.9-21.876,39.227-15.512,21.118-30.9,42.507-40.12,67.265-.278.75.833,1.306,1.118.555,10.7-28.518,30.274-50.747,46.755-75.8,8.405-12.758,14.214-27.415,20.45-41.344,3.752-8.308,8.788-18.011,5.028-27.137a.165.165,0,0,0-.308.105Z'
						transform='translate(-724.724 -120.105)'
						fill='#449134'
						opacity='0.5'
					/>
					<g
						id='Group_9'
						data-name='Group 9'
						transform='translate(487.983 351.199)'
						opacity='0.5'
					>
						<path
							id='Path_38'
							data-name='Path 38'
							d='M1286.11,471.73c2.364,13.606.961,27.077-3,40.225-4.188,13.929-9.989,29.321-17.621,41.794-7.242,11.85-19.76,20.458-29.178,30.522a201.532,201.532,0,0,0-23.572,30.424c-.585.938.953,1.689,1.5.751a207.753,207.753,0,0,1,28.893-35.8c9.951-10,20.713-18.244,27.017-31.175,11.167-22.9,23.542-51.032,16.4-76.848-.075-.27-.525-.188-.48.09Z'
							transform='translate(-1212.606 -471.46)'
							fill='#449134'
						/>
					</g>
					<g
						id='Group_10'
						data-name='Group 10'
						transform='translate(489.006 350.533)'
						opacity='0.5'
					>
						<path
							id='Path_39'
							data-name='Path 39'
							d='M1286.188,470.893c.863,11.4-8.255,24.405-13.854,33.689-7.415,12.225-15.475,24.015-23.347,35.955-14.672,22.221-32.781,43.527-35.01,71.235a.481.481,0,0,0,.946.18c2.161-6.754,3.385-13.824,5.524-20.615,2.949-9.358,7.062-16.51,12.915-24.315,8.15-10.912,15.1-22.747,22.634-34.086,8.2-12.345,16.653-24.7,23.64-37.8,3.512-6.589,9.073-16.548,7.145-24.36C1286.7,470.435,1286.165,470.556,1286.188,470.893Z'
							transform='translate(-1213.969 -470.572)'
							fill='#449134'
						/>
					</g>
					<g
						id='Group_11'
						data-name='Group 11'
						transform='translate(488.361 350.313)'
						opacity='0.5'
					>
						<path
							id='Path_40'
							data-name='Path 40'
							d='M1285.748,470.708c-2.109,14.777-13.374,28.008-22.3,39.34-9.486,12.008-19.332,23.73-28.21,36.225-7.137,10.041-11.2,21.268-15.175,32.811-3.85,11.182-6.987,23.9-6.949,35.737,0,.623.908.615,1.051.06,3.182-12.428,3.888-25.021,8.255-37.238,1.989-5.584,3.752-11.317,6.214-16.728,3.655-8.158,9.118-15.175,14.432-22.3,8.736-11.7,18.334-22.732,27.017-34.477,7.279-9.854,15.055-20.8,16.765-33.231.1-.683-.961-.9-1.058-.2Z'
							transform='translate(-1213.11 -470.279)'
							fill='#449134'
						/>
					</g>
					<path
						id='Path_41'
						data-name='Path 41'
						d='M1178.176,635.584c-5.749-26.267-22.034-67.82-45.479-81.051a190.365,190.365,0,0,0-21.171-9.756c-4.766-1.966-16.338-2.537-21.486-2.687,8.188,7.31,12.008,18.319,19.107,26.694,10.972,12.946,28.451,18.252,41.561,29.021,12.105,9.936,19.925,24.015,27.467,37.741'
						transform='translate(-694.039 -137.885)'
						fill='#448933'
					/>
					<path
						id='Path_42'
						data-name='Path 42'
						d='M1089.925,542.113c11.677,2.3,22.619,6,32.668,12.533,8.255,5.328,15.632,12.368,22.649,19.2,16.443,16.038,24.563,38.882,31.422,60.226.24.75,1.336.248,1.1-.48-7.325-22.252-15.948-45.681-33.494-62.057-15.565-14.529-32.27-27.707-54.282-30.019a.293.293,0,0,0-.06.578Z'
						transform='translate(-693.954 -137.743)'
						fill='#449134'
					/>
					<path
						id='Path_43'
						data-name='Path 43'
						d='M1089.811,542.06c19.257,11.43,40.751,21.3,56,38.207,14.649,16.225,23.865,35.5,31.52,55.738.27.75,1.373.233,1.088-.488-7.805-20.165-17.336-39.625-31.955-55.805-15.257-16.893-36.728-27.287-56.361-38.094-.3-.165-.623.263-.315.443Z'
						transform='translate(-693.945 -137.758)'
						fill='#449134'
					/>
					<g
						id='Group_12'
						data-name='Group 12'
						transform='translate(395.737 403.78)'
						opacity='0.5'
					>
						<path
							id='Path_44'
							data-name='Path 44'
							d='M1089.742,542.016a151.02,151.02,0,0,0,18.762,20.773c7.745,7.024,16.863,12.285,25.231,18.514,18.987,14.154,31.677,31.52,42.829,52.218.368.69,1.5.18,1.111-.5-10.552-18.409-21.359-35.062-38.124-48.466-8.255-6.589-17.328-12.008-25.621-18.537-9.006-7.077-16.083-15.94-23.707-24.39a.3.3,0,1,0-.465.383Z'
							transform='translate(-1089.689 -541.524)'
							fill='#449134'
						/>
					</g>
					<path
						id='Path_45'
						data-name='Path 45'
						d='M1089.786,542.014c6.469,7.685,15.28,12.338,23.662,17.606a158.348,158.348,0,0,1,27.145,21.561,171.779,171.779,0,0,1,36.706,54.86.677.677,0,1,0,1.238-.548,174.218,174.218,0,0,0-35.565-53.554,154.969,154.969,0,0,0-23.58-19.692c-9.824-6.657-21.216-11.542-29.2-20.563a.263.263,0,0,0-.405.33Z'
						transform='translate(-693.965 -137.764)'
						fill='#449134'
					/>
					<path
						id='Path_46'
						data-name='Path 46'
						d='M1138.33,468.48c7.362,9.006,6.409,21.9,7.332,33.494,1.141,14.259,5.666,28.023,10.312,41.554a196,196,0,0,0,9.178,23.265c3.978,8.023,9.006,15.482,13.163,23.392,4.57,8.675,8.113,17.846,11.647,27.017,9.5-28.946,14.477-54.034-6.619-88.2-4.593-7.43-8.6-15.5-13.366-22.814-3.227-4.953-5.561-10.6-9.058-15.362-6.672-9.066-11.34-15.445-22.589-22.334'
						transform='translate(-706.089 -119.517)'
						fill='#6aba56'
					/>
					<path
						id='Path_47'
						data-name='Path 47'
						d='M1140.093,470.689c9.471,9.006,12.63,24.42,15.812,36.631s5.944,24.766,10.206,36.773c8.2,23.077,19.512,45.178,23.077,69.644.12.8,1.328.488,1.223-.3-3.6-25.906-15.91-49.134-24.345-73.591-4.285-12.428-7.032-25.253-10.634-37.876-3.054-10.7-6.424-23.9-15.01-31.6-.24-.218-.6.12-.368.345Z'
						transform='translate(-706.5 -119.971)'
						fill='#55aa43'
					/>
					<g
						id='Group_13'
						data-name='Group 13'
						transform='translate(437.095 354.199)'
						opacity='0.5'
					>
						<path
							id='Path_48'
							data-name='Path 48'
							d='M1144.859,475.865c16.713,19.385,18.762,45.464,28.18,68.293,4.75,11.5,10.994,22.229,14.334,34.3a108.289,108.289,0,0,1,3.242,38.094c-.068.826,1.186.826,1.276,0a102.064,102.064,0,0,0-2.454-36.48c-3.1-12.285-9.238-23.122-14.259-34.664-10.109-23.317-12.158-50.492-30.019-69.876-.18-.2-.488.083-.308.285Z'
							transform='translate(-1144.797 -475.457)'
							fill='#55aa43'
						/>
					</g>
					<path
						id='Path_49'
						data-name='Path 49'
						d='M1140.118,470.739c8.158,6.552,14.792,15.813,20.826,24.285,7.325,10.282,12.405,22.267,17.5,33.771,5.869,13.253,11.054,27.017,13.3,41.381,2.379,15.257-.45,29.966-2.529,45.066-.15,1.066,1.538,1.088,1.681,0,1.981-15.265,4.766-30.064,2.342-45.464-2.251-14.507-7.61-28.315-13.651-41.629-9.471-20.893-20.5-43.482-39.145-57.952-.315-.248-.63.278-.323.525Z'
						transform='translate(-706.503 -119.93)'
						fill='#55aa43'
					/>
					<g
						id='Group_14'
						data-name='Group 14'
						transform='translate(433.556 350.308)'
						opacity='0.5'
					>
						<path
							id='Path_50'
							data-name='Path 50'
							d='M1140.1,470.616c7.009,10.034,8.931,24.255,10.439,36.18,1.246,9.854,2.071,19.475,4.69,29.126a217.966,217.966,0,0,0,15.01,38.762c6.507,13.306,15.64,25.666,18.642,40.4.18.871,1.5.533,1.336-.338-2.341-13.7-10.672-25.141-16.848-37.306-7.22-14.206-13.464-29.208-17.374-44.683-2.417-9.569-2.949-19.257-4.42-28.961-1.711-11.257-3.752-24.3-11.077-33.449-.165-.2-.525.06-.375.27Z'
							transform='translate(-1140.082 -470.273)'
							fill='#55aa43'
						/>
					</g>
					<path
						id='Path_51'
						data-name='Path 51'
						d='M1152.49,644.32s42.026,13.126,84.436-.45v21.344H1152.49Z'
						transform='translate(-709.622 -163.282)'
						fill='#ff9500'
					/>
					<path
						id='Path_52'
						data-name='Path 52'
						d='M1153.808,645.031a63.485,63.485,0,0,0,14.161,3.6,150.286,150.286,0,0,0,17.876,1.644c6.349.233,12.713.173,19.055-.2a160.094,160.094,0,0,0,17.644-1.929,61.016,61.016,0,0,0,13.508-3.587c.42-.173.826-.39,1.238-.578.263-.113,0-.5-.218-.375a40.26,40.26,0,0,1-5.793,1.914c-2.364.638-4.758,1.148-7.16,1.591A149.156,149.156,0,0,1,1207,649.151q-9.463.615-18.957.39a169.618,169.618,0,0,1-18.011-1.328,79.49,79.49,0,0,1-14.717-3.167c-.48-.165-.953-.33-1.418-.51-.315-.113-.435.375-.135.5Z'
						transform='translate(-709.896 -163.212)'
						fill='#af6935'
					/>
					<path
						id='Path_53'
						data-name='Path 53'
						d='M1181.4,804.514a34.242,34.242,0,0,0,7.565,1.981,76.452,76.452,0,0,0,9.253.886,89.341,89.341,0,0,0,19.04-1.156,26.732,26.732,0,0,0,7.8-2.251.167.167,0,0,0-.128-.308,58.063,58.063,0,0,1-15.76,3,94.661,94.661,0,0,1-19.175-.5,39.926,39.926,0,0,1-8.525-1.959c-.24-.09-.33.278-.105.368Z'
						transform='translate(-716.795 -203.152)'
						fill='#af6935'
					/>
					<path
						id='Path_54'
						data-name='Path 54'
						d='M736.66,365.621l-3.97-2.071,1.118-34.739,11.745,5.118,6.191,15.475Z'
						transform='translate(-604.871 -84.666)'
						fill='#aa8d7e'
						opacity='0.32'
					/>
					<rect
						id='Rectangle_10'
						data-name='Rectangle 10'
						width='54.537'
						height='6.867'
						transform='translate(131.789 274.088)'
						fill='#fff'
					/>
					<rect
						id='Rectangle_11'
						data-name='Rectangle 11'
						width='54.537'
						height='6.867'
						transform='translate(131.789 251.011)'
						fill='#fff'
					/>
					<rect
						id='Rectangle_12'
						data-name='Rectangle 12'
						width='59.175'
						height='6.867'
						transform='translate(128.938 244.144)'
						fill='#aa8d7e'
					/>
					<rect
						id='Rectangle_13'
						data-name='Rectangle 13'
						width='53.186'
						height='6.867'
						transform='translate(133.14 257.87)'
						fill='#e0784b'
					/>
					<rect
						id='Rectangle_14'
						data-name='Rectangle 14'
						width='50.117'
						height='9.351'
						transform='translate(135.677 264.737)'
						fill='#726865'
					/>
					<line
						id='Line_2'
						data-name='Line 2'
						x2='5.996'
						transform='translate(141.358 269.412)'
						fill='none'
						stroke='#aaa6a5'
						strokeWidth='1.69'
					/>
					<line
						id='Line_3'
						data-name='Line 3'
						x2='29.351'
						transform='translate(150.641 269.412)'
						fill='none'
						stroke='#aaa6a5'
						strokeWidth='1.69'
					/>
					<line
						id='Line_4'
						data-name='Line 4'
						x2='50.619'
						transform='translate(133.575 277.518)'
						fill='none'
						stroke='#c6c4c4'
						strokeWidth='1.69'
					/>
					<line
						id='Line_5'
						data-name='Line 5'
						x2='42.574'
						transform='translate(137.418 261.307)'
						fill='none'
						stroke='#e89274'
						strokeWidth='1.69'
					/>
					<line
						id='Line_6'
						data-name='Line 6'
						x2='25.494'
						transform='translate(158.701 254.44)'
						fill='none'
						stroke='#c6c4c4'
						strokeWidth='1.69'
					/>
					<line
						id='Line_7'
						data-name='Line 7'
						x2='52.406'
						transform='translate(131.789 247.574)'
						fill='none'
						stroke='#bfa599'
						strokeWidth='1.69'
					/>
					<path
						id='Path_55'
						data-name='Path 55'
						d='M720.062,466.664l-2.612-1.036,2.612-56.908,3.73,39.37Z'
						transform='translate(-601.068 -104.606)'
						fill='#aa8d7e'
						opacity='0.32'
					/>
					<rect
						id='Rectangle_15'
						data-name='Rectangle 15'
						width='49.666'
						height='57.944'
						transform='translate(118.994 304.114)'
						fill='#e0784b'
					/>
					<rect
						id='Rectangle_16'
						data-name='Rectangle 16'
						width='42.192'
						height='50.192'
						transform='translate(122.724 307.979)'
						fill='#c6865c'
					/>
					<rect
						id='Rectangle_17'
						data-name='Rectangle 17'
						width='40.225'
						height='48.361'
						transform='translate(123.707 308.842)'
						fill='#f4f1ef'
					/>
					<rect
						id='Rectangle_18'
						data-name='Rectangle 18'
						width='30.987'
						height='39.002'
						transform='translate(128.33 313.255)'
						fill='#fff'
					/>
					<path
						id='Path_56'
						data-name='Path 56'
						d='M754.4,448.707c-.285-.113-.645.75-.675.8a3.3,3.3,0,0,1,.458-1.081c-.338.15-.871,1.4-.856,1.171s.638-1.268.593-1.6-.3-.443-.7-.39c-.518,0-1.321,1.5-1.583,2.049a13.047,13.047,0,0,0-.383,1.306c-.12.518-.21,1.036-.285,1.561h0a4.638,4.638,0,0,1,.751-2.251h0c0,.06-.135,1.216-.225,2.454a20.807,20.807,0,0,0-.09,2.664,8.911,8.911,0,0,1,.48-2.679,10.858,10.858,0,0,0,.18,3.107c.293-2.064.713-3.8.713-3.8l-.18,3.557.63-2.364a15,15,0,0,1-.173,2.372c.165-.54.3-1,.413-1.411a21.4,21.4,0,0,0,.4-2.394.052.052,0,0,1,0-.038v-.315a.249.249,0,0,0,0-.075,7.388,7.388,0,0,1,.5-2.109C754.645,448.865,754.682,448.932,754.4,448.707Zm-3.677,6.5h0l-.068.045Zm10.424-10.739a5.683,5.683,0,0,0-.863-.833h0c-.33-.278-.653-.51-.84-.7s-.488-.608-.42-.81h0a.2.2,0,0,1,.158-.083h0a1.567,1.567,0,0,1,.473.09h0l.218.075a2.435,2.435,0,0,1,.645.488l.06.06.128.128c.248.24.435.36.668,0l.045-.075a1.764,1.764,0,0,0-1.133-2.664c-.578-.158-.991-.248-1.3-.308h0a1.733,1.733,0,0,1-.953-.36c-.345-.33-.443-.886.4-.788a3.882,3.882,0,0,1,.818.225h0c.75.278,1.546.683,1.831.555.4-.18.8-2.537-.675-4.585-.645-.75-1.381-1.921-4.3-1.351-.661.173-1.268.36-1.764.488h0c-.7.2-1.171.27-1.276.053-.173-.368-.12-.841.75-1.088l.66-.18c.968-.293,2.146-.75,1.5-1.148a5.884,5.884,0,0,0-5.929-.323,4.834,4.834,0,0,0-.57.353h0l-.39.3h0a7.05,7.05,0,0,0-.548.5h0a7.851,7.851,0,0,0-1.614,2.679h0a14.258,14.258,0,0,0-.66,2.462v.33h0v.113a.1.1,0,0,1,0,.045c-.068.315-.39.953-1.921.908h-.473a7.933,7.933,0,0,0-4.5.916,4.5,4.5,0,0,0-1.178,1.073c-.225.293-.443.585-.638.886h0a8.114,8.114,0,0,0-1.126,6.642c.263,1.156.923,1.681,2.469.5,1.358-.946,1.891-1.388,2.251-1.583h0a.826.826,0,0,1,.413-.128c.338,0,.413.233.045.608h0a2.876,2.876,0,0,1-.458.353c-.885.563-3.257,2.762-1.9,3.752l.135.1.135.1c1.456,1.043,4.24,2.7,6.056,2.8h.668a.871.871,0,0,0,.413-.165l.075-.068.06-.075.06-.09a.189.189,0,0,1,0-.053v-.045a3.542,3.542,0,0,0,.15-.413,1.6,1.6,0,0,1,.09-.278h0c.173-.518.473-1.441.841-2.364h0c.06-.15.12-.3.188-.45.5-1.163,1.073-2.206,1.561-2.251h.15c.233.038.353.24.39.54v.053a3.32,3.32,0,0,1-.263,1.328.664.664,0,0,0-.038.113l-.068.158a6.261,6.261,0,0,1-.3.593,2.585,2.585,0,0,1-.15.24,1.757,1.757,0,0,1-.128.2,5.316,5.316,0,0,1-.443.555,8.512,8.512,0,0,0-.66.811,3.068,3.068,0,0,0-.5.976.053.053,0,0,0,0,.038c-.157.653.135,1.178,1.133,1.5l.128.038c1.981.518,4.323,1.358,4.668-.2a3.247,3.247,0,0,1,.105-.51v-.233a.411.411,0,0,0,0-.06h0v-.075c.075-.533.12-1.058.165-1.591a1.1,1.1,0,0,0,0-.15v-.315a.56.56,0,0,1,0-.113v-.736h0a2.906,2.906,0,0,1,.1-.63.352.352,0,0,1,.105-.15c.15-.12.353.075.428.323a6.947,6.947,0,0,1,0,2.049v1.861a.249.249,0,0,1,0,.075c0,.645,0,1.366.683,1.629a12.253,12.253,0,0,0,2.071.435,5.914,5.914,0,0,0,2.034.27,1.734,1.734,0,0,0,1.126-.938,8.258,8.258,0,0,0,.525-2.777,2.56,2.56,0,0,0-.338-1.719,1.129,1.129,0,0,0-.075-.1,21.761,21.761,0,0,0-3.325-3.332c-.5-.375.518-.143,1.426.57.3.233.683.578,1.081.9.833.675,1.726,1.291,2.026.705.443-.833.368-5.321-.593-6.642Zm-10.507,3.122a.315.315,0,0,1-.12,0h0a.337.337,0,0,1-.173-.165,1.2,1.2,0,0,1,.278-1.178,5.185,5.185,0,0,0,.413-.4,1.292,1.292,0,0,1,.248-.248l.12-.075a.428.428,0,0,1,.233-.045h0a.465.465,0,0,1,.315.2c.128.158,0,.458,0,.623a1.682,1.682,0,0,1-.173.48l-.038.105a1.1,1.1,0,0,1-.24.54.608.608,0,0,1-.353.173,1.208,1.208,0,0,1-.473,0h0Zm5.471-3.3a4.4,4.4,0,0,1-1.163-.27c-.45-.173-.525-.713-.923-.961a.5.5,0,0,0-.2-.06,3.076,3.076,0,0,0-.473,0c-.368,0-.75,0-.916-.18a.293.293,0,0,1-.06-.105.315.315,0,0,1,0-.18.136.136,0,0,1,.045-.1h0a1.036,1.036,0,0,1,.661-.1c.383,0,.75.1,1.1.113h.893a7.411,7.411,0,0,0,1.073.165,2.544,2.544,0,0,1,1.366.48c.188.135.856.578.856.916a.255.255,0,0,1-.083.188.608.608,0,0,1-.36.113,4.359,4.359,0,0,0-.683.037,8.1,8.1,0,0,1-1.118-.06Zm-4.015-7.8a1.693,1.693,0,0,1-.218.323,3,3,0,0,1-.931.63,2.249,2.249,0,0,1-.473.135,1.185,1.185,0,0,1-.75-.083.248.248,0,0,1-.075-.315c.105-.3.51-.45.705-.683a1.4,1.4,0,0,0,.218-.405v-.053a1.674,1.674,0,0,1,.615-.863,1.7,1.7,0,0,1,.713-.143c.825-.128.525.886.21,1.456ZM740.956,445.5a.8.8,0,0,1,.113-.315c.4-.675,1.118-.826,1.711-1.246a4.24,4.24,0,0,0,.345-.27h0a2.514,2.514,0,0,1,1.313-.75,6.138,6.138,0,0,1,.8-.053c.428,0,.818.143.856.6h0a1.56,1.56,0,0,1,0,.27,1.2,1.2,0,0,1-.7.931l-.09.045-.248.128c-.6.33-1.163.75-1.741,1.1a1.748,1.748,0,0,1-1.5.308c-.3-.1-.871-.42-.841-.78Zm10.229,8.9v.068a.335.335,0,0,0,0,.075v.15a1.182,1.182,0,0,1-.09.2.686.686,0,0,1-.083.12l-.052.068-.052.053-.06.053-.068.053-.068.045-.083.06h0l-.263.128h0a2.086,2.086,0,0,1-.946.15c-.518-.053-.518-1.186.75-2.7a1.5,1.5,0,0,1,.218-.218h0l.12-.09.075-.045h0a.338.338,0,0,1,.4,0h0a.675.675,0,0,1,.173.375,3.61,3.61,0,0,1,.045.75q0,.169,0,.338a2.181,2.181,0,0,1,0,.338Z'
						transform='translate(-605.745 -110.086)'
						fill='#58a13f'
					/>
					<path
						id='Path_57'
						data-name='Path 57'
						d='M753.87,432a2.454,2.454,0,0,1-.39.3Z'
						transform='translate(-610.058 -110.415)'
						fill='#8f9569'
					/>
					<path
						id='Path_58'
						data-name='Path 58'
						d='M737.92,445.81Z'
						transform='translate(-606.176 -113.861)'
						fill='#142f32'
					/>
					<path
						id='Path_59'
						data-name='Path 59'
						d='M741.023,451.087h0c-.345.188-.878.63-2.252,1.583-1.546,1.186-2.206.66-2.469-.5a8.228,8.228,0,0,1,1.126-6.642c-.113.18-.855,1.441.585.75l1.756-.78c-.923.488-2.071,1.216-2.252,1.876-.285,1.088,2.191-1.013,2.424-1.208-.248.24-2.867,2.8-3.182,3.242a9.849,9.849,0,0,1,2.522-1.779,4.083,4.083,0,0,0-1.861,2.161c1.5-1.5,4.053-4.5,6.109-5.186-5.253,5.193-4.435,3.962-5.253,6.469l2.019-2.154a11.916,11.916,0,0,0-1.869,2.642C738.366,452.13,740.888,451.139,741.023,451.087Z'
						transform='translate(-605.714 -113.561)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_60'
						data-name='Path 60'
						d='M742.6,449.486a.8.8,0,0,0-.113.315c0,.36.54.675.833.75-1.921-.39-.75-1.929,0-2.086a4.1,4.1,0,0,0,1.321-.525,4.248,4.248,0,0,1-.345.27C743.72,448.63,743,448.781,742.6,449.486Z'
						transform='translate(-607.263 -114.392)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_61'
						data-name='Path 61'
						d='M755.36,463.458a1.035,1.035,0,0,0,.15-.1v.608h0c-.038-.173-.068-.338-.09-.51Z'
						transform='translate(-610.527 -118.24)'
						fill='#8f9569'
					/>
					<path
						id='Path_62'
						data-name='Path 62'
						d='M750,463.03l.248-.33a.953.953,0,0,1-.248.33Z'
						transform='translate(-609.19 -118.075)'
						fill='#8f9569'
					/>
					<path
						id='Path_63'
						data-name='Path 63'
						d='M749.65,449.68h0v.045Z'
						transform='translate(-609.103 -114.826)'
						fill='#142f32'
					/>
					<path
						id='Path_64'
						data-name='Path 64'
						d='M747.488,457.987c1.073-1.156,1.2-1.3,1.223-1.313h0l-.841,2.364h0l-.09.278c-.248.75-.42.968-1.5.946-1.816-.1-4.6-1.756-6.056-2.8l-.135-.1-.135-.1c-1.358-1.013,1.013-3.212,1.9-3.752a2.491,2.491,0,0,0,.458-.345c-.24.24-1.591,1.621-1.388,2.439.225.585.338.841.878.585s1.7-3.092,2.792-3.992-1.839,3.632-2.026,4.278,1.4-1.786,1.4-1.786l-.923,2.552c.09-.173,2.889-5.756,3.527-6.244-1.313,2.574-2.514,6.447-2.2,6.927s2.034-3.895,2.191-4.285l-1.426,4.345,1.846-3.272s-.976,2.619-1.2,3.069a16.678,16.678,0,0,0,2.852-4.12,32.03,32.03,0,0,1-1.666,3.94,25.183,25.183,0,0,0,1.779-2.612A31.231,31.231,0,0,0,747.488,457.987Z'
						transform='translate(-606.581 -115.156)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_65'
						data-name='Path 65'
						d='M751.48,447.93l-.42.36C751.113,448.245,751.263,448.1,751.48,447.93Z'
						transform='translate(-609.455 -114.39)'
						fill='#214749'
					/>
					<path
						id='Path_66'
						data-name='Path 66'
						d='M757.784,458.052h0l-.1-.488a23.251,23.251,0,0,1-.443,2.822c-.113.413-.248.878-.413,1.411a15.754,15.754,0,0,0,.165-2.371l-.623,2.364.18-3.557s-.42,1.734-.713,3.8a10.868,10.868,0,0,1-.18-3.107,8.91,8.91,0,0,0-.48,2.679,45.5,45.5,0,0,1,.315-5.118,4.638,4.638,0,0,0-.75,2.251.676.676,0,0,1,.173.375,3.6,3.6,0,0,1,.045.75q0,.169,0,.338a1.283,1.283,0,0,1-.63,1.321,1.809,1.809,0,0,1-.27.135h0l-.946.15c-.518-.053-.518-1.186.75-2.7a1.5,1.5,0,0,1,.218-.218h0c.083-.12.15-.21.2-.21a1.5,1.5,0,0,0-1.276.871,5.385,5.385,0,0,1-.893,1.358.3.3,0,0,1-.2.105.323.323,0,0,1-.278-.225,1.238,1.238,0,0,1,.465-1.328,13.006,13.006,0,0,0,1.171-.931,3.974,3.974,0,0,0,.63-2.874v.06a4.024,4.024,0,0,1-.263,1.328.655.655,0,0,0-.038.113l-.068.158a6.26,6.26,0,0,1-.3.593,2.582,2.582,0,0,1-.15.24,1.762,1.762,0,0,1-.128.2,7.933,7.933,0,0,1-.563.75c-.18.21-.368.413-.54.63a2.582,2.582,0,0,0-.435.75,1.247,1.247,0,0,0-.06.225h0c-.143.75.405,1.253,1.133,1.5l.128.038c1.981.525,4.323,1.366,4.668-.2a3.24,3.24,0,0,1,.105-.51v-.233a.233.233,0,0,1,0-.06h0c.045-.375.135-1.358.21-2.131h0v-.113a1.636,1.636,0,0,1,.045-.48c.045-.143,0-.1,0-.15a.233.233,0,0,0,0-.075.209.209,0,0,0,0-.068h0Z'
						transform='translate(-609.522 -116.316)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_67'
						data-name='Path 67'
						d='M760.749,461.74a.948.948,0,0,0,0,.15v-.143Z'
						transform='translate(-611.871 -117.836)'
						fill='#214749'
					/>
					<g
						id='Group_15'
						data-name='Group 15'
						transform='translate(142.859 320.59)'
						opacity='0.8'
					>
						<path
							id='Path_68'
							data-name='Path 68'
							d='M758.681,432.795c-.24,0-.48.045-.75.053a.17.17,0,0,1,.105-.143l.938-.42a10.283,10.283,0,0,0-3.37,1.133,1.816,1.816,0,0,1,.75-.57l2.394-1.246a.137.137,0,0,0,.113-.158,4.945,4.945,0,0,0-2,.375,11.956,11.956,0,0,0-1.824.938,4.863,4.863,0,0,1,2.086-1.711,7.224,7.224,0,0,0-2.071.886c.233-.5.825-.683,1.253-1.021a6.447,6.447,0,0,0-2.912,1.208,3.087,3.087,0,0,1-.668.443.336.336,0,0,0,0-.083,7.007,7.007,0,0,1,.548-.5h0l.39-.3h0a4.842,4.842,0,0,1,.57-.353,5.884,5.884,0,0,1,5.929.323C760.828,432.059,759.687,432.5,758.681,432.795Z'
							transform='translate(-752.73 -430.674)'
							fill='#3b8233'
						/>
					</g>
					<path
						id='Path_69'
						data-name='Path 69'
						d='M763.781,447.762c0-.338-.668-.75-.856-.916a2.544,2.544,0,0,0-1.366-.48,7.419,7.419,0,0,1-1.073-.165h-.893a10.57,10.57,0,0,1-1.1-.113c-.188,0-.518-.038-.66.1.5-.751,2.717-.143,3-.105a14.479,14.479,0,0,1,1.726.285,1.4,1.4,0,0,1,1.223,1.4Z'
						transform='translate(-611.144 -113.861)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<g
						id='Group_16'
						data-name='Group 16'
						transform='translate(132.007 321.218)'
						opacity='0.5'
					>
						<path
							id='Path_70'
							data-name='Path 70'
							d='M745.041,442.385s-4.645-.585-6.717,2.537c-.233.645,1.786-.5,2.6-.75s2.439-.668,2.927-.75S746.234,442.941,745.041,442.385Z'
							transform='translate(-738.279 -434.213)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_71'
							data-name='Path 71'
							d='M743.133,444.606a9.477,9.477,0,0,0-4.863,2.649c3.812-2.011,3.062-1.951,3.692-2.041a11.737,11.737,0,0,0-2.341,2.416,40.62,40.62,0,0,1,3.212-2.7C743.133,444.794,743.133,444.606,743.133,444.606Z'
							transform='translate(-738.27 -434.775)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_72'
							data-name='Path 72'
							d='M751.678,447.51a13.269,13.269,0,0,0-4.878,7.43c1.216-2.154,1.809-3.295,1.809-3.295l-1.088,2.634,1.246-2.469-.878,3,1.433-2.739-.75,2.882a34.516,34.516,0,0,0,2.206-3.437c.6-1.216-.218.788-.218.788l1.936-3.52a11.17,11.17,0,0,0-1.328,1.674l1.328-2.342-1.081,1.028,1.381-1.621s-1.5.24-2.522,2.642A5.892,5.892,0,0,1,751.678,447.51Z'
							transform='translate(-740.398 -435.502)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_73'
							data-name='Path 73'
							d='M748.874,444.544c-.128,0-2.086-.593-4.653,1.5l1.5-.623-2.7,1.756a4.706,4.706,0,0,0,2.109-.751c.946-.668,1.5-.293,2.327-.615a9.5,9.5,0,0,0,1.4-.668,7.305,7.305,0,0,1-1.5.3,11.433,11.433,0,0,1,1.779-.585l-1.283.09Z'
							transform='translate(-739.455 -434.743)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_74'
							data-name='Path 74'
							d='M746.8,450.39a12.892,12.892,0,0,0-3.295,3.632,10.5,10.5,0,0,1-1.2,1.606l1.043-1.914-1.043,1.1S744.191,450.623,746.8,450.39Z'
							transform='translate(-739.276 -436.221)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_75'
							data-name='Path 75'
							d='M758.3,453.619l-.135.105a5.877,5.877,0,0,0-1.366,2.184,5.735,5.735,0,0,0-.285,1.373,5.636,5.636,0,0,0,0,.8,1.484,1.484,0,0,0,.038.405,1.657,1.657,0,0,1,.075.413,18.007,18.007,0,0,1,.938-2.514,7.969,7.969,0,0,0-.443,3.9c.383-2.619.638-4.3,1.058-4.908a3.706,3.706,0,0,0,.608-1.306c0-.143.083-.368,0-.48S758.444,453.537,758.3,453.619Z'
							transform='translate(-742.819 -437.004)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_76'
							data-name='Path 76'
							d='M759.3,456.24a5.253,5.253,0,0,0-.841,3.317A12.761,12.761,0,0,0,759.3,456.24Z'
							transform='translate(-743.304 -437.681)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_77'
							data-name='Path 77'
							d='M763.967,459.94a16.582,16.582,0,0,0-.33,3.422C763.817,463.94,764.515,463.16,763.967,459.94Z'
							transform='translate(-744.59 -438.604)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_78'
							data-name='Path 78'
							d='M764.78,460.941s0,3.047.751,2.589c.368-.33-.585-2.679-.585-2.679s1.193,2.251,1.193,2.094-.668-2.094-.668-2.094l1.569,1.358-1.118-1.914,1.4.961-1.4-1.5.931.488a3.026,3.026,0,0,0-2.732-.968v.48Z'
							transform='translate(-744.72 -438.419)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_79'
							data-name='Path 79'
							d='M754.583,431.645s-3.332,1.441-3.978,4.015a9.664,9.664,0,0,0-.285,1.5,4.668,4.668,0,0,1,1.066-2.251,7.091,7.091,0,0,0-.7,1.5,6.56,6.56,0,0,1,1.088-1.5c-.24.428-.63,1.373-.63,1.373a8.542,8.542,0,0,1,1.171-1.5c-.165.428-.826,1.884-.826,1.884a14.263,14.263,0,0,1,1.591-2.537c.548-.473,1.261-.968,1.261-.968a1.726,1.726,0,0,0-.833.36c.338-.293,1.614-1.456,1.614-1.456s-1.306.916-1.614,1.118a9.758,9.758,0,0,1,2.311-1.674,6.921,6.921,0,0,0-2.161,1.058Z'
							transform='translate(-741.277 -431.51)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_80'
							data-name='Path 80'
							d='M764.471,439.468l-.135-.045a6.644,6.644,0,0,0-7.407,3c-.308.608.533.1,2-1.066a9.473,9.473,0,0,1,5.493-1.929Z'
							transform='translate(-742.91 -433.434)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_81'
							data-name='Path 81'
							d='M763.275,441.111c-.083,0-1.5-.4-3.685,1.861a7.293,7.293,0,0,0,3.6-1.861Z'
							transform='translate(-743.59 -433.899)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_82'
							data-name='Path 82'
							d='M762.724,435.792s-3.212-.278-4.345,1.066,2.041,0,2.041,0S763.369,436.115,762.724,435.792Z'
							transform='translate(-743.227 -432.573)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_83'
							data-name='Path 83'
							d='M759.6,444.605s4.353-2.672,7.407,0a6.461,6.461,0,0,0-2.251-.585,14.35,14.35,0,0,1,2.041,1.148A9.332,9.332,0,0,0,759.6,444.605Z'
							transform='translate(-743.593 -434.481)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_84'
							data-name='Path 84'
							d='M761.75,449.726a8.668,8.668,0,0,1,3.347.841c1.5.75,2.326.75,2.6.188S764.7,449.629,761.75,449.726Z'
							transform='translate(-744.129 -436.053)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_85'
							data-name='Path 85'
							d='M761.64,451.8a8.5,8.5,0,0,1,6.176,2.169,22.038,22.038,0,0,0-2.454-1.193s2.724,1.238,2.732,2.026-1.351.608-3.475-1.2a13.654,13.654,0,0,0-2.9-.75l1.959-.105A4.09,4.09,0,0,0,761.64,451.8Z'
							transform='translate(-744.102 -436.568)'
							fill='#9fce55'
							opacity='0.58'
						/>
						<path
							id='Path_86'
							data-name='Path 86'
							d='M763.939,456.55a6.177,6.177,0,0,1,2.477,1.111c.75.75.585.75-.413.165a11.154,11.154,0,0,0-1.989-.9C763.826,456.828,763.579,456.565,763.939,456.55Z'
							transform='translate(-744.629 -437.758)'
							fill='#9fce55'
							opacity='0.58'
						/>
					</g>
					<path
						id='Path_87'
						data-name='Path 87'
						d='M755.27,451.228a1.216,1.216,0,0,0-.278,1.186.369.369,0,0,0,.173.165h.12c-.87-.038-.518-1-.285-1.276a3.085,3.085,0,0,1,.66-.5A4.041,4.041,0,0,1,755.27,451.228Z'
						transform='translate(-610.37 -115.106)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_88'
						data-name='Path 88'
						d='M761.54,434.02Z'
						transform='translate(-612.07 -110.919)'
						fill='#466456'
					/>
					<path
						id='Path_89'
						data-name='Path 89'
						d='M767.147,440.356c-.285.128-1.088-.278-1.831-.555,1.5.443,1.328-.45.931-.63a4.736,4.736,0,0,0-2.732,0,3.647,3.647,0,0,1,2.139-.375c.36.038.8,0,.93-.405.24-.75-.8-.9-1.291-1.006-.345-.068-.683-.128-1.036-.18a7.293,7.293,0,0,1,1.876,0,10.864,10.864,0,0,0-3.55-.3,19.735,19.735,0,0,1,3.332-.4l-2.334-.218s2.379-.045,2-.248-3.415.045-3.325-.218,3.077-.4,2.484-.578a11.82,11.82,0,0,0-2.251-.143s.48-.075,1.5-.2a30.762,30.762,0,0,0-3.655,0c.5-.128,1.1-.315,1.764-.488,2.919-.57,3.655.615,4.3,1.351C767.95,437.82,767.545,440.176,767.147,440.356Z'
						transform='translate(-611.77 -110.981)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<g
						id='Group_17'
						data-name='Group 17'
						transform='translate(148.797 341.668)'
						opacity='0.8'
					>
						<path
							id='Path_90'
							data-name='Path 90'
							d='M767.11,460.929a8.254,8.254,0,0,1-.525,2.777,1.7,1.7,0,0,1-1.126.931,5.733,5.733,0,0,1-2.034-.263,12.255,12.255,0,0,1-2.071-.435c-.75-.263-.75-.983-.683-1.629a.254.254,0,0,0,0-.075v.585a1.3,1.3,0,0,0,.173.615.5.5,0,0,0,.563.21c.405-.165.308-3,.66-3.31,0,.405-.06,3-.053,3.407a2.577,2.577,0,0,1,.165-.615l.2-.75.405-1.5-.105,2.251a.516.516,0,0,0,0,.263.345.345,0,0,0,.54,0,.632.632,0,0,0,.128-.3c.15-.7.09-1.418.218-2.116a5.409,5.409,0,0,1,.113,1.208,1.561,1.561,0,0,0,.5,1.448.631.631,0,0,0,.563.113c.21-.09.173-.323.113-.51l-.428-1.313.683,1.156c.06.105.15.218.263.2s.172-.218.143-.368a13.762,13.762,0,0,0-.555-1.283.12.12,0,0,1,.2-.12,7.458,7.458,0,0,0,1,.893c.113-.083.06-.263,0-.39l-.323-.653a.143.143,0,0,1,.188-.2,2.4,2.4,0,0,0,.405.165c.24-.225-.826-1.021-.976-1.223.15,0,.976.6,1.111.638-.435-.353-.856-.75-1.261-1.118l.938.5c.105.053.248.105.323,0a.3.3,0,0,0,0-.18,2.252,2.252,0,0,0-.458-1.186,1.846,1.846,0,0,1,.563.458A2.581,2.581,0,0,1,767.11,460.929Z'
							transform='translate(-760.643 -458.76)'
							fill='#3b8233'
						/>
					</g>
					<path
						id='Path_91'
						data-name='Path 91'
						d='M760.457,453.1l.428.18A2.931,2.931,0,0,0,760.457,453.1Zm1.081-4.323c-.135-.053-.968-.368-1.794-.623a6.754,6.754,0,0,0-1.569-.36c-.81,0-1.006-.645-.39-.811a8.007,8.007,0,0,1,3.64.63h0a8.629,8.629,0,0,1,2.011,1.148,12.856,12.856,0,0,0-1.321-1.066l.608.293h0a1.179,1.179,0,0,0-.158-.18,4.442,4.442,0,0,0-1.163-.886,12.008,12.008,0,0,0-5-1.3,10,10,0,0,1,4.886-.233,5,5,0,0,0-1.636-.42,9.461,9.461,0,0,0-1.126-.037,12.626,12.626,0,0,0-2.379.285c-.473.12-.953.2-.848-.585,0-.278.413-.63.938-.991a3.069,3.069,0,0,0-.473,0,1.449,1.449,0,0,1-.465.18c-.968.15-1.013-.488-.848-.863.308-.69,2.169-1.561,3.1-1.876-1.5,0-2.949,1.231-3.467,1.448s3.595-3.325,4.833-3.79c-1.921-.1-5.2,4.308-5.343,3.227-.1-.75.751-1.914,1.4-2.7h0c.278-.338.525-.608.638-.75a10.445,10.445,0,0,0-1.5,1.246c-.585.525-1.141,1.021-1.261,1.088-.285.173-.623.113-.51-.345.458-1.4,2.792-3,4.24-3.752a8.1,8.1,0,0,0-4.405,3.115c-.3.353-.751.383-.788,0a3.219,3.219,0,0,1,.7-1.741.248.248,0,0,1-.075-.315c.105-.3.51-.45.705-.683a1.4,1.4,0,0,0,.218-.405c-.18.255-.48.383-.706.6-.578.525-.585,1.343-1.058,1.921-.173.218-.435.353-.5,0a.083.083,0,0,0,0-.037c-.21-1.4,1.591-4.225,3.077-5.614l.278-.24c-2.754.75-3.985,5.523-4.255,5.178s.555-1.846,1.013-2.717a4.457,4.457,0,0,0-1.088,1.906l.368-1.629a15.85,15.85,0,0,1-1.021,2.131c-.315.248.165-1.936.278-2.341a14.262,14.262,0,0,0-.66,2.462v.113l.338.375.946,1.058h0l-.893-.66h0a1.222,1.222,0,0,0-.39-.435h0a.631.631,0,0,1,0,.083h0c-.045.3-.33,1-1.929.946h-.473a4.39,4.39,0,0,0,2.469.053,4.293,4.293,0,0,1-1.651.255H745.86a10.215,10.215,0,0,0,1.321.083,11.336,11.336,0,0,0,1.366-.083l-1.238.255-.683.135.683-.1,1.5-.225a9.755,9.755,0,0,0-2.356,1.1,11.578,11.578,0,0,1,3.392-.841h0a1.052,1.052,0,0,1,.218.068l.075.053a.218.218,0,0,1,.075.278c-.173.428-2.139.2-3.61,1.253a3.544,3.544,0,0,0-.413.353c.638-.225,1.186-.578,2-.81a6.754,6.754,0,0,1,2.251-.233c.113.105-.525.405-1.051.63l-.51.21-.113.053.856-.255h.12a12.226,12.226,0,0,1,1.411-.323,7.017,7.017,0,0,0-2.7,2.3h0a1.572,1.572,0,0,1,0,.27c.961-1.111,1.921-1.921,2.927-1.869h0a12.41,12.41,0,0,0-2.522,2.792l-.158.248,1.208-1.088h.038c.683-.608,1.163-1.006,1.5-1.276l-.323.263-.863.751h0l-.135.113.1-.075h0a3.678,3.678,0,0,1,1.861-.908c.42,0,.45.068.383.188a4.353,4.353,0,0,0-2.184,2.251.1.1,0,0,0,0,.045c-.045.1-.083.2-.128.3s0,.053,0,.083c.1-.128.18-.255.27-.383h0c.15-.225.3-.435.45-.638a2.844,2.844,0,0,1,1.839-1.276,3.64,3.64,0,0,0-.323.188h0a5.1,5.1,0,0,0-2,2.477,11.562,11.562,0,0,1,.923-1.1h0a5.255,5.255,0,0,1,1.5-1.223c.218-.045.63.1.375.5a7.009,7.009,0,0,0-1.5,2.319c-.645,1.614.75-1.561,1.5-1.749.458-.12-2.034,3.632-2.251,3.948.233-.285,2.649-3.4,2.747-3.542.075.068.068.293,0,.593l.12-.075a.428.428,0,0,1,.233-.045l.06-.21s1-.06.675.871a19.812,19.812,0,0,0-1.839,6.417.366.366,0,0,0,0-.083c.66-1.936,2.311-6.244.976-2.619l.083-.173c.263-.518,1.066-2.019,1.583-2.049.4-.053.645.06.7.39s-.578,1.366-.593,1.6.518-1.021.856-1.171a3.3,3.3,0,0,0-.458,1.081c0-.075.39-.908.675-.8s.24.158,0,.555a7.385,7.385,0,0,0-.5,2.109.252.252,0,0,1,0,.075q0,.158,0,.315a.052.052,0,0,0,0,.038,7.652,7.652,0,0,0,0,1.659v-.18c.135-1.036.24-1.756.338-2.251h0a2.542,2.542,0,0,1,.113-.308,4.49,4.49,0,0,1,.143-.45c.083-.2.315-.6.6-.428.113.068.105.225.075.353l-.135.75a3.661,3.661,0,0,0-.12.7c.188-.06.248-.458.293-.623a1.359,1.359,0,0,1,.128-.345.679.679,0,0,1,.113-.143.571.571,0,0,1,.143-.09,2.774,2.774,0,0,0-.1.428l-.135.548c-.105.465-.2.931-.255,1.4a6.583,6.583,0,0,0-.075.75v.375a2.083,2.083,0,0,1,0,.375c.15-.645.293-1.283.435-1.929a2.6,2.6,0,0,1,.4-1.028c.052-.068.128-.135.2-.105s.1.18.068.278c-.082.315-.165.713-.248,1.021.248-.233.353-.976.465-1.141a.81.81,0,0,1,.135.383h0v.038a.946.946,0,0,1-.105.45.188.188,0,0,1,.06-.075.2.2,0,0,1,.24,0c.293.15.045,1.208,0,1.291l.315-.788v1.336a3.4,3.4,0,0,0,.21-.615,2.15,2.15,0,0,0,.068-.345h0v-.068a.428.428,0,0,0,0-.1.576.576,0,0,0,.113.173h0l.068.09.218.323c.083.135.173.308.27.45l.045.053a.607.607,0,0,0,.09.105h0v-.2a2.358,2.358,0,0,0-.135-.345c-.09-.18-.6-.923-.263-1.058a.563.563,0,0,1,.353,0,4.5,4.5,0,0,1-.435-.2.9.9,0,0,1-.233-.135l-.068-.068a.037.037,0,0,1,0-.038c0-.045.06-.053.105-.053.473.068.946.15,1.411.255a4.763,4.763,0,0,1-.63-.285,3,3,0,0,0-.75-.2,1.5,1.5,0,0,1-.293-.045.55.55,0,0,1-.165-.068.353.353,0,0,1-.1-.113.36.36,0,0,1,.165-.465,2.342,2.342,0,0,1,1,.113c-.405-.12-1.328-.435-1.5-.788s.09-.555,1.276-.263c-.75-.615-1.411-.39-1.659-.66s.983-.12.983-.12-1.058-.263-1.223-.645.518-.623,2.634.308a3.587,3.587,0,0,0-2.364-1.238h0a4.521,4.521,0,0,1-.525-.128A10.355,10.355,0,0,1,761.537,448.782Zm-3.977,1h-.083c-.165-.323-.33-.623-.488-.9l-.36-.608.8,1.186.21.36Z'
						transform='translate(-608.157 -110.754)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_92'
						data-name='Path 92'
						d='M765.36,458l.158.045Z'
						transform='translate(-613.023 -116.902)'
						fill='#214749'
					/>
					<path
						id='Path_93'
						data-name='Path 93'
						d='M762.069,448.837h0c-.308-.188-.593-.39-.886-.593-.15-.083-.3-.18-.443-.27a4.473,4.473,0,0,0-.45-.27l-.51-.278h0l-.405-.2a7.625,7.625,0,0,0-.953-.413,7.049,7.049,0,0,0-2.056-.36,5.54,5.54,0,0,0-2.064.3c1.066,1.583,2.161,3.362,3.272,5.381h0l.173-.038a4.944,4.944,0,0,1,.818-.075,4.173,4.173,0,0,1,1,.15,2.334,2.334,0,0,1,.93.428l.188.18.165.2a1.312,1.312,0,0,1,.135.218,1.613,1.613,0,0,1,.1.24h0c-.293-.188-.518-.39-.75-.54a6.006,6.006,0,0,0-.8-.45,3.7,3.7,0,0,0-.908-.248,4.508,4.508,0,0,0-.638-.06h-.323l.3.555c.293.54.585,1.1.878,1.681a1.212,1.212,0,0,1,.075.135h0c.293.57.585,1.156.87,1.764a.261.261,0,0,1,0,.068,1.306,1.306,0,0,1-.083-.135l-.075-.105c-.128-.2-.255-.405-.375-.615l-.075-.128-.45-.8c0-.068-.075-.135-.12-.2-.158-.285-.315-.57-.48-.856l-.165-.293v-.053c-.188-.338-.383-.675-.578-1.013a.052.052,0,0,1,0,.038,2.252,2.252,0,0,1-.128.465c-.06.165-.12.33-.135.39a9.191,9.191,0,0,0-.278,2.169,5.1,5.1,0,0,1-.278,1.756,11.513,11.513,0,0,0,0-1.253c-.045-.18,0-.3-.045-.443a6,6,0,0,1,.75-3.062l.045-.09h0l-.315-.533c-.75-1.261-1.5-2.507-2.3-3.752-.21-.323-.428-.645-.645-.968h0a12.014,12.014,0,0,0-1.178,2.154c-.15.345-.285.7-.413,1.051a13.032,13.032,0,0,0-.383,1.306c-.12.518-.21,1.036-.285,1.561h0a.338.338,0,0,0-.4,0v-.075l.06-.338a2.927,2.927,0,0,1,.143-.615c.045-.2.105-.413.165-.615a14.475,14.475,0,0,1,.923-2.357,11.9,11.9,0,0,1,1.336-2.109h0c-.728-.968-1.479-1.921-2.229-2.912-.375-.488-.75-.953-1.156-1.418l-.083.045a12.223,12.223,0,0,0-1.051.705,8.969,8.969,0,0,0-.863.75h0a6.342,6.342,0,0,0-.5.473l-.045.045a13.184,13.184,0,0,0-1.764,2.251c-.083.135-.165.27-.24.405s-.21.368-.308.563a17,17,0,0,0-.983,2.462c-.075.263-.158.525-.218.788l-.105.405a3.909,3.909,0,0,1-.09.405c-.113.533-.188,1.088-.278,1.636h0v-.841a3.962,3.962,0,0,1,.06-.841,11.6,11.6,0,0,1,.308-1.666c.045-.165.09-.323.143-.488V449.5A11.574,11.574,0,0,1,745.852,447a13.514,13.514,0,0,1,1.4-1.854,10.108,10.108,0,0,1,.75-.75c.27-.24.488-.443.751-.645a11.307,11.307,0,0,1,1.951-1.3h0c-.593-.69-1.208-1.366-1.846-2.019h-.293a11.261,11.261,0,0,0-2.792.751,11.67,11.67,0,0,0-2.679,1.568l-.045.038a9.86,9.86,0,0,0-1.163,1.073l-.27.285-.158.188-.1.113c-.173.2-.338.4-.5.608a19.087,19.087,0,0,0-1.606,2.492,1.51,1.51,0,0,0-.105.188h0a9.846,9.846,0,0,1,3.752-5.186,12.085,12.085,0,0,1,1.313-.833,11.7,11.7,0,0,1,1.5-.7,11.2,11.2,0,0,1,2.792-.653h.3l-.18-.188c-.39-.383-.788-.75-1.2-1.111h0l-.4-.33h0a18.156,18.156,0,0,0-2-1.463,12.4,12.4,0,0,0-3.925-1.689c-.428-.1-1.5-.083-1.636-.683h0a.165.165,0,0,1,0-.12.75.75,0,0,1,.63-.27s2.814.36,6.949,3.88h0l.338.3c.5.435,1.006.908,1.5,1.433a9.7,9.7,0,0,1,.428-2.732,8,8,0,0,1,1.276-2.507,7.065,7.065,0,0,1,.983-1.028,5.73,5.73,0,0,1,.548-.405h0c.2-.135.42-.233.63-.345a6.243,6.243,0,0,1,1.561-.465,5.808,5.808,0,0,1,1.193-.083h0a10.553,10.553,0,0,0-2.582.863c-.2.113-.4.21-.585.338l-.068.045c-.165.1-.323.218-.488.33a6.753,6.753,0,0,0-.976.931,7.507,7.507,0,0,0-1.336,2.364,10.325,10.325,0,0,0-.45,1.651,9.651,9.651,0,0,0-.128,1.043h0c.623.63,1.276,1.328,1.944,2.109a9.544,9.544,0,0,1,1.5-2.514l.15-.173a7.5,7.5,0,0,1,3.475-2.326,6.491,6.491,0,0,1,1.5-.255,7.362,7.362,0,0,1,2.912.48h0a11.88,11.88,0,0,0-2.867-.12,7.5,7.5,0,0,0-2.724.75,7.179,7.179,0,0,0-1.419.946h0a8.344,8.344,0,0,0-.826.8,9.757,9.757,0,0,0-1.6,2.409h0a51.9,51.9,0,0,1,3.355,4.42,5.7,5.7,0,0,1,2.086-.458,7.159,7.159,0,0,1,2.146.255,9.757,9.757,0,0,1,1.028.353l.248.113a2.4,2.4,0,0,1,.24.12l.465.278a4.77,4.77,0,0,1,.443.323l.143.113.278.225a10.4,10.4,0,0,1,.75.75Z'
						transform='translate(-606.483 -110.553)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_94'
						data-name='Path 94'
						d='M759.746,457.023c-.36-.533-.66-1.1-.976-1.651-.458-.811-.908-1.614-1.373-2.417v-.045h0c-.1-.173-.2-.345-.3-.518-.75-1.261-1.5-2.507-2.3-3.752-.068-.113-.33-.488-.668-.976v-.038c-.668-.953-1.636-2.311-2.124-2.942-.375-.48-.75-.953-1.156-1.418h0c-.593-.69-1.876-2.064-1.869-2.064l-.18-.188c-.518-.51-1.058-1-1.614-1.463a19.154,19.154,0,0,0-2.011-1.5,12.4,12.4,0,0,0-3.925-1.689c-.428-.1-1.5-.083-1.636-.683h0a.187.187,0,0,1,0-.09c.068.113.233.218.57.278a29.463,29.463,0,0,1,3.887,1.291s7.024,2.882,15.677,19.767Z'
						transform='translate(-606.598 -111.31)'
						fill='#9fce55'
						opacity='0.58'
					/>
					<path
						id='Path_95'
						data-name='Path 95'
						d='M769.071,445.849c-.27.45-.555.225-.841-.075a2.251,2.251,0,0,0-1.246-.705c-.135,0-.308,0-.375.1a.458.458,0,0,1,.278-.435.976.976,0,0,1,.548-.06,2.845,2.845,0,0,1,.855.27,1.417,1.417,0,0,0,.533.21.127.127,0,0,0,.12,0,.112.112,0,0,0,0-.068c0-.2,0-.458-.2-.555a1.126,1.126,0,0,0-.465-.12,1.5,1.5,0,0,1-.668-.285c-.248-.218,1.111.315,1-.2s-1.884-1-2-1.028c.308.068.75.158,1.313.315a1.764,1.764,0,0,1,1.148,2.634Z'
						transform='translate(-613.335 -113.134)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_96'
						data-name='Path 96'
						d='M768.92,455.445c-.3.585-1.193,0-2.026-.705-.54-.668-.428-1.2,0-.75a1.351,1.351,0,0,0,1.5.4.262.262,0,0,0,.143-.128.293.293,0,0,0-.113-.27l-.42-.473a.855.855,0,0,1,.323.105.315.315,0,0,0,.315,0,.338.338,0,0,0,.068-.27,2.094,2.094,0,0,0-1.028-1.636c-.315-.233-.645-.45-.976-.66l-.638-.405a4.73,4.73,0,0,0-1.118-.36,5.5,5.5,0,0,1,1.794.563,4.271,4.271,0,0,0,1.861.75.233.233,0,0,0,.158-.045c.083-.067.068-.2.045-.3a1.681,1.681,0,0,0-.525-1.036,3.659,3.659,0,0,0-.623-.233.09.09,0,0,1,0-.165c.54-.1.518-.428.45-.75a2.56,2.56,0,0,0-.645-1.133,5.358,5.358,0,0,1,.863.833C769.288,450.094,769.363,454.582,768.92,455.445Z'
						transform='translate(-612.92 -114.392)'
						fill='#3b8233'
						opacity='0.8'
					/>
					<path
						id='Path_97'
						data-name='Path 97'
						d='M748.718,463.388H760.1L746.76,415.02H735.39Z'
						transform='translate(-605.544 -106.178)'
						fill='#fff'
						opacity='0.3'
					/>
					<path
						id='Path_98'
						data-name='Path 98'
						d='M741.156,463.388h3.13L730.957,415.02H727.82Z'
						transform='translate(-603.656 -106.178)'
						fill='#fff'
						opacity='0.3'
					/>
					<path
						id='Path_99'
						data-name='Path 99'
						d='M778.7,426.682v11.37L772.35,415.02h3.13Z'
						transform='translate(-614.767 -106.178)'
						fill='#fff'
						opacity='0.3'
					/>
					<ellipse
						id='Ellipse_6'
						data-name='Ellipse 6'
						cx='170.305'
						cy='43.663'
						rx='170.305'
						ry='43.663'
						transform='translate(124.052 593.287)'
						fill='#5b2101'
						opacity='0.17'
					/>
					<path
						id='Path_100'
						data-name='Path 100'
						d='M747.2,803.9s2.867,39.9,7.64,42.889,15.76,3,17.171-1.013,6.807-41.876,6.807-41.876Z'
						transform='translate(-608.491 -203.214)'
						fill='#513703'
					/>
					<path
						id='Path_101'
						data-name='Path 101'
						d='M1015.65,837.33s2.867,39.9,7.64,42.89,15.76,3,17.178-1.013,6.8-41.876,6.8-41.876Z'
						transform='translate(-675.477 -211.555)'
						fill='#513703'
					/>
					<path
						id='Path_102'
						data-name='Path 102'
						d='M1126.32,784.81s2.169,30.267,5.786,32.533,11.948,2.251,13.036-.75,5.156-31.768,5.156-31.768Z'
						transform='translate(-703.092 -198.45)'
						fill='#513703'
					/>
					<path
						id='Path_103'
						data-name='Path 103'
						d='M788.157,639.5l126.17-46.649,92.759,22.814-30.019,94.387-150.41,1.831L784.63,677.706Z'
						transform='translate(-617.831 -150.551)'
						fill='#b77408'
					/>
					<path
						id='Path_104'
						data-name='Path 104'
						d='M797.786,529.948c25.111-9.456,71.58-12.518,71.58-12.518L879.25,623,778.086,644.343,764.84,549.378S769.876,540.462,797.786,529.948Z'
						transform='translate(-612.893 -131.732)'
						fill='#cf8c0e'
					/>
					<path
						id='Path_105'
						data-name='Path 105'
						d='M769.358,684.559s-7.152-16.03,15.22-27.2,71.85-21.073,84.323-34.146,123.7-20.263,134.1-3.272-17.058,90.687-45.336,91.257S769.358,684.559,769.358,684.559Z'
						transform='translate(-613.749 -154.822)'
						fill='none'
						stroke='#cf8c0e'
						strokeWidth='1'
					/>
					<path
						id='Path_106'
						data-name='Path 106'
						d='M1037.126,530.49s-22.454,35.978-21.929,43.4,7.73,33.621,20.33,31.122,52.616-33.906,52.616-33.906l-12.608-34.814Z'
						transform='translate(-675.362 -134.991)'
						fill='#a87150'
					/>
					<path
						id='Path_107'
						data-name='Path 107'
						d='M742.163,679.784c2.709-32.45,3.2-56.03,0-73.426s5.2-55.318,30.409-50.364,24.8,31.37,18.807,52.571-12.33,51.55-8.8,75.655,9.133,72.578-30.019,67.618C720.962,747.8,740.632,698.163,742.163,679.784Z'
						transform='translate(-605.376 -141.244)'
						fill='#e19f1c'
					/>
					<path
						id='Path_108'
						data-name='Path 108'
						d='M1119.623,513.18s-5.906-66.83,9.246-91.333,24.225-21.951,28.518-16.225,15.2,86.47-12.871,139.521S1119.623,513.18,1119.623,513.18Z'
						transform='translate(-701.138 -102.874)'
						fill='#ffc345'
					/>
					<path
						id='Path_109'
						data-name='Path 109'
						d='M1068.435,771.325c18.589-12.33,29.043-20.48,46.807-29.111,7.6-3.692,14.807-2.9,18.011-31.3s7.2-88.421,7.2-102.027-4-49.749-68.421-30.477-31.58,88.488-31.58,88.488l-4.833,112.451,4.826,8.766S1051.129,782.8,1068.435,771.325Z'
						transform='translate(-679.578 -145.566)'
						fill='#ffc345'
					/>
					<path
						id='Path_110'
						data-name='Path 110'
						d='M784.8,749.268c-1.2,0-17.7-3.6-20.45,16.8s-3.152,33.606,12.008,37.208,60.458,6.4,76.443,8.8,76.2,15.2,86.9,10,19.512-48.9,5.9-58.259S784.8,749.268,784.8,749.268Z'
						transform='translate(-612.398 -189.52)'
						fill='#f4b038'
					/>
					<path
						id='Path_111'
						data-name='Path 111'
						d='M766.078,716.842c-3.415-18.514-1.8-27.212,31.707-27.212S927.3,705.915,947.73,703.236s14.409,43.212,4.008,49.216-41.636,4-82.327.4c0,0-40.878-3.625-65.884-9.223S770.874,742.846,766.078,716.842Z'
						transform='translate(-612.893 -174.7)'
						fill='#ffc345'
					/>
					<path
						id='Path_112'
						data-name='Path 112'
						d='M787.025,534.855c.308,2.859,6.7,13.509,12.563,22.327l.533.811c.705,1.013,1.358,1.989,2,2.9a72.537,72.537,0,0,0,6.709,8.818c3.512,3.159,5.253,5.861,8.525,12.1a12.2,12.2,0,0,1,.946,2.942,39.325,39.325,0,0,1,.8,4.5c1.5,11.22,1.546,29.486,1.546,29.486s.458,1.418.173,5.9c-.075.638-.12,1.343-.2,2.109-.15,1.373-.24,2.687-.27,3.835-.045,4.008,1.088,6.6,5.591,6.709h.068a14.691,14.691,0,0,0,3.137-.338c4.758-.938,11.662-3.55,19.107-5.771,1.058-.293,2.124-.623,3.182-.878q2.687-.751,5.381-1.313c5.193-1.088,14.514-2.041,24.263-2.762.991-.105,2.019-.173,3-.24,7.4-.525,14.837-.916,20.743-1.156l3.039-.113c2.867-.12,5.178-.165,6.754-.188,4.15,0,10.387-.315,16.293-.585,1-.045,1.959-.113,2.927-.15,6.206-.3,11.587-.615,13.223-.57a6.607,6.607,0,0,0,6.071-7.925,8.25,8.25,0,0,0-.488-1.554c-1.433-3.362-4.083-6.349-8.615-13.186-.705-1.111-1.5-2.311-2.334-3.647-2.251-3.647-4.908-8.255-8.008-14.071a110.446,110.446,0,0,1-6.229-15.084c-.465-1.328-.923-2.717-1.388-4.105-2.852-8.818-5.554-18.694-7.782-27.768-.293-1.156-.585-2.251-.856-3.415-3.752-15.182-6.154-27.385-6.154-27.385-.705-3.385-7.7,1.7-13.816,5.584-.893.555-1.749,1.073-2.582,1.568a24.989,24.989,0,0,1-2.814,1.5c-6.319,2.732-8.848,5.809-15.25,7.024a.424.424,0,0,0-.263.06c-.968.165-1.876.308-2.7.383-4.773.39-7.5-.638-13.126-.75a29.911,29.911,0,0,0-8.255,1.5c-.908.263-1.854.563-2.822.856-5.539,1.786-12.008,4.09-18.837,5.426a10.34,10.34,0,0,1-1.058.165c-.968.2-2,.338-3,.473-10.206,1.283-22.432.63-29.171.045-.991-.09-1.831-.173-2.559-.255a5.523,5.523,0,0,0-1.051-.06C788.488,528.228,786.522,530.322,787.025,534.855Z'
						transform='translate(-618.41 -128.376)'
						fill='#876f5f'
					/>
					<path
						id='Path_113'
						data-name='Path 113'
						d='M921.28,537.2s-20.263.7-28.083,2.507-23.16.961-28.983.856-15.445,4.052-17.7,6.394,4.983,19.978,8.36,31.152,3.842,36.436,5.906,41.7,4.961,6.131,12.293,5.111,28.8,1.921,39.452-.218,22.364,1.358,33.163-1.981,11.895-3.31,9.411-6.176-15.857-23.22-17.171-29.268-1.884-12.465-4.188-22.514S925.768,532.9,921.28,537.2Z'
						transform='translate(-633.167 -136.526)'
						fill='#8e7869'
					/>
					<path
						id='Path_114'
						data-name='Path 114'
						d='M803.79,574.361c2.2,3.287,4.315,6.357,6,8.638a32.089,32.089,0,0,0,3.235,3.895c3.512,3.16,5.253,5.861,8.525,12.1s3.287,36.931,3.287,36.931.593,1.869,0,8.008-.525,10.4,5.321,10.507c4.435.113,12.7-3.2,21.914-6h.06c2.912-.886,5.914-1.681,8.916-2.311,12.48-2.634,48.586-4.4,57.786-4.458s29.028-1.4,32.443-1.306a6.607,6.607,0,0,0,6.071-7.925,14.89,14.89,0,0,0-5.7-1.073c-3.587-.09-2.507-.06-9.861,1.869s-18.829,2.739-26.6,2.447-14.9,1.328-22.447,1.433-27.768.113-32.916,1.583-14.214,3.91-17.313.63-2.462-8.075-3.174-14.5-1.929-24.623-2.732-29.966-6.754-13.268-13.756-16.773C818.244,575.809,805.794,570.113,803.79,574.361Z'
						transform='translate(-622.612 -145.555)'
						fill='#6b5647'
					/>
					<path
						id='Path_115'
						data-name='Path 115'
						d='M811.8,586.36a32.093,32.093,0,0,0,3.235,3.895c3.512,3.16,5.253,5.861,8.525,12.1s3.287,36.931,3.287,36.931.593,1.869,0,8.008-.525,10.4,5.321,10.507c4.435.113,12.7-3.2,21.914-6-.938.135-11.872,1.5-15.52,2.5-3.82.961-3.82.833-6.191-1.118s-.848-4.668-1.021-8.42.09-17.876.045-20.7-.255-19.1-1.869-23.535-4.5-10.011-9.914-12.548A14.8,14.8,0,0,0,811.8,586.36Z'
						transform='translate(-624.611 -148.917)'
						fill='#604d40'
					/>
					<path
						id='Path_116'
						data-name='Path 116'
						d='M802.464,560.267c.705,1.013,1.358,1.989,2,2.9a22.735,22.735,0,0,1,5.869-9.276c1.5,2.251,3.107,4.405,4.638,6.334,7.707,9.674,10.747,14.259,12.683,19.955a28.165,28.165,0,0,0-7.009,6.844,39.351,39.351,0,0,1,.8,4.5,23.19,23.19,0,0,1,7.129-8.255c.135.488.24.968.375,1.5a132.159,132.159,0,0,1,2.919,34,44.716,44.716,0,0,0-8.706,8.18c-.075.638-.12,1.343-.2,2.109-.15,1.373-.24,2.687-.27,3.835a37.439,37.439,0,0,1,8.871-10,79.645,79.645,0,0,1-3.212,16.623,14.687,14.687,0,0,0,3.137-.338,90.324,90.324,0,0,0,3.152-18.694,98.47,98.47,0,0,1,16.676-9.006c.413-.18.885-.36,1.3-.548a59.046,59.046,0,0,1-.128,10.957,93.282,93.282,0,0,1-1.891,11.52c1.058-.293,2.124-.623,3.182-.878.593-2.777,1.141-6.191,1.6-10.281a62.453,62.453,0,0,0,.105-12.4,165.671,165.671,0,0,1,26.267-6.334c2.146,6.334,3.587,12.045,3.137,15.813-.375,3.385-.916,6.484-1.448,9.126.991-.105,2.019-.173,3-.24.5-2.522.946-5.4,1.321-8.5.51-4.248-.863-10.146-3.092-16.706,7.069-1.133,14.019-2.019,19.993-2.612,3.219,7.932,5.156,15.925,2.522,26.657l3.039-.113c2.432-10.769.533-19.055-2.514-26.822,1.606-.15,3.159-.27,4.5-.368a100.441,100.441,0,0,1,14.567.4c.525,1.163,1.058,2.251,1.561,3.242,3.752,7.782,5.726,11.775,4.893,22.777,1-.045,1.959-.113,2.927-.15.818-11.647-1.351-16.12-5.253-24.135-.218-.45-.443-.908-.668-1.388,6.266.668,12.21,1.614,16.105,2.251-.705-1.111-1.5-2.311-2.334-3.647-4.218-.683-9.7-1.5-15.407-2.049a178.634,178.634,0,0,1-8.886-23.55c-.75-2.417-1.5-4.773-2.251-7.137a44.4,44.4,0,0,1,12.368,3.64c-.465-1.328-.923-2.717-1.388-4.105a52.538,52.538,0,0,0-11.94-2.927c-3.114-9.816-6.071-18.9-8.683-26.709,5.186.54,9.666,1.291,12.841,1.884-.293-1.156-.585-2.251-.856-3.415-3.43-.66-7.97-1.351-13.1-1.861-2.912-8.7-5.336-15.58-6.867-19.94-.893.555-1.749,1.073-2.582,1.568,1.5,4.135,3.632,10.372,6.244,18.094a100.562,100.562,0,0,0-20.646.45c-1.418-3.88-2.649-7.31-3.662-10.056a.424.424,0,0,0-.263.06c-.968.165-1.876.308-2.7.383.961,2.649,2.251,6.109,3.67,10.056-1.321.218-2.619.51-3.88.833-4.5,1.133-9.966,2.507-15.85,3.925-2.139-5.719-4.053-10.8-5.321-14.064-.908.263-1.854.563-2.822.856,1.208,3.167,3.13,8.188,5.253,13.906-6.552,1.568-13.464,3.19-19.955,4.6-1.951-4.983-3.752-9.516-5.2-12.916-.968.2-2,.338-3,.473,1.343,3.272,3.25,7.932,5.253,13.073-6.754,1.5-12.983,2.657-17.561,3.317a15.347,15.347,0,0,0-5.771,2.034c-4.338-6.552-8.428-13.636-11.092-18.379-.991-.09-1.831-.173-2.559-.255a5.532,5.532,0,0,0-1.051-.06c2.514,4.615,7.19,12.833,12.255,20.458A24.622,24.622,0,0,0,802.464,560.267Zm65.419,7.587a210.643,210.643,0,0,0-21.058,4.188c-1.719-7.25-5.051-16.788-8.338-25.456,6.492-1.441,13.4-3,19.925-4.6,3.287,8.758,6.927,18.627,9.471,25.831Zm22.912-3.752c-1.111.165-2.169.368-3.347.593-4.5.916-9.539,1.681-14.874,2.484-.555.075-1.148.2-1.7.278-2.507-7.145-6.206-17.171-9.576-26.161,5.7-1.366,11.025-2.709,15.347-3.752,1.411-.353,2.882-.668,4.345-.923,3.039,8.308,6.657,18.327,9.809,27.4Zm22.514-1.358a85.711,85.711,0,0,0-19.512.856c-3.137-9.006-6.717-18.972-9.756-27.415A104.5,104.5,0,0,1,904.678,536c2.552,7.707,5.478,16.766,8.623,26.672ZM904.3,592.282a134.426,134.426,0,0,1-5.4-13.411c-1.111-3.482-2.529-7.685-4.105-12.278a82.552,82.552,0,0,1,19.512-.57c.863,2.807,1.756,5.651,2.649,8.555a184.2,184.2,0,0,0,8.255,22.252,94.5,94.5,0,0,0-13.141-.263c-1.7.12-3.6.263-5.621.465-.653-1.614-1.373-3.2-2.124-4.826ZM877.466,584.5c-2.064-5.013-3.993-9.711-5.523-13.974l1-.173c5.4-.826,10.469-1.591,15.009-2.507,1.321-.285,2.582-.48,3.872-.705,1.666,4.818,3.16,9.246,4.323,12.893a125.9,125.9,0,0,0,5.539,13.659c.548,1.261,1.1,2.492,1.628,3.752-5.944.593-12.758,1.5-19.7,2.619-1.794-5.118-3.978-10.394-6.124-15.64Zm-26.8,2.634c-1.1-3.9-2.2-7.9-3.122-12.008a216.474,216.474,0,0,1,21.4-4.15c1.613,4.5,3.677,9.546,5.854,14.852,1.989,4.826,4.083,9.906,5.831,14.724a175.486,175.486,0,0,0-25.516,6.161,135.526,135.526,0,0,0-4.428-19.655Zm-19.557-5.576a58.446,58.446,0,0,1,13.584-5.659c.946,4.2,2.071,8.255,3.174,12.2a133.135,133.135,0,0,1,4.45,19.655c-.75.27-1.448.54-2.1.841a106.206,106.206,0,0,0-15.392,8.113,131.135,131.135,0,0,0-3.077-32.788c-.188-.886-.39-1.659-.615-2.432ZM812.783,552.2a12.971,12.971,0,0,1,4.36-1.5c4.78-.645,11.257-1.929,18.349-3.452a231.92,231.92,0,0,1,8.488,25.591,62.162,62.162,0,0,0-13.794,5.771c-2.251-6.266-5.651-11.257-13.021-20.473-1.426-1.869-2.889-3.872-4.36-6.011Z'
						transform='translate(-620.753 -130.614)'
						fill='#e4d9cd'
						opacity='0.74'
					/>
					<path
						id='Path_117'
						data-name='Path 117'
						d='M901.409,657.159a24.033,24.033,0,0,1-8.135,1.336s-.465-8.871,3.2-13.276S901.409,657.159,901.409,657.159Z'
						transform='translate(-644.936 -163.431)'
						fill='#9b9b9b'
					/>
					<path
						id='Path_118'
						data-name='Path 118'
						d='M891.15,636.388s7.8,22.207,29.8,26,45.614-3.4,56.616-24.6-37.809-39.107-49.614-36.158S891.15,636.388,891.15,636.388Z'
						transform='translate(-644.411 -152.663)'
						fill='#218284'
					/>
					<path
						id='Path_119'
						data-name='Path 119'
						d='M906.677,381.709s-3.467-7.467-17.073-7.34-29.471,5.869-39.475,22.679-.533,29.2-4,40.405-10.934,27.077-1.336,36.541,52.15,5.336,66.042-9.2,18.807-36.248,19.069-51.783S918.819,377.972,906.677,381.709Z'
						transform='translate(-631.667 -96.034)'
						fill='#231f20'
					/>
					<path
						id='Path_120'
						data-name='Path 120'
						d='M910.635,461.114s-2.522,20.968,4.218,27.07-17.133,1.5-24.6,0,2.484-33.944,6.574-33.974S910.635,461.114,910.635,461.114Z'
						transform='translate(-643.513 -115.957)'
						fill='#231f20'
					/>
					<path
						id='Path_121'
						data-name='Path 121'
						d='M925.706,415.313s-2,20.668-10.266,29.471-18.409,8.8-20.54,5.869c0,0-3.872,3.332-.8,13.073l4.8,7.467s.931,9.336-15.069,8.668-21.344-10.034-21.471-12.405,2-4.27,2-4.27,13.028-5.936,9.914-23.97-2.574-27.175-2.574-27.175l6.664-8.45,20.541-8.405,16.27-1.066,5.066,4.938Z'
						transform='translate(-637.225 -100.963)'
						fill='#a87c50'
					/>
					<path
						id='Path_122'
						data-name='Path 122'
						d='M864.591,496.262c3.355,2.679,20,7.2,21.869-9.6,0,0,8.54,5.066,14.469,9.463S914.6,507.2,914.437,524s10.507,43.745,10.507,43.745l-11.069,19.512-4.135.8s-17.2,6.131-31.873,30.942l-6.8-15.94s-4.608,5.6-9.006,6.8-6.8-1.2-11.6-7.8-17.4-35.212-18.6-63.04,8.255-40.21,10.507-43.01,10.319-10.942,14.319-9.876A25.516,25.516,0,0,0,864.591,496.262Z'
						transform='translate(-629.589 -123.9)'
						fill='#fff'
					/>
					<g
						id='Group_18'
						data-name='Group 18'
						transform='translate(273.088 383.049)'
						opacity='0.31'
					>
						<path
							id='Path_123'
							data-name='Path 123'
							d='M937.915,533.78c-2.5-9.719-9.253-12.856-11.655-19.88a93.854,93.854,0,0,0,6.672,7.317c4.983,4.5,6.619,11.925,6.619,11.925Z'
							transform='translate(-926.26 -513.9)'
							fill='#ddd'
						/>
					</g>
					<path
						id='Path_124'
						data-name='Path 124'
						d='M926,513.933c1.178,3.362,3.467,6,5.666,8.781a30.053,30.053,0,0,1,6,11.1c.045.18.48.068.435-.113a29.4,29.4,0,0,0-5.734-10.807c-2.251-2.844-4.7-5.591-5.921-9.073-.06-.18-.5-.06-.435.113Z'
						transform='translate(-653.107 -130.809)'
						fill='#e2e2e2'
					/>
					<path
						id='Path_125'
						data-name='Path 125'
						d='M919.67,555.724s.18,4.638,4.788,4.841S976.886,513.9,976.886,513.9s-24.7,1.253-29.951,2.852S919.467,554.576,919.67,555.724Z'
						transform='translate(-651.527 -130.851)'
						fill='#efbf9e'
					/>
					<path
						id='Path_126'
						data-name='Path 126'
						d='M921.27,556.141s22.387-34.454,26.071-37.073,27.843-3.5,27.843-3.5'
						transform='translate(-651.927 -131.268)'
						fill='none'
						stroke='#9b6237'
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth='0.5'
						opacity='0.44'
					/>
					<path
						id='Path_127'
						data-name='Path 127'
						d='M922.37,557.941s22.139-33.824,26.582-37.133c3.752-2.784,7.3-1.779,27.5-3.377'
						transform='translate(-652.201 -131.732)'
						fill='none'
						stroke='#9b6237'
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth='0.5'
						opacity='0.44'
					/>
					<path
						id='Path_128'
						data-name='Path 128'
						d='M924.419,558.353l26.694-36.24a2.777,2.777,0,0,1,1.906-1.118l21.313-2.7a2.807,2.807,0,0,1,2.874,4.023l-20.54,42.147a2.814,2.814,0,0,1-2.852,1.561l-27.452-3.212a2.814,2.814,0,0,1-1.944-4.458Z'
						transform='translate(-652.577 -131.941)'
						fill='#aa8d7e'
					/>
					<path
						id='Path_129'
						data-name='Path 129'
						d='M896.709,595.89s6,19.8,5,25.944l-5.869-2.139s-4.773-14.672-2.754-19.805Z'
						transform='translate(-644.769 -151.31)'
						fill='#9b9b9b'
					/>
					<path
						id='Path_130'
						data-name='Path 130'
						d='M891.876,588.89s24.616-9.606,28.616-15.31,2.3-7.3,3.3-11.1,5.606-6.9,6.3-9.8,1.3-6.206,2.7-5.8,1.8,4.2,1.1,7.3-3,7.8,8.405,2.9-4.7,17.1-11.5,23.009-30.9,24.608-40.908,29.006C889.888,609.093,879.253,591.592,891.876,588.89Z'
						transform='translate(-643.051 -139.072)'
						fill='#a87c50'
					/>
					<path
						id='Path_131'
						data-name='Path 131'
						d='M961.472,541.16s-19.8,33.809-30.612,70.424l56.818,7.115,3-26.92,1-34.98Z'
						transform='translate(-654.319 -137.653)'
						fill='#218284'
					/>
					<path
						id='Path_132'
						data-name='Path 132'
						d='M979.58,524.222s18.454,32.5,31.858,23.76,21.208-44.165,6.4-42.559S979.58,524.222,979.58,524.222Z'
						transform='translate(-666.476 -128.722)'
						fill='#a87c50'
					/>
					<path
						id='Path_133'
						data-name='Path 133'
						d='M976.872,528s13.508,20.706,32.12,20.105l-5.6,11s-9.606,1.8-21.208-6.6-12.405-14.6-12.405-14.6Z'
						transform='translate(-664.031 -134.369)'
						fill='#006e7a'
					/>
					<path
						id='Path_134'
						data-name='Path 134'
						d='M867.69,545.29a19.77,19.77,0,0,0,4,6.2c2.9,3.1,5.8,7.9,3.7,13.906,0,0,.8,4.5-.9,7.8s1,3.107,2.6,5.5,1.846,9.651,6,8.908c0,0-4.585-6.867-4.428-12.5s1.831-8.105.63-15.407A18.694,18.694,0,0,0,867.69,545.29Z'
						transform='translate(-638.557 -138.684)'
						fill='#ddd'
						opacity='0.39'
					/>
					<path
						id='Path_135'
						data-name='Path 135'
						d='M867.69,545.29a19.77,19.77,0,0,0,4,6.2c2.9,3.1,5.8,7.9,3.7,13.906,0,0,.8,4.5-.9,7.8s1,3.107,2.6,5.5,1.846,9.651,6,8.908'
						transform='translate(-638.557 -138.684)'
						fill='none'
						stroke='#e2e2e2'
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth='0.5'
					/>
					<path
						id='Path_136'
						data-name='Path 136'
						d='M873.4,568.245a23.912,23.912,0,0,0-5.9-6.567c-2.207-1.824-4.668-3.557-6.349-5.921-.083-.105-.51-.788-.705-.653s.293.826.345.893a31.89,31.89,0,0,0,6.161,6.109c2.139,1.741,4.45,3.512,5.824,5.959.113.188.5.893.75.87s-.09-.608-.143-.69Z'
						transform='translate(-636.737 -141.128)'
						fill='#e2e2e2'
					/>
					<path
						id='Path_137'
						data-name='Path 137'
						d='M876.681,595.168a16.39,16.39,0,0,0-9.689,2.874,22.732,22.732,0,0,0-3.535,3.152c-1.3,1.336-2.672,2.844-4.548,3.295-.218.053-1.1.69-.6.57,3-.75,4.893-3,6.972-5.051a14.132,14.132,0,0,1,10.612-4.218c.255,0,1.1-.585.788-.593Z'
						transform='translate(-636.178 -151.128)'
						fill='#e2e2e2'
					/>
					<path
						id='Path_138'
						data-name='Path 138'
						d='M880.6,599.754c-4.15,1.741-6.281,5.824-8.143,9.666-.15.315.57.18.675-.045,1.741-3.572,3.752-7.617,7.61-9.246.413-.173.278-.555-.143-.375Z'
						transform='translate(-639.74 -152.262)'
						fill='#e2e2e2'
					/>
					<path
						id='Path_139'
						data-name='Path 139'
						d='M894.147,595.89s-3.137,10.274-1.006,16.51a23.076,23.076,0,0,0,6,9.471s-4.871,6.867-10.4,5.666-7.07-16.075-6.2-21.606,2.732-7.6,5.2-8.736A21.076,21.076,0,0,1,894.147,595.89Z'
						transform='translate(-642.207 -151.31)'
						fill='#e2e2e2'
					/>
					<path
						id='Path_140'
						data-name='Path 140'
						d='M913.11,396.374s2.251,9.261-3.332,12.57a25.2,25.2,0,0,0,0-11.37s-14.672,6.672-21.073,12.668-17.133,10.889-14.8,17.6c2.844,8.2,2.206,44.638-22.071,38.957-7.565-1.779,8.728-47.482,8.728-47.482l9.471-22.409,26.942-5.336,14.4-2.251,11.6,8.668,4.278,14.724-4.135,8.338s-1.936-6.139-5.036-9.471S913.11,400.112,913.11,396.374Z'
						transform='translate(-634.1 -99.765)'
						fill='#231f20'
					/>
					<path
						id='Path_141'
						data-name='Path 141'
						d='M919.507,427.749c-.51,1.8-1.929,3-3.167,2.634s-1.831-2.094-1.321-3.9,1.929-3,3.167-2.642S920.017,425.94,919.507,427.749Z'
						transform='translate(-650.321 -108.362)'
						fill='#231f20'
					/>
					<path
						id='Path_142'
						data-name='Path 142'
						d='M888.734,425.973s-.135-10.169-4.5-10.507-6.934,7.137-5.6,11.865,2.934,8.255,6.4,6.634S888.734,425.973,888.734,425.973Z'
						transform='translate(-641.199 -106.286)'
						fill='#a87c50'
					/>
					<path
						id='Path_143'
						data-name='Path 143'
						d='M911.888,416.283a17.735,17.735,0,0,1,3.377-.563,13.336,13.336,0,0,1,6.634.886,7.152,7.152,0,0,1,3.077,2.679c.188.308.675,0,.48-.285-2.574-4.128-8.09-4.33-12.39-3.55a13.05,13.05,0,0,0-1.328.285.285.285,0,0,0,.15.548Z'
						transform='translate(-649.502 -106.195)'
						fill='#231f20'
					/>
					<path
						id='Path_144'
						data-name='Path 144'
						d='M936.954,426.857l.105-.045h.068l.188-.075a6.509,6.509,0,0,1,1.058-.293,3.662,3.662,0,0,1,2.724.383,3.392,3.392,0,0,1,1.238,1.7c.12.338.66.188.54-.15a3.639,3.639,0,0,0-2.709-2.507,5.689,5.689,0,0,0-2.852.278,6.2,6.2,0,0,0-.653.255c-.33.158-.045.645.285.488Z'
						transform='translate(-655.73 -108.867)'
						fill='#231f20'
					/>
					<path
						id='Path_145'
						data-name='Path 145'
						d='M938.683,436.614c-.435,1.5-1.636,2.529-2.687,2.251s-1.553-1.779-1.118-3.31,1.636-2.529,2.687-2.251S939.1,435.083,938.683,436.614Z'
						transform='translate(-655.283 -110.729)'
						fill='#231f20'
					/>
					<path
						id='Path_146'
						data-name='Path 146'
						d='M928.02,435.1c-.113,1.126-.24,2.251-.375,3.37-.1.856-.2,1.711-.33,2.567-.075.533-.075,1.388-.518,1.764a2.788,2.788,0,0,1-2.829,0c-.21-.113-.4.21-.188.323a3.6,3.6,0,0,0,2.582.3,1.6,1.6,0,0,0,.946-.653,2.564,2.564,0,0,0,.255-.886c.3-1.741.48-3.512.668-5.253.06-.5.113-1.013.165-1.5a.188.188,0,0,0-.375,0Z'
						transform='translate(-652.53 -111.151)'
						fill='#231f20'
					/>
					<path
						id='Path_147'
						data-name='Path 147'
						d='M916.987,448.926a7.378,7.378,0,0,0,1.711,2.859,3.9,3.9,0,0,0,4.75.75,3.361,3.361,0,0,0,1.051-.953c.128-.2-.2-.39-.323-.2a3.2,3.2,0,0,1-3,1.253,4.573,4.573,0,0,1-3.415-2.777,7.316,7.316,0,0,1-.443-1.028c-.075-.233-.435-.135-.36.1Z'
						transform='translate(-650.848 -114.582)'
						fill='#231f20'
					/>
					<path
						id='Path_148'
						data-name='Path 148'
						d='M910.208,436.784c-.66,1.5-2.957,1.989-5.141,1.043s-3.407-2.942-2.747-4.465,2.957-1.981,5.141-1.043S910.868,435.268,910.208,436.784Z'
						transform='translate(-647.153 -110.373)'
						fill='#c3996c'
					/>
					<path
						id='Path_149'
						data-name='Path 149'
						d='M936.327,443.724c-2.251-.645-4.5.128-4.953,1.719s1.043,3.415,3.325,4.06a5.554,5.554,0,0,0,2.679.1c.608-1.358,1.163-2.762,1.651-4.188A5.306,5.306,0,0,0,936.327,443.724Z'
						transform='translate(-654.427 -113.283)'
						fill='#c3996c'
					/>
					<path
						id='Path_150'
						data-name='Path 150'
						d='M1066.8,667.859c12.758-21.809,13.6-53.434-6.807-62.522s-38.4,1.636-45.269,48.12-13.141,73.216-23.948,91.625-8.6,44.008,4.105,46.815,29.546,6.4,33.531,3.595S1026.786,736.279,1066.8,667.859Z'
						transform='translate(-667.543 -152.929)'
						fill='#e19f1c'
					/>
					<path
						id='Path_151'
						data-name='Path 151'
						d='M1015.077,654.632a291.742,291.742,0,0,0,7.5,28.826c4.21,12.593,10.447,22.972,16.428,27.82s4.465,11.317-6.919,12.645-20.105.608-25.794-11.257-9.276-12.758-15.22-17.261c-5.621-4.2-7.79-11.257.2-24.24s7.94-19.392,7.752-24.165Z'
						transform='translate(-668.09 -164.063)'
						fill='#b77408'
						opacity='0.24'
					/>
					<path
						id='Path_152'
						data-name='Path 152'
						d='M1149.513,673.829a337.247,337.247,0,0,1-6.934-34.664c2.529-1.156,3.82-1.831,2.251-5.959-1.816-4.81-4.068-12.856-6.874-14.161a.931.931,0,0,0-.886.052c-2-10.9-14-26.124-16.18-35.437-.42-1.794,1.846-3.22,1.366-5.133-8.645-1.321-14.259-4.946-29.066-1.066,2.642,8.015,8.113,22.852,14.859,31.122a74.366,74.366,0,0,1,9.9,15.76c-2.364-1.741-3.5,2.161-1.028,6.634s1.779,8.21,2,10.049c.173,1.4.8,2.1,3.46,2.409a24.483,24.483,0,0,1,.893,7.767c-.338,6.079-2.326,8.473-5.7,11.917s-4.976,12.008,4.818,20.263,11.1,17.876,12.878,24.631c1.576,6,6.4,11.325,12.27,10.507.353-2.094.668-4.39.953-6.927.916-8.128,1.9-18.837,2.829-30.312C1150.774,678.745,1150.166,676.253,1149.513,673.829Z'
						transform='translate(-694.825 -146.276)'
						fill='#b77408'
						opacity='0.24'
					/>
					<path
						id='Path_153'
						data-name='Path 153'
						d='M1051.89,524.269s18.762-10.2,34.807-6.8,22.807,22.807,28.008,37.208,16.405,51.032,16.405,51.032l-17.4,6.919s-4.405-11.017-15.61-22.319-22-37.764-22-37.764'
						transform='translate(-684.52 -131.568)'
						fill='#a87150'
					/>
					<path
						id='Path_154'
						data-name='Path 154'
						d='M1136.645,654.362a30.976,30.976,0,0,1,3.8,12.06c.6,6.807-1,9.8-3.8,14.206s-3.069,14.206,7.865,21.606,13.741,18.011,16.51,25.208,9.6,12.8,16,8.4.405-29.606-7.2-48.781-14-43.94-14-43.94Z'
						transform='translate(-705.26 -163.095)'
						fill='#fff'
					/>
					<path
						id='Path_155'
						data-name='Path 155'
						d='M1158.271,654.377l1.028-.75c-1.816-6.3-2.9-10.507-2.9-10.507l-19.2,11.257a30.66,30.66,0,0,1,2.949,7.295,29.651,29.651,0,0,0,3.2-.345C1148.672,660.516,1155.2,656.779,1158.271,654.377Z'
						transform='translate(-705.804 -163.095)'
						fill='#ddd'
						opacity='0.52'
					/>
					<path
						id='Path_156'
						data-name='Path 156'
						d='M1140.946,631.045c-4.158,2.694-9.336,3.069-11.932,1.5s-3.137,3,0,7.5,3,8.8,3.527,10.8,1.606,2.537,6.934,1.734,11.872-4.5,14.942-6.934,5.066-2.9,2.529-7.917-6-13.554-9.006-14.514C1146.184,622.7,1145.877,627.841,1140.946,631.045Z'
						transform='translate(-703.226 -158.12)'
						fill='#fff'
					/>
					<path
						id='Path_157'
						data-name='Path 157'
						d='M980.43,520.336s14.417-20.4,29.021-26.2,32.21,1.411,30.807,24.908-20.608,68.518-20.2,78.124l-21.764-1.7a148.764,148.764,0,0,1,.916-36.51c3-20.008,10.4-22.807,11.6-33.411'
						transform='translate(-666.688 -125.444)'
						fill='#a87c50'
					/>
					<path
						id='Path_158'
						data-name='Path 158'
						d='M1014.6,651.33s-1.606,17.261,1.4,29.884,8,23.2,13.208,28.413,3.175,9.6-7.5,10-16.766-3.362-21.171-15.37S991,695.247,985.8,690.414c-4.916-4.5-6.4-11.6,2-23.6s8.833-18.274,9.006-22.942Z'
						transform='translate(-667.032 -163.282)'
						fill='#fff'
					/>
					<path
						id='Path_159'
						data-name='Path 159'
						d='M999.66,653.1c.488.2,1.021.405,1.659.63,4.608,1.621,11.827,3.932,17.411,3,.128-3.257.323-5.358.323-5.358l-17.794-7.46a29.687,29.687,0,0,1-1.6,9.186Z'
						transform='translate(-671.487 -163.292)'
						fill='#ddd'
						opacity='0.52'
					/>
					<path
						id='Path_160'
						data-name='Path 160'
						d='M1002.182,620.86s-3.159.4-3.557,4.8.4,8.826,0,12.916-2.507,4.735,3.948,7.009,18.934,6.169,19.737-2.034c.653-6.687,6.267-17.914,3.325-20.4C1021.26,623.156,1011.188,628.86,1002.182,620.86Z'
						transform='translate(-671.068 -157.54)'
						fill='#fff'
					/>
					<rect
						id='Rectangle_19'
						data-name='Rectangle 19'
						width='90.154'
						height='9.508'
						rx='1.37'
						transform='translate(108.757 284.587)'
						fill='#c6764a'
						opacity='0.11'
					/>
					<rect
						id='Rectangle_20'
						data-name='Rectangle 20'
						width='90.154'
						height='9.508'
						rx='1.37'
						transform='translate(105.71 281.6)'
						fill='#e0a171'
					/>
					<path
						id='Path_161'
						data-name='Path 161'
						d='M786.372,476.617l-9.636-1.283s-4.675-3.4-4.675-9.006V446.26l16.51,13.464Z'
						transform='translate(-614.695 -113.973)'
						fill='#aa8d7e'
						opacity='0.32'
					/>
					<path
						id='Path_162'
						data-name='Path 162'
						d='M802.849,451.967v11.527a11.933,11.933,0,0,1-5.118,9.8,11.73,11.73,0,0,1-6.184,2.146H788.41a12.008,12.008,0,0,1-11.97-11.97V441.55l4.8,1.906,8.405,3.317Z'
						transform='translate(-615.787 -112.798)'
						fill='#aa8d7e'
					/>
					<path
						id='Path_163'
						data-name='Path 163'
						d='M807.23,453.7v11.527a11.933,11.933,0,0,1-5.118,9.8c-.42-.165-.818-.353-1.2-.548A13.276,13.276,0,0,1,794,462.6V448.51Z'
						transform='translate(-620.169 -114.534)'
						fill='#ccb3a8'
					/>
					<path
						id='Path_164'
						data-name='Path 164'
						d='M791.547,475.441H788.41a12.008,12.008,0,0,1-11.97-11.97V441.55l4.8,1.906v19.107a14.034,14.034,0,0,0,3.512,9.478,9.689,9.689,0,0,0,6.8,3.4Z'
						transform='translate(-615.787 -112.798)'
						fill='#997f73'
					/>
					<path
						id='Path_165'
						data-name='Path 165'
						d='M673.911,445.57H646.489c-1.036,0-1.974,1.088-2.379,2.754l-6.454,26.439c-.36,1.5.263,3.129,1.186,3.129h42.687c.916,0,1.546-1.651,1.178-3.129l-6.447-26.439C675.847,446.643,674.909,445.57,673.911,445.57Z'
						transform='translate(-581.131 -113.801)'
						fill='#fff'
					/>
					<path
						id='Path_166'
						data-name='Path 166'
						d='M675.9,446.211q1.929,1.043,3.955,1.914a12.607,12.607,0,0,0,4.781,1.246c1.658,0,5.1.645,6-.75s-.923-4.78-2.289-5.726a5.934,5.934,0,0,0-2.176-.75,36.361,36.361,0,0,1-5.884-1.764'
						transform='translate(-590.7 -112.506)'
						fill='#448933'
					/>
					<path
						id='Path_167'
						data-name='Path 167'
						d='M649.7,434.106c-2.357-1.5-9.088-7.82-10.267-10.364a11.639,11.639,0,0,1-.24-7.692c.533-2.064,3.752-6.679,4.9-6.927s3.159,1.734,4.173,3.685c.833,1.606.578,3.535.338,5.321a22.1,22.1,0,0,0-.24,6.086,8.135,8.135,0,0,0,2.747,5.291'
						transform='translate(-581.408 -104.701)'
						fill='#448933'
					/>
					<path
						id='Path_168'
						data-name='Path 168'
						d='M655.212,420.634c-.533-3.46-1.058-7.024-.068-10.3a8.715,8.715,0,0,1,7.752-6.349,1.4,1.4,0,0,1,.585.075,1.321,1.321,0,0,1,.5.458,15.416,15.416,0,0,1,2.957,7.167,27.052,27.052,0,0,1,0,5.171q-.165,2.9-.353,5.794'
						transform='translate(-585.382 -103.424)'
						fill='#448933'
					/>
					<path
						id='Path_169'
						data-name='Path 169'
						d='M669.9,424.164c-.751-2.176,0-4.758.75-7.092l2.747-8.713a10.371,10.371,0,0,1,1.268-2.934,2.724,2.724,0,0,1,2.477-1.336,2.957,2.957,0,0,1,1.628,1.208c3.617,4.54,3.82,12.308.465,17.831'
						transform='translate(-589.125 -103.449)'
						fill='#448933'
					/>
					<path
						id='Path_170'
						data-name='Path 170'
						d='M679.474,424.829l5.433-10.507a9.269,9.269,0,0,1,1.606-2.424,2.762,2.762,0,0,1,4.8,1.088,8.846,8.846,0,0,1,.375,3.077c0,3.692-.308,7.692-2.724,10.507a14.845,14.845,0,0,1-4.105,3.047,20.826,20.826,0,0,1-8.353,3'
						transform='translate(-590.852 -105.15)'
						fill='#448933'
					/>
					<path
						id='Path_171'
						data-name='Path 171'
						d='M677,435.8a6.063,6.063,0,0,0,4.9-1.1c1.313-.848,3.857-3.092,5.193-3.647,3.49-1.456,9.006-1.5,9.824.083,1,1.854,0,4.833-.878,6.259-1.388,2.3-5.7,3-8.5,3.054a25.682,25.682,0,0,1-10.281-2.086'
						transform='translate(-590.975 -109.905)'
						fill='#6aba56'
					/>
					<path
						id='Path_172'
						data-name='Path 172'
						d='M655.412,442.315a5.891,5.891,0,0,1-5.253,2.139c-4.585-.75-7.752-1.171-11.527-3.872s-7.617-7.077-6.679-11.632c.405-1.951,1.816-4.293,3.392-4.668s4.173,3.077,5.508,5.163a89.142,89.142,0,0,0,6.582,8.255,16.509,16.509,0,0,0,4.03,2.874,2.529,2.529,0,0,0,2.544-.443'
						transform='translate(-579.698 -108.481)'
						fill='#6aba56'
					/>
					<path
						id='Path_173'
						data-name='Path 173'
						d='M661.382,437.37c-1.036-3-3.94-10.979-3.677-14.154a11.127,11.127,0,0,1,4.27-8.21,1.636,1.636,0,0,1,2.251.608c1.7,2.589,2.086,4.811,2.514,7.94s-.54,10.447-2.3,13'
						transform='translate(-586.156 -106.118)'
						fill='#55aa43'
					/>
					<path
						id='Path_174'
						data-name='Path 174'
						d='M659.581,436.863c-4.36-.968-8.653-2.814-11.017-6.6s-4.18-9.006-1.321-12.443a4.391,4.391,0,0,1,2.251-1.591,4.57,4.57,0,0,1,3.752,1.171A10.2,10.2,0,0,1,657,423.767c.248,1.561.12,3.152.285,4.721a26.064,26.064,0,0,0,1.7,6.259c.263.75.848,1.606,1.561,1.336'
						transform='translate(-583.185 -106.467)'
						fill='#6aba56'
					/>
					<path
						id='Path_175'
						data-name='Path 175'
						d='M664.61,436.562a135.767,135.767,0,0,0,5.088-14.814c.578-2.7,1.771-5.561,4.06-6.807a2.371,2.371,0,0,1,2.011-.278c.488.21,2.2,1.3,3,4.5a10.1,10.1,0,0,1-.1,4.563c-.75,3.475-5.741,14.372-12.758,13.223'
						transform='translate(-587.883 -106.061)'
						fill='#6aba56'
					/>
					<path
						id='Path_176'
						data-name='Path 176'
						d='M652.388,446c-2.2.668-4.308,1.869-6.6,2-6.244.375-2.5,4.255-2.334,4.383,1.756,1.4,5.764,1.929,9.584,1.336,3-.458,6.589-4.435,6.116-7.355'
						transform='translate(-582.288 -113.908)'
						fill='#448933'
					/>
					<path
						id='Path_177'
						data-name='Path 177'
						d='M664.2,445.527a14.174,14.174,0,0,0,.06,6.124,4.893,4.893,0,0,0,3.077,2.874c1.4.5,3.813,1.7,5.253,1.621s2.1-1.463,3.054-2.454a5.336,5.336,0,0,0,.916-4.893,5.95,5.95,0,0,0-1.824-2.056,37.679,37.679,0,0,0-5.6-3.752'
						transform='translate(-587.703 -113.157)'
						fill='#448933'
					/>
					<path
						id='Path_178'
						data-name='Path 178'
						d='M667.209,439.717a11.437,11.437,0,0,0,12.008-5.021,8.953,8.953,0,0,0,.983-7.685c-.75-1.981-2.747-3.7-4.818-3.265a4.543,4.543,0,0,0-3.122,3.317,18.323,18.323,0,0,0-.435,4.758,8.8,8.8,0,0,1-1.876,4.24c-.886,1.291-4.2,2.807-5.629,2.356'
						transform='translate(-587.811 -108.338)'
						fill='#55aa43'
					/>
					<path
						id='Path_179'
						data-name='Path 179'
						d='M659.308,440.7a3.918,3.918,0,0,1,1.5.871,1.884,1.884,0,0,1,.57,1.666,2.514,2.514,0,0,1-.608,1.051,8.893,8.893,0,0,1-9.9,2.184,7.017,7.017,0,0,1-4.12-4.128,3.361,3.361,0,0,1-.15-1.741c.293-1.343,1.238-3.445,4.038-2.364a10.326,10.326,0,0,1,1.621.75c1.794,1.051,5.253,2.724,7.024,1.689'
						transform='translate(-583.377 -111.897)'
						fill='#55aa43'
					/>
					<path
						id='Path_180'
						data-name='Path 180'
						d='M666.252,440.851a4.18,4.18,0,0,0-1.749.54,1.809,1.809,0,0,0-.893,1.5,2.477,2.477,0,0,0,.45,1.156,9.959,9.959,0,0,0,9.951,4.173,7.16,7.16,0,0,0,5.051-3.2c.285-.518,2.544-5.719-.375-5.944-.4,0-4.2,1.336-4.8,1.5-2.056.675-6,1.614-7.64.233'
						transform='translate(-587.633 -112.181)'
						fill='#6aba56'
					/>
					<rect
						id='Rectangle_21'
						data-name='Rectangle 21'
						width='155.243'
						height='10.589'
						rx='1.5'
						transform='translate(43.834 362.141)'
						fill='#e0a171'
					/>
					<circle
						id='Ellipse_7'
						data-name='Ellipse 7'
						cx='48.743'
						cy='48.743'
						r='48.743'
						transform='translate(11.263 183.461)'
						fill='#c6764a'
						opacity='0.11'
					/>
					<circle
						id='Ellipse_8'
						data-name='Ellipse 8'
						cx='48.743'
						cy='48.743'
						r='48.743'
						transform='matrix(0.227, -0.974, 0.974, 0.227, 0, 265.375)'
						fill='#f7eeff'
					/>
					<path
						id='Path_181'
						data-name='Path 181'
						d='M620.688,274.925a.661.661,0,0,1-.563-.323l-4.855-8.255a.645.645,0,0,1,.225-.886.66.66,0,0,1,.893.233l4.856,8.255a.646.646,0,0,1-.2.9.616.616,0,0,1-.36.075Z'
						transform='translate(-575.549 -68.837)'
						fill='#e0a171'
					/>
					<path
						id='Path_182'
						data-name='Path 182'
						d='M662.768,347.827a.653.653,0,0,1-.563-.315l-4.856-8.255a.645.645,0,0,1,.225-.886.66.66,0,0,1,.893.233l4.856,8.255a.661.661,0,0,1-.233.893A.631.631,0,0,1,662.768,347.827Z'
						transform='translate(-586.049 -87.03)'
						fill='#e0a171'
					/>
					<path
						id='Path_183'
						data-name='Path 183'
						d='M658.195,275.066a.631.631,0,0,1-.323-.083.653.653,0,0,1-.24-.886l4.758-8.308a.638.638,0,0,1,.886-.24.653.653,0,0,1,.24.886l-4.773,8.308a.646.646,0,0,1-.548.323Z'
						transform='translate(-586.121 -68.858)'
						fill='#e0a171'
					/>
					<path
						id='Path_184'
						data-name='Path 184'
						d='M615.655,347.737a.63.63,0,0,1-.323-.083.653.653,0,0,1-.24-.885l4.773-8.308a.645.645,0,0,1,.885-.24.653.653,0,0,1,.24.886l-4.773,8.308a.645.645,0,0,1-.563.323Z'
						transform='translate(-575.506 -86.993)'
						fill='#e0a171'
					/>
					<path
						id='Path_185'
						data-name='Path 185'
						d='M670.965,289.006a.653.653,0,0,1-.338-1.208l8.255-4.908a.645.645,0,0,1,.886.225.66.66,0,0,1-.225.893l-8.255,4.908A.66.66,0,0,1,670.965,289.006Z'
						transform='translate(-589.307 -73.185)'
						fill='#e0a171'
					/>
					<path
						id='Path_186'
						data-name='Path 186'
						d='M598.285,331.535a.638.638,0,0,1-.555-.315.653.653,0,0,1,.225-.893l8.255-4.908a.648.648,0,0,1,.668,1.111l-8.255,4.916a.66.66,0,0,1-.338.09Z'
						transform='translate(-571.172 -83.797)'
						fill='#e0a171'
					/>
					<path
						id='Path_187'
						data-name='Path 187'
						d='M679.334,331.288a.63.63,0,0,1-.323-.083l-8.33-4.728a.647.647,0,1,1,.638-1.126l8.33,4.728a.645.645,0,0,1-.315,1.208Z'
						transform='translate(-589.316 -83.782)'
						fill='#e0a171'
					/>
					<path
						id='Path_188'
						data-name='Path 188'
						d='M606.434,289.123a.6.6,0,0,1-.315-.1l-8.338-4.728a.647.647,0,1,1,.638-1.126l8.338,4.728a.645.645,0,0,1,.248.878A.653.653,0,0,1,606.434,289.123Z'
						transform='translate(-571.125 -73.257)'
						fill='#e0a171'
					/>
					<path
						id='Path_189'
						data-name='Path 189'
						d='M636.763,263.18h.1c.315.075.48.233.48.48v6.559q-.09.5-.518.5h-.038q-.5-.105-.5-.473v-5.816a1.793,1.793,0,0,1-.518.113c-.24,0-.4-.165-.473-.48v-.12c0-.263.293-.458.878-.578Z'
						transform='translate(-580.569 -68.29)'
						fill='#e0a171'
					/>
					<path
						id='Path_190'
						data-name='Path 190'
						d='M641.159,263.19a2.319,2.319,0,0,1,2.342,2.319,2.769,2.769,0,0,1-1.013,2.041l-1.891,2.161H643.1c.27,0,.435.158.488.488v.045c-.045.338-.218.5-.51.5h-3.707c-.33-.06-.5-.225-.5-.51h0c0-.165.135-.368.4-.615l2.942-3.355a1.193,1.193,0,0,0,.218-.705,1.231,1.231,0,0,0-.908-1.208,1.067,1.067,0,0,0-.33-.045h-.053a1.231,1.231,0,0,0-1.193.886,3.049,3.049,0,0,0-.068.488.571.571,0,0,1-.5.375h-.052q-.5-.09-.5-.5a2.327,2.327,0,0,1,1.156-2,2.507,2.507,0,0,1,1.163-.375Z'
						transform='translate(-581.453 -68.292)'
						fill='#e0a171'
					/>
					<path
						id='Path_191'
						data-name='Path 191'
						d='M639.834,345.934h.2a2.251,2.251,0,0,1,1.891,1.111,2.431,2.431,0,0,1,.345,1.2,2.3,2.3,0,0,1-1.051,1.929,2.251,2.251,0,0,1-1.238.39h-.1a2.327,2.327,0,0,1-1.7-3.842l2.064-3.557a.75.75,0,0,1,.39-.135q.383,0,.5.518a2.883,2.883,0,0,1-.48.968Zm-1.148,2.251v.18a1.208,1.208,0,0,0,.8,1.088,2.355,2.355,0,0,0,.458.09,1.253,1.253,0,0,0,1.216-.893l.053-.33v-.06a1.223,1.223,0,0,0-.961-1.216h-.338a1.253,1.253,0,0,0-1.193.916Z'
						transform='translate(-581.148 -88.214)'
						fill='#e0a171'
					/>
					<path
						id='Path_192'
						data-name='Path 192'
						d='M598.789,307.515a2.319,2.319,0,0,1-1.9-1.246,2.387,2.387,0,0,1-.27-1.066,2.251,2.251,0,0,1,1.253-2.034,2.363,2.363,0,0,1,1.066-.27,2.289,2.289,0,0,1,1.981,1.156,2.432,2.432,0,0,1,.323,1.148,2.575,2.575,0,0,1-.7,1.681l-2.537,3.407a.638.638,0,0,1-.368.135c-.338-.068-.51-.24-.51-.525a2.515,2.515,0,0,1,.63-1Zm-1.133-2.387v.165a1.216,1.216,0,0,0,.75,1.073,1.254,1.254,0,0,0,.518.1,1.238,1.238,0,0,0,1.246-1.246h0a1.223,1.223,0,0,0-.9-1.2.924.924,0,0,0-.323-.045h-.113a1.216,1.216,0,0,0-1.1.81A1.325,1.325,0,0,0,597.656,305.129Z'
						transform='translate(-570.917 -78.201)'
						fill='#e0a171'
					/>
					<path
						id='Path_193'
						data-name='Path 193'
						d='M680.147,302.92a2,2,0,0,1,1.583.818,1.854,1.854,0,0,1,.375,1.118v.075a1.726,1.726,0,0,1-.593,1.373,2.116,2.116,0,0,1,.893,1.809,2.311,2.311,0,0,1-2.3,2.319h-.052a2.319,2.319,0,0,1-2.116-1.4,2.86,2.86,0,0,1-.18-.931c0-.263.18-.42.533-.488s.458.173.51.518a1.3,1.3,0,0,0,.751,1.163,1.554,1.554,0,0,0,.54.1,1.231,1.231,0,0,0,1.148-.8,1.1,1.1,0,0,0,.09-.4v-.15a1.223,1.223,0,0,0-.8-1.1l-.638-.135a.593.593,0,0,1-.278-.465h0c0-.338.225-.51.668-.51a.916.916,0,0,0,.645-.42,1.277,1.277,0,0,0,.128-.51.893.893,0,0,0-.525-.811.848.848,0,0,0-.42-.1.885.885,0,0,0-.863.645c-.045.443-.12.66-.21.66a.435.435,0,0,1-.345.15q-.518-.113-.518-.473v-.09a1.936,1.936,0,0,1,1.066-1.711A2.251,2.251,0,0,1,680.147,302.92Z'
						transform='translate(-591.164 -78.206)'
						fill='#e0a171'
					/>
					<path
						id='Path_194'
						data-name='Path 194'
						d='M637.9,305.636a.645.645,0,0,1-.473-.2l-20.728-21.7a.653.653,0,0,1,.938-.9l20.728,21.7a.646.646,0,0,1,0,.916.631.631,0,0,1-.465.18Z'
						transform='translate(-575.893 -73.155)'
						fill='#e0a171'
					/>
					<path
						id='Path_195'
						data-name='Path 195'
						d='M633.951,308.356a.645.645,0,0,1-.3-1.223l17.329-8.908a.653.653,0,1,1,.593,1.156l-17.328,8.9A.586.586,0,0,1,633.951,308.356Z'
						transform='translate(-580.068 -77.008)'
						fill='#e0a171'
					/>
					<g id='light' transform='translate(379.925, -10)'>
						<g>
							<line
								id='Line_8'
								data-name='Line 8'
								y1='179.783'
								transform='translate(37.404)'
								fill='none'
								stroke='#513703'
								strokeWidth='0.85'
							/>
							<path
								id='Path_196'
								data-name='Path 196'
								d='M1088.883,252.68s3.332-16,17.141-16,15.932,18.672,15.932,18.672,17.464,2.379,17.434,53.877c0,0-7.723,9.606-37.914,8.54s-31.265-6.934-32.33-10.672S1066.443,267.6,1088.883,252.68Z'
								transform='translate(-1068.619 -61.677)'
								fill='#218284'
							/>
							<ellipse
								id='Ellipse_9'
								data-name='Ellipse 9'
								cx='30.402'
								cy='6.859'
								rx='30.402'
								ry='6.859'
								transform='translate(4.984 240.031)'
								fill='#006b6c'
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const Search = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='18.313'
			height='18.317'
			viewBox='0 0 18.313 18.317'
		>
			<g id='Group_4' data-name='Group 4'>
				<path
					id='Path_2'
					data-name='Path 2'
					d='M25.124,23.589l-3.52-3.52A8.085,8.085,0,1,0,20.069,21.6l3.52,3.52a1.085,1.085,0,0,0,1.535-1.535Zm-14.1-4.231a5.894,5.894,0,1,1,4.168,1.727A5.9,5.9,0,0,1,11.022,19.359Z'
					transform='translate(-7.129 -7.125)'
					fill='#fff'
				/>
			</g>
		</svg>
	);
};

export const EdanraLogo = () => {
	return (
		<svg
			version='1.1'
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			x='0px'
			y='0px'
			viewBox='0 0 3000 3000'
			xmlSpace='preserve'
		>
			<path
				className='st0'
				d='M2181.2,2079.8L2181.2,2079.8c-62.1,0-112.4-50.3-112.4-112.4V605c0-62.1,50.3-112.4,112.4-112.4h0
	c62.1,0,112.4,50.3,112.4,112.4v1362.4C2293.6,2029.5,2243.3,2079.8,2181.2,2079.8z'
			/>
			<path
				className='st0'
				d='M1414.2,2456.6l-6.1-9.9c-30.8-50.2-15.2-115.8,35-146.6l660-405.7c50.2-30.8,115.8-15.2,146.6,35l6.1,9.9
	c30.8,50.2,15.2,115.8-35,146.6l-660,405.7C1510.7,2522.4,1445,2506.7,1414.2,2456.6z'
			/>
			<path
				className='st0'
				d='M1595.1,2450.1L1595.1,2450.1c-31.9,53.3-100.9,70.6-154.2,38.8l-677.6-405.3c-53.3-31.9-70.6-100.9-38.8-154.2
	l0,0c31.9-53.3,100.9-70.6,154.2-38.8l677.6,405.3C1609.6,2327.8,1627,2396.8,1595.1,2450.1z'
			/>
			<path
				className='st0'
				d='M1838.1,2079.8h-206.9c-4.9,0-8.9-4-8.9-8.9V927.8c0-4.9,4-8.9,8.9-8.9h206.9c4.9,0,8.9,4,8.9,8.9v1143.1
	C1847.1,2075.8,1843.1,2079.8,1838.1,2079.8z'
			/>
			<rect
				x='1164.4'
				y='918.9'
				className='st0'
				width='224.8'
				height='1161'
			/>
			<path
				className='st0'
				d='M818.8,2079.8L818.8,2079.8c-62.1,0-112.4-50.3-112.4-112.4V605c0-62.1,50.3-112.4,112.4-112.4h0
	c62.1,0,112.4,50.3,112.4,112.4v1362.4C931.2,2029.5,880.9,2079.8,818.8,2079.8z'
			/>
			<path
				className='st0'
				d='M2293.6,1954.6v25.6c0,55-44.6,99.6-99.6,99.6h-472.1c-55,0-99.6-44.6-99.6-99.6v-25.6
	c0-55,44.6-99.6,99.6-99.6H2194C2249,1855,2293.6,1899.6,2293.6,1954.6z'
			/>
			<path
				className='st0'
				d='M2293.6,601.2v16.4c0,55.1-44.7,99.8-99.8,99.8h-961.6c-55.1,0-99.8-44.7-99.8-99.8v-25.2
	c0-55.1,44.7-99.8,99.8-99.8H2185C2245,492.6,2293.6,541.2,2293.6,601.2z'
			/>
			<path
				className='st0'
				d='M1389.1,1945.6v43.6c0,50.1-40.6,90.6-90.6,90.6H797c-50.1,0-90.6-40.6-90.6-90.6v-43.6
	c0-50.1,40.6-90.6,90.6-90.6h501.5C1348.6,1855,1389.1,1895.6,1389.1,1945.6z'
			/>
			<path
				className='st0'
				d='M1852.6,1945.6v43.6c0,50.1-40.6,90.6-90.6,90.6h-501.5c-50.1,0-90.6-40.6-90.6-90.6v-43.6
	c0-50.1,40.6-90.6,90.6-90.6h501.5C1812,1855,1852.6,1895.6,1852.6,1945.6z'
			/>
			<path
				className='st0'
				d='M1852.6,2135.4v43.6c0,50.1-40.6,90.6-90.6,90.6h-501.5c-50.1,0-90.6-40.6-90.6-90.6v-43.6
	c0-50.1,40.6-90.6,90.6-90.6h501.5C1812,2044.8,1852.6,2085.4,1852.6,2135.4z'
			/>
			<path
				className='st0'
				d='M1389.1,605L1389.1,605c0,62.1-50.3,112.4-112.4,112.4H818.8c-62.1,0-112.4-50.3-112.4-112.4v0
	c0-62.1,50.3-112.4,112.4-112.4h457.9C1338.8,492.6,1389.1,542.9,1389.1,605z'
			/>
			<path
				className='st0'
				d='M1389.1,605L1389.1,605c0,62.1-50.3,112.4-112.4,112.4H818.8c-62.1,0-112.4-50.3-112.4-112.4v0
	c0-62.1,50.3-112.4,112.4-112.4h457.9C1338.8,492.6,1389.1,542.9,1389.1,605z'
			/>
		</svg>
	);
};

export const AboutBannerSvg = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			width='3499.88'
			height='1999.8'
			viewBox='0 0 3499.88 1999.8'
			preserveAspectRatio='xMidYMid slice'
		>
			<defs>
				<clipPath id='clipPath'>
					<rect
						id='Rectangle_200'
						data-name='Rectangle 200'
						width='3499.88'
						height='1999.8'
						transform='translate(0.12 0.2)'
						fill='#f7f3e1'
					/>
				</clipPath>
			</defs>
			<g id='about_2' transform='translate(-0.12 -0.2)'>
				<g id='Speech_Bubble' data-name='Speech Bubble'>
					<g>
						<rect
							id='Rectangle_199'
							data-name='Rectangle 199'
							width='3499.88'
							height='1999.8'
							transform='translate(0.12 0.2)'
							fill='#f7f3e1'
						/>
						<g
							id='Group_259'
							data-name='Group 259'
							clipPath='url(#clip-path)'
						>
							<path
								id='Path_609'
								data-name='Path 609'
								d='M3500,2000H0V0H3500V2000'
								fill='#f7f3e1'
							/>
						</g>
					</g>
					<g id='MAIN'>
						<path
							id='Path_610'
							data-name='Path 610'
							d='M3391.33,1901.81h0l-.08-407.13h.08v407.13m-1394.45,0H120.2V102.56H3391.33V486.35h-.08V105.88H1940.46L1809,290.82h187.93V987.3c-3-29.74-8-57.57-16.86-78-14.07-32.61-32.63-55.07-52-70.31-.15,0-15.63-12-15.73-12a39,39,0,0,1-11,1.5c-11.65,0-24.07-4.38-36.34-9.27-12.93-5.16-26.09-7.53-33.32-7.53-2.7,0-4.57.33-5.3,1-17.76,15.52-29.36,45.45-35.2,83.47-20.79,69.27-53.2,178.19-57.66,198.61-6.62,30.37,9.56,155,9.56,155a51.25,51.25,0,0,0,17.66,3.27h2c13.56-.64,27.34-5.08,27.34-5.08s7.47-101.21,10.74-132.17c5,50.94,7.15,90.74,7.87,107a9.83,9.83,0,0,0,5.79,8.51c-4,13.32-3.81,85.68-1.65,177.34-30.7,4.42-58.57,15.22-81.15,30.52a32.91,32.91,0,0,1-51.54-27.13V1288.71c0-121-95.47-220-212.16-220s-212.15,99-212.15,220h0c0,67.12-54.58,120.48-119.73,120.48a120.03,120.03,0,0,1-15.63-1,221.508,221.508,0,0,0-28.43-1.83h0c-93.59,0-170.15,58.74-170.15,130.54v23.26a11.93,11.93,0,0,1-8.74,11.49c5.57-91.91,11.42-272.92,12.07-293.28a7.68,7.68,0,0,0,4.23-6.09c1.13-11.12,2.93-35.38-.31-54.28-5.45-31.71,4.41-97.49,5.51-134.19a190.732,190.732,0,0,0-.78-20c5.92-2.66,14.54-3.66,14.54-3.66-11.1-85.47-27-85.78-27.2-85.78h0s-6.37-7-33.78-8.84c-1.33-.16-2.89-.34-4.68-.52h0c-15-18.86,13.65-108.43,13.65-108.43s-1.44-63.75-60.18-63.75a91.634,91.634,0,0,0-11.71.78c-70.28,9-76.18,101.13-62,131.84s-28.34,31.29-40.75,58.46,7.68,57.87,7.68,65.55-13.08,37.83,30.55,37.83h2.52c1.23,0,2.5-.06,3.8-.09,8.57,23,22.57,64.56,22.59,89.68a39.159,39.159,0,0,1-1.66,12.36c-7.89,22.92-19.49,64.94-19.49,80.92,0,4,.73,6.4,2.44,6.4,0,0-13.78,13.53-13.78,77.9v2.5c.09,15.63,2.08,42.42,5.26,75.65l.12,10.35c-30.63-22.6-72.18-36.54-117.78-36.54-43,0-82.36,12.39-112.39,32.74A32.91,32.91,0,0,1,480,1412V1288.71c0-121-95.47-220-212.16-220-57.17,0-109.23,23.77-147.48,62.24v768H1996.88v2.81'
							transform='translate(-1.55 0.07)'
							fill='#f7f3e1'
						/>
						<path
							id='Path_611'
							data-name='Path 611'
							d='M3391.33,1901.81H2916.49V480.57H2252.71V1901.81H1996.88V1899h17.28V1756.73c28.39,47,57.5,88.08,84.17,116.84l77.76-3.6s-139-581.32-159.17-630.61a7.228,7.228,0,0,0,3.34-1.69h0l.5-.07a8,8,0,0,0,1.92-4.95v-1.11a7.3,7.3,0,0,0-.58-2.2c-5.54-12.73-17.94-46.51-19.85-105v-.24c-.47-14.74-.64-32.72-1-52.19-.07-3.35-.14-6.75-.23-10.17-.58-24.1-1.62-49.94-4.08-74.48V290.82h1394.3v-.1h0V486.35H3002.68V1494.68h388.57v407.13'
							transform='translate(-1.55 0.07)'
							fill='#f2e9ca'
						/>
						<path
							id='Path_612'
							data-name='Path 612'
							d='M2914.94,1907.36H2251.16v-5.48h663.78v5.48'
							fill='#f7f3e1'
						/>
						<path
							id='Path_613'
							data-name='Path 613'
							d='M2916.49,1901.81H2252.71V480.57h663.78V1901.81M2281.9,506.93V1899.72h605.4V506.93H2281.9'
							transform='translate(-1.55 0.07)'
							fill='#ede2b8'
						/>
						<path
							id='Path_614'
							data-name='Path 614'
							d='M2885.75,1899.79h-605.4V507h605.4V1899.79'
							fill='#eadca9'
						/>
						<path
							id='Path_615'
							data-name='Path 615'
							d='M3391.37,1494.68h0V1476.3h.05v18.38m0-983.67h-.05V486.35h0V511'
							transform='translate(-1.55 0.07)'
							fill='#f7f3e1'
						/>
						<path
							id='Path_616'
							data-name='Path 616'
							d='M3391.33,1494.68h-.08V1476.3h.08v18.38m0-983.67h-.08V486.35h.08V511'
							transform='translate(-1.55 0.07)'
							fill='#f2e9ca'
						/>
						<path
							id='Path_617'
							data-name='Path 617'
							d='M3389.7,1494.75H3001.13V486.42H3389.7v24.66H3030.27v965.29H3389.7v18.38'
							fill='#ede2b8'
						/>
						<path
							id='Path_618'
							data-name='Path 618'
							d='M3389.83,1476.37h0l-.01-965.29h.01v965.29'
							fill='#f7f3e1'
						/>
						<path
							id='Path_619'
							data-name='Path 619'
							d='M3389.83,1476.37h-.05V511.08h.05l-.01,965.29'
							fill='#f2e9ca'
						/>
						<path
							id='Path_620'
							data-name='Path 620'
							d='M3389.78,1476.37h-.08V511.08h.08v965.29'
							fill='#ede2b8'
						/>
						<path
							id='Path_621'
							data-name='Path 621'
							d='M3389.7,1476.37H3030.27V511.08H3389.7v965.29'
							fill='#eadca9'
						/>
						<path
							id='Path_622'
							data-name='Path 622'
							d='M1995.33,290.89H1807.4l131.51-184.94H3389.69V290.79H1995.33v.1'
							fill='#ece0b3'
						/>
						<path
							id='Path_623'
							data-name='Path 623'
							d='M3389.69,290.89H1995.33v-.1H3389.7l-.01.1'
							fill='#e9dba5'
						/>
						<path
							id='Path_624'
							data-name='Path 624'
							d='M1996.88,1899H120.35V1131c38.25-38.47,90.31-62.24,147.48-62.24,116.69,0,212.16,99,212.16,220V1412a32.91,32.91,0,0,0,51.54,27.13c30-20.35,69.42-32.74,112.39-32.74,45.6,0,87.15,13.94,117.78,36.54.81,64.32,2.23,124.82-3.93,140.74-57.91,149.66-70.95,251.24-70.95,251.24l60.54,10.44,49.32-115.48c8.4,64.79,14.75,111.45,14.75,111.45l33.5-1.44h0l28.79-1.22s32.28-176.16,37.35-238c.66-8.08,1.33-17.92,2-29.06a11.91,11.91,0,0,0,8.74-11.49v-23.26c0-71.8,76.56-130.54,170.15-130.54h0a221.569,221.569,0,0,1,28.446,1.832,120.047,120.047,0,0,0,15.614,1c65.15,0,119.73-53.36,119.73-120.48h0c0-121,95.47-220,212.15-220s212.16,99,212.16,220V1412a32.91,32.91,0,0,0,51.54,27.13c22.58-15.3,50.45-26.1,81.15-30.52,4.5,190.72,17.35,465,17.35,465l89.75-.69c15-64.3,22.66-152.82,26.05-243.72,15.9,33.51,33.16,66.75,51,98.08V1899'
							transform='translate(-1.55 0.07)'
							fill='#f2e9ca'
						/>
						<path
							id='Path_625'
							data-name='Path 625'
							d='M2014.16,1899h-17.28V1727.24q8.56,15.06,17.28,29.49V1899'
							transform='translate(-1.55 0.07)'
							fill='#ede2b8'
						/>
						<path
							id='Path_626'
							data-name='Path 626'
							d='M3445.65,1899.51l-3352.08-.22c-4.2,0-7.64,3.15-7.64,7v.43c0,3.86,3.44,7,7.64,7l3352.08-.11a6.9,6.9,0,0,0,6.92-6.85v-.43a6.9,6.9,0,0,0-6.92-6.84Z'
							transform='translate(-1.55 0.07)'
							fill='#c58941'
						/>
						<path
							id='Path_627'
							data-name='Path 627'
							d='M1788,1233.85l-5,13.08s18.31,26.53-12.13,42.57c0,0-13.29,5.78-16-3.63s-.1-6-4.35-19.21-.94-26.18,8.54-31.06l6.65-8.86,22.3,7.11Z'
							transform='translate(-1.55 0.07)'
							fill='#9b6f46'
						/>
						<path
							id='Path_628'
							data-name='Path 628'
							d='M1899.57,823.29c2.67-29.12,1.52-46.17,1.52-46.17l-59-40.53c6.77,61.41-30.42,94-30.42,94s76.82,30.79,118.58,14a102.4,102.4,0,0,0-30.7-21.35Z'
							transform='translate(-1.55 0.07)'
							fill='#8c5f39'
						/>
						<path
							id='Path_629'
							data-name='Path 629'
							d='M1914.1,775.1s-69.78,17.14-79.79-26.48-25.75-70.78,18.38-83.57,56.64,1.86,63.52,15.61S1932,769.52,1914.1,775.1Z'
							transform='translate(-1.55 0.07)'
							fill='#9b6f46'
						/>
						<path
							id='Path_630'
							data-name='Path 630'
							d='M1837.84,758.87s-1.65-59.77,67-76.11c47.06-11.2,16.36-45.56,10.63-50.92,0,0-35.89,10-72.57,21.3-77,23.66-13.8,97.67-5.1,105.73Z'
							transform='translate(-1.55 0.07)'
							fill='#2e2d5d'
						/>
						<path
							id='Path_631'
							data-name='Path 631'
							d='M1833.39,1868.16l9.84,31.81,95.6-.61s-24.73-42.82-105.44-31.2Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_632'
							data-name='Path 632'
							d='M1940.85,1226s26.49,444-21,646.91l-89.75.69s-28.2-602-15.68-642.42l126.42-5.18'
							transform='translate(-1.55 0.07)'
							fill='#2e2d5d'
						/>
						<path
							id='Path_633'
							data-name='Path 633'
							d='M2104,1867.92l9.64,31.87h95.6S2184.79,1856.79,2104,1867.92Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_634'
							data-name='Path 634'
							d='M1814.43,1231.15s29.15,132.21,80.54,276.23c46.69,130.81,133.41,290.75,203.36,366.19l77.76-3.6s-140.81-589-159.55-631.51l-202.11-7.31'
							transform='translate(-1.55 0.07)'
							fill='#36367d'
						/>
						<path
							id='Path_635'
							data-name='Path 635'
							d='M2121.15,1834.19C2110,1776.9,2093.9,1710,2073.7,1641.32c-3.09-10.49-6.33-21.26-9.63-32-3.65-11.87-7.41-23.86-11.18-35.64-1.3-4-4-8.29-6.7-12.38-2.47-3.81-5-7.75-6.17-11.23-14.67-44.7-30-85-43.55-120.46q-5.33-14-10.4-27.38c-30.47-80.86-47.45-126.78-47.59-127.25.14.46,14.45,47.08,45,128q5.07,13.44,10.41,27.39c13.52,35.48,28.85,75.69,43.5,120.31,1.28,3.89,4,8,6.54,12s5.16,8,6.32,11.58c3.77,11.78,7.53,23.75,11.17,35.61,3.3,10.74,6.53,21.5,9.62,32,20.17,68.55,38.34,135.41,49.43,192.61l.73-.31Z'
							transform='translate(-1.55 0.07)'
							fill='#2e2d5d'
						/>
						<path
							id='Path_636'
							data-name='Path 636'
							d='M1951.5,1281.62c44.91,0,64.43-32.59,64.63-32.92l-2.08-1.21c-27.23,35.55-64.18,34.12-64.18,34.12Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_637'
							data-name='Path 637'
							d='M1762.67,1253c13.56-.64,27.34-5.08,27.34-5.08s9.45-128.1,11.75-140.16,80.17-167.07,80.17-167.07L1808.64,838s-68.55,226.41-75.18,256.79,9.56,155,9.56,155a51,51,0,0,0,19.65,3.22'
							transform='translate(-1.55 0.07)'
							fill='#b67538'
						/>
						<path
							id='Path_638'
							data-name='Path 638'
							d='M2022.68,1232.65a7.311,7.311,0,0,1-2.34,4.95l-.08.07a7.271,7.271,0,0,1-4.36,1.83c-29.41,2-116.27,5.15-199-7.53a9.82,9.82,0,0,1-8.33-9.26c-1-23.28-4.92-94.78-16.14-178.12-13.71-101.9-3.72-199.14,33.84-232,2.69-2.35,20.86-.53,38.62,6.56,16.23,6.47,32.71,12,47.35,7.77.1,0,15.58,12,15.73,12,19.37,15.24,37.93,37.7,52,70.31,16.11,37.32,19.66,99.2,20.94,152.5.09,3.42.16,6.82.23,10.17.38,19.47.55,37.45,1,52.19v.24c1.91,58.45,14.31,92.23,19.85,105a7.3,7.3,0,0,1,.58,2.2,10.231,10.231,0,0,1,0,1.11'
							transform='translate(-1.55 0.07)'
							fill='#c58941'
						/>
						<path
							id='Path_639'
							data-name='Path 639'
							d='M2020.26,1237.67h0l.08-.07a7.311,7.311,0,0,0,2.34-4.95h0a8,8,0,0,1-1.92,4.95l-.5.07h0'
							transform='translate(-1.55 0.07)'
							fill='#cda270'
						/>
						<path
							id='Path_640'
							data-name='Path 640'
							d='M1992.26,1239.84c-38.59,0-62.49-15-92.67-48.3-24.72-27.27-33.24-152.69-34.42-225.45-.41-25.93,17.07-43.94,35.52-43.94,7.64,0,15.43,3.08,22.2,9.94,28.18,28.58,57.57,79.61,78.07,129.69.09,3.42.16,6.82.23,10.17.38,19.47.55,37.45,1,52.19v.24c1.91,58.45,14.31,92.23,19.85,105a7.3,7.3,0,0,1,.58,2.2v1.11a7.311,7.311,0,0,1-2.34,5l-.08.07h0a201.885,201.885,0,0,1-28,2.17'
							transform='translate(-1.55 0.07)'
							fill='#bc7d3c'
						/>
						<path
							id='Path_641'
							data-name='Path 641'
							d='M2209.79,1126.44l19.05,4.16s32-20.21,61,9.47c0,0,11,13-1.23,16.44s-8.15.49-25.26,5.64-35.59,2.65-44.46-6.6l-13.67-6.13,4.53-23Z'
							transform='translate(-1.55 0.07)'
							fill='#9b6f46'
						/>
						<path
							id='Path_642'
							data-name='Path 642'
							d='M2221.26,1126.63l-1.57,14.95-1.67,15.83s-158.36-7.37-186.19-20.63c0,0-171.57-129.28-178.2-219.67-6-81.72,29.81-85.83,29.81-85.83s46.91-15.32,182,236.87c0,0,60.77,14.55,155.81,58.48Z'
							transform='translate(-1.55 0.07)'
							fill='#c58941'
						/>
						<path
							id='Path_643'
							data-name='Path 643'
							d='M2700.07,1865l-10.69,34.37H2583.32S2610.45,1853,2700.07,1865Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_644'
							data-name='Path 644'
							d='M2659.15,1179.75l190.67,32.1s-68.46,354.67-148,656l-96,2.8,53.37-690.89Z'
							transform='translate(-1.55 0.07)'
							fill='#2e2d5d'
						/>
						<path
							id='Path_645'
							data-name='Path 645'
							d='M2326.86,1122.47a3.73,3.73,0,1,1-2.864.157,3.74,3.74,0,0,1,2.864-.157Zm12.43,18.43a17.65,17.65,0,1,0-27.38,8.22L2293,1203.21s11.33,0,13.25-3.87,1.71-13,5.48-16.5,5.27-7.79,5.43-13.12,5.72-9.06,7.2-12.51a13.134,13.134,0,0,0,.73-4.65,17.63,17.63,0,0,0,14.18-11.66Z'
							transform='translate(-1.55 0.07)'
							fill='#b67538'
						/>
						<path
							id='Path_646'
							data-name='Path 646'
							d='M2331.5,1096.71a14.84,14.84,0,1,0,4.9.83A14.84,14.84,0,0,0,2331.5,1096.71Zm0,31a16.1,16.1,0,1,1,0-32.2,15.67,15.67,0,0,1,5.3.91,16.09,16.09,0,0,1-5.3,31.29Z'
							transform='translate(-1.55 0.07)'
							fill='#b67538'
						/>
						<path
							id='Path_647'
							data-name='Path 647'
							d='M2932.67,1863.62l-11.09,35.67H2811.51S2839.67,1851.17,2932.67,1863.62Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_648'
							data-name='Path 648'
							d='M2942.61,1866.46s-44.65-568.81-100.1-673.68l-156.35-.74,2.74,98.65s8.52,1.93,16.84,18.94l142.65,555.72,94.22,1.11Z'
							transform='translate(-1.55 0.07)'
							fill='#36367d'
						/>
						<path
							id='Path_649'
							data-name='Path 649'
							d='M2840.37,1266.45c-48.3,0-69.29-35-69.5-35.4l2.23-1.3c.1.17,15.63,18.15,32.39,27.22,17,9.19,35.17,9.48,34.88,9.48Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_650'
							data-name='Path 650'
							d='M2910.42,1817.52c-.92-51.6-4.75-112.37-11.86-175.24-1.09-9.61-2.26-19.49-3.49-29.37-1.36-10.89-2.81-21.91-4.3-32.75-.51-3.72-2.25-7.83-3.94-11.8-1.57-3.7-3.19-7.52-3.66-10.73-5.94-41.17-13.16-78.57-19.53-111.57q-2.51-13-4.87-25.44c-14.18-75.08-22-117.67-22-118.1,0,.42,5.39,43.21,19.59,118.4q2.35,12.46,4.88,25.45c6.36,33,13.57,70.33,19.51,111.43.51,3.59,2.21,7.59,3.86,11.46s3.27,7.72,3.73,11c1.49,10.83,2.93,21.84,4.29,32.72,1.23,9.86,2.41,19.73,3.49,29.33,7.1,62.79,12.71,123.8,13.63,175.31l.68-.15Z'
							transform='translate(-1.55 0.07)'
							fill='#2e2d5d'
						/>
						<path
							id='Path_651'
							data-name='Path 651'
							d='M2698.68,744.87s5.92,21.77,12,66.26c0,0,34.78,30.07,49.25,27.33,12.57-2.37,27.21-42.28,27.21-42.28s-13.85-19.68-27.54-75.67l-60.87,24.36Z'
							transform='translate(-1.55 0.07)'
							fill='#c09195'
						/>
						<path
							id='Path_652'
							data-name='Path 652'
							d='M2689.89,766.73s69.42,14.58,77.83-28.79,23-70.69-20.93-81.83-55.81,3.73-62.14,17.52-12.6,88.19,5.24,93.1Z'
							transform='translate(-1.55 0.07)'
							fill='#d4abaf'
						/>
						<path
							id='Path_653'
							data-name='Path 653'
							d='M2767.72,737.94s4.24-59-58.4-67.06-26.1-62.59,28.84-62.56c0,0-9,19.85,24.18,28.61,69.56,18.39,13.16,92.81,5.38,101Z'
							transform='translate(-1.55 0.07)'
							fill='#585c9c'
						/>
						<path
							id='Path_654'
							data-name='Path 654'
							d='M2407.78,1083.6l-20-4.46s-30.87-23.83-63.52,3.81c0,0-12.54,12.3-.32,17s8.3,1.29,25.35,8.22,36.25,6.16,46.25-2.46l24.88.18-12.65-22.27Z'
							transform='translate(-1.55 0.07)'
							fill='#d4abaf'
						/>
						<path
							id='Path_655'
							data-name='Path 655'
							d='M2852.32,1015.26c-.71-23.65-1.77-47.53-3-70.31-4.14-76.66-10.28-140.76-11.89-141.13a353.438,353.438,0,0,0-50.34-7.64c-12.61,7.43-36.23,19.85-52.31,19.4-13.36-.37-21.61-8.86-25.81-16.05-7.59,1.22-14.73,2.66-21.44,4.21-14.08,3-49.61,11.35-67.46,23.92-12.84,9-52.05,116.43-101.37,221.25,0,0-37.37,6.17-63.42,12.27-21.47,5-62.35,17.13-62.35,17.13l-.59,19.54-.32,10.6s45.57,13.21,86.92,9.46l2-.2.95-.1,2.12-.25c52.07-6.63,106.88-16.44,106.88-16.44l39.89-65.21c4.89,60.84,11.46,118.2,19.79,145,10.6,29.43,22,31.77,45.56,34.94,106.29,14.3,152.55-3.42,153.65-3.82,17.7-6.41,5.25-104.78,2.5-196.59Z'
							transform='translate(-1.55 0.07)'
							fill='#585c9e'
						/>
						<path
							id='Path_656'
							data-name='Path 656'
							d='M2852.32,1015.26c-17,7.77-50.19,19.85-51.6-3.13-1.9-31,23.36-81,33.37-82.94,5.83-1.12,11.52,8,15.23,15.76C2850.55,967.73,2851.61,991.61,2852.32,1015.26Z'
							transform='translate(-1.55 0.07)'
							fill='#515599'
						/>
						<path
							id='Path_657'
							data-name='Path 657'
							d='M2635.69,1027.74l-44.76,73.18s-54.81,9.81-106.88,16.44l-2.12.25-.95.1-2,.2c-41.35,3.75-86.92-9.46-86.92-9.46l.32-10.6c51.73-8.31,176.91-14.59,186.26-19.54,11.64-6.17,45.21-114.42,52.07-109.62,5,3.47,5.25,39,5,59Z'
							transform='translate(-1.55 0.07)'
							fill='#515599'
						/>
						<path
							id='Path_658'
							data-name='Path 658'
							d='M2925.61,1168.56l-141.73,62.75-83.5-188.63,141.73-62.74,83.5,188.62Z'
							fill='#b65c32'
						/>
						<path
							id='Path_659'
							data-name='Path 659'
							d='M2791.75,1109.82l-5.07,6.3s-34.73-18.25-62.28,14.8c0,0-10.29,14.36,2.62,16.88s8.45-.16,26.55,3.75,37-.18,45.41-10.46l9.27-11.48-16.5-19.79Z'
							transform='translate(-1.55 0.07)'
							fill='#d4abaf'
						/>
						<path
							id='Path_660'
							data-name='Path 660'
							d='M2787.72,796.18s72.29.58,82,7.73S2976,971.21,2977.56,1032.7c0,0-59.95,63.32-169.45,100.5l-21.93-22.2s82.56-83.49,121.92-98.74c0,0-65.13-66.1-79.44-101.69s-40.94-114.42-40.94-114.42Z'
							transform='translate(-1.55 0.07)'
							fill='#585c9e'
						/>
						<path
							id='Path_661'
							data-name='Path 661'
							d='M435.65,1878.06l5.89,21.27h49.78s14.82-27.2-55.67-21.27Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_662'
							data-name='Path 662'
							d='M305.4,1878.06l5.89,21.27h49.79s14.82-27.2-55.68-21.27Z'
							transform='translate(-1.55 0.07)'
							fill='#262350'
						/>
						<path
							id='Path_663'
							data-name='Path 663'
							d='M476.2,1551.21,381.76,1559s-11.09,165.64,51,319.2l52.92-1-9.44-326Z'
							transform='translate(-1.55 0.07)'
							fill='#2e2d5d'
						/>
						<path
							id='Path_664'
							data-name='Path 664'
							d='M329.64,1560.73s-8.06,57.54-14.71,164.86c-1.26,20.32-17.37,68.11-17.37,154h59.15l49-151.51,13.33-116c1.17-7.92,16.07-19,16.07-19l.58-30.57-106-1.93Z'
							transform='translate(-1.55 0.07)'
							fill='#36367e'
						/>
						<path
							id='Path_665'
							data-name='Path 665'
							d='M338.57,1234.19c-3.25-14.1.76-24.51,7.23-34.54,6.21-9.62,14.93-10,23.31-18.18,7.89-7.66,22.6-12.71,34.31-12.71,37.46,0,69.9,22.94,62.5,61.83-2.35,12.36-.36,22.09-10.38,36.54-12.5,18-27.7,32.49-52.12,32.49-13,0-24.32-3-34.31-12.43-5.44-5.14-13.24-5.78-18-11.38-9.68-11.31-9-26.21-12.51-41.62Z'
							transform='translate(-1.55 0.07)'
							fill='#585c9e'
						/>
						<path
							id='Path_666'
							data-name='Path 666'
							d='M431.93,1318.43c-8.46-15.19-2.53-38.18-2.53-38.18l-38-19.48c2.42,33.61-9.6,56.24-9.6,56.24l.53,1.83c-4.46.46-9.19,1-14.23,1.73,0,0,32.53,25.23,45.49,24.86,10.36-.29,35.21-21.91,35.21-21.91s-3.91-3.24-16.83-5.09Z'
							transform='translate(-1.55 0.07)'
							fill='#8d5f38'
						/>
						<path
							id='Path_667'
							data-name='Path 667'
							d='M430.61,1296.25s-47.79,5.82-48.81-27.85,18.9-55.47,32.19-55.23c26.51.5,30.89,11.22,34,22.37s4.66,58.34-17.34,60.71Z'
							transform='translate(-1.55 0.07)'
							fill='#9c6f46'
						/>
						<path
							id='Path_668'
							data-name='Path 668'
							d='M417.82,1276.84s1,4.2,11.51,3.43c0,0,8.79-.65,8.47-5.27,0,0-8.57-3.19-20,1.84Z'
							transform='translate(-1.55 0.07)'
							fill='#fff'
						/>
						<path
							id='Path_669'
							data-name='Path 669'
							d='M425.82,1213.49s-40.84,0-31.46,28c5.92,17.67-13.75,20.42-13.75,20.42s-12.18-21.37-9.46-28.32c13.15-33.67,54.67-20.11,54.67-20.11Z'
							transform='translate(-1.55 0.07)'
							fill='#585c9e'
						/>
						<path
							id='Path_670'
							data-name='Path 670'
							d='M448.76,1323.52s27.59,5.91,33.41,14.42,9,93.91,9,109.79c0,0,35.74,10.9,42,16.27L530,1476.66s-56.21-9.8-59.79-17.44-20.47-89-20.47-89l-1-46.69Z'
							transform='translate(-1.55 0.07)'
							fill='#8d5f38'
						/>
						<path
							id='Path_671'
							data-name='Path 671'
							d='M493,1395.3s-1-50.33-12.74-60.49c0,0-8.66-5.45-15.9-7.84h0a152.812,152.812,0,0,0-31.61-8.42c.21,6.72-2.46,12.83-14.24,14.38-15.68,2-29.68-8.66-36.78-15.92-18.54,2.66-38.76,8.71-61,20l6.71,55.86,8.11,67.39-5.89,99.06-.06.89s86.4,16.79,146.6-9.5l-4-149.34c5.34-1.72,19.57-6.25,20.84-6.07Z'
							transform='translate(-1.55 0.07)'
							fill='#ba6533'
						/>
						<path
							id='Path_672'
							data-name='Path 672'
							d='M366,1556.13c-4.08,5.12-24.22,6.91-36.31,3.21l5.89-99.06-8.11-67.39s44.57,9.13,38.2,45.94c-3.81,22,5.59,110.73.33,117.3Z'
							transform='translate(-1.55 0.07)'
							fill='#ab5933'
						/>
						<path
							id='Path_673'
							data-name='Path 673'
							d='M405.57,1554.09h81.9v-116.7h-81.9v116.7Z'
							fill='#c78b41'
						/>
						<path
							id='Path_674'
							data-name='Path 674'
							d='M528.43,1437.39v116.7h-81.9v-116.7Z'
							fill='#e6cf75'
						/>
						<path
							id='Path_675'
							data-name='Path 675'
							d='M533.15,1464c-.56-5-3.17-4.78-3.17-4.78a25.377,25.377,0,0,0-8.27,5.73s-5.42,6.32,0,8.75c4.46,2,4.06,1.18,8,2.85a.39.39,0,0,0,.27.11c2.1-.11,3.73-7.62,3.17-12.66Z'
							transform='translate(-1.55 0.07)'
							fill='#9c6f46'
						/>
						<path
							id='Path_676'
							data-name='Path 676'
							d='M467.78,1479.85c-14.14-14.18-27.39-2.79-27.39-2.79s-83.68-21.72-97.13-23.51c0,0,23.89-117.25,15.11-131.51,0,0-25.88,6.33-37.44,16.2s-24.18,118.94-6,143.09c0,0,74.49,14,121.32,10.39,4.33,4.42,12.77,4.78,20.32,1.17s5.81-1.85,11.22-4.29,0-8.75,0-8.75Z'
							transform='translate(-1.55 0.07)'
							fill='#9c6f46'
						/>
						<path
							id='Path_677'
							data-name='Path 677'
							d='M353.42,1404.86s-40.11-12.42-47.63-10.51c0,0,1.48-38.78,15-57.32,0,0,9.72-9.17,37.6-15,18.8-3.93-4.95,82.82-4.95,82.82Z'
							transform='translate(-1.55 0.07)'
							fill='#ba6533'
						/>
						<path
							id='Path_678'
							data-name='Path 678'
							d='M1519.55,1366.19c-14.75.48-35.67-1-47.64-11.78-16.19-14.52,7.67-58.18,17-73.82a76.455,76.455,0,0,1,3.3,17.47c1.78,25.3,7.93,55.59,26.27,67.38a10.436,10.436,0,0,1,1,.75Z'
							transform='translate(-1.55 0.07)'
							fill='#ab5933'
						/>
						<path
							id='Path_679'
							data-name='Path 679'
							d='M1560.27,1737.62a80.4,80.4,0,0,0-50.13,17.47c-40.19-11-82.09-44.5-118.39-81.55q7.74-8.36,15.6-17.36a923.593,923.593,0,0,0,74.93-98.67l-16.79-10.73c-.65,1-37.23,57.74-87.52,112.26-50.3-54.52-86.88-111.23-87.53-112.26l-16.78,10.73a921.2,921.2,0,0,0,74.92,98.67q7.86,9,15.6,17.36c-31.56,32.22-67.35,61.77-102.58,76.14a80.81,80.81,0,1,0,17.12,14.2Q1325,1741.94,1378,1688c42,42.8,81.15,70.66,116.84,83.14a80.72,80.72,0,1,0,65.46-33.52Z'
							transform='translate(-1.55 0.07)'
							fill='#585c9e'
						/>
						<path
							id='Path_680'
							data-name='Path 680'
							d='M1179.54,1816.94a39.61,39.61,0,1,1,39.61,39.61h0a39.6,39.6,0,0,1-39.61-39.61Z'
							transform='translate(-1.55 0.07)'
							fill='#ba6533'
						/>
						<path
							id='Path_681'
							data-name='Path 681'
							d='M1520.32,1816.94a39.61,39.61,0,1,1,39.61,39.61h0a39.6,39.6,0,0,1-39.6-39.6Z'
							transform='translate(-1.55 0.07)'
							fill='#ba6533'
						/>
						<path
							id='Path_682'
							data-name='Path 682'
							d='M1455.56,1332.12s-73.08,5-152.1,64.86h148l4.11-64.86Z'
							transform='translate(-1.55 0.07)'
							fill='#e6cf75'
						/>
						<path
							id='Path_683'
							data-name='Path 683'
							d='M1170.29,1385.71l-3.48,4.53-9.93,12.93s-4.91-2.3-13.08-6.36c-40.2-20-159.17-82.43-157.78-122.69.19-5.35,9.05-11.41,19-15.77,9.44-4.11,19.86-6.7,24.83-5.7,41.75,8.44,129.09,118.59,139.42,131.77.66.84,1,1.29,1,1.29Z'
							transform='translate(-1.55 0.07)'
							fill='#ba6533'
						/>
						<path
							id='Path_684'
							data-name='Path 684'
							d='M1055,1318.19c-28-16.93-42.58-39.26-50-59.84,9.44-4.11,19.86-6.7,24.83-5.7,15.66,3.16,37.72,20.63,59.74,41.92,36.69,35.49,73.23,81.61,79.68,89.85,0,0-67-37.67-114.29-66.23Z'
							transform='translate(-1.55 0.07)'
							fill='#ab5933'
						/>
						<path
							id='Path_685'
							data-name='Path 685'
							d='M1662.57,1410.8a25.183,25.183,0,0,0-.23-2.88h0v-.06l-2.2-34.45a10.93,10.93,0,0,0-3.93-7.8,10.431,10.431,0,0,0-1-.75c-18.35-11.79-24.49-42.08-26.28-67.38a75.825,75.825,0,0,0-3.3-17.47,79.518,79.518,0,0,0-24.47-36.64c-21.68-18.3-41.57-48-49.18-60.11a11,11,0,0,0-9.58-5.12h-1c-53.85.56-94-26.14-100.78-31a10.757,10.757,0,0,0-1.66-1c-.33-.16-.67-.3-1-.43s-.94-.32-1.4-.46a11,11,0,0,0-14.22,10.72l3.82,228.36h-259.7a26.659,26.659,0,0,0-6.828.889,27.12,27.12,0,0,0-15.832,11.5,26.779,26.779,0,0,0-4.32,14.59V1536.6a27.05,27.05,0,0,0,27,27h469.13a27.05,27.05,0,0,0,27-27V1410.8Z'
							transform='translate(-1.55 0.07)'
							fill='#ba6533'
						/>
						<path
							id='Path_686'
							data-name='Path 686'
							d='M1541.43,1178.14c-16.28,7-46.64,17.22-69,8.28-22-8.81-30.4-28.69-33.47-40.19a10.766,10.766,0,0,1,1.66,1c6.78,4.81,46.93,31.51,100.78,31Z'
							transform='translate(-1.55 0.07)'
							fill='#ab5933'
						/>
						<path
							id='Path_687'
							data-name='Path 687'
							d='M1662.57,1411.4v125.29a27.05,27.05,0,0,1-27,27H1166.46a27.05,27.05,0,0,1-27-27V1504.8c47.67,32.36,234.51,39.61,341.66,34.68,98.19-4.51,162-96.42,181.43-128.68v.6Z'
							transform='translate(-1.55 0.07)'
							fill='#ab5933'
						/>
						<path
							id='Path_688'
							data-name='Path 688'
							d='M818.29,1797.96l19.92,82.42,27.12-10.45,2.8-69.81-49.84-2.16Z'
							fill='#d6adb1'
						/>
						<path
							id='Path_689'
							data-name='Path 689'
							d='M832.54,1869.05l9.07,30h90.06S908.67,1858.56,832.54,1869.05Z'
							transform='translate(-1.55 0.07)'
							fill='#b85c31'
						/>
						<path
							id='Path_690'
							data-name='Path 690'
							d='M697.52,1792.14l-5.03,88.24,31.86-6.69,31.87-73.49-58.7-8.06Z'
							fill='#d6adb1'
						/>
						<path
							id='Path_691'
							data-name='Path 691'
							d='M686.82,1869.05l9.07,30H786s-23-40.49-99.14-30Z'
							transform='translate(-1.55 0.07)'
							fill='#b85c31'
						/>
						<path
							id='Path_692'
							data-name='Path 692'
							d='M747.36,1845.3l-60.54-10.44s13-101.58,70.95-251.24c12.51-32.34-6.23-248.54,12.33-307.14H925.21l-97.63,381L747.36,1845.3'
							transform='translate(-1.55 0.07)'
							fill='#36367e'
						/>
						<path
							id='Path_693'
							data-name='Path 693'
							d='M756.32,1356.88c.47,83.35,55.11,484.39,55.11,484.39l33.5-1.44,28.79-1.22S906,1662.5,911.07,1600.69c6.42-78.73,14.14-324.21,14.14-324.21H770.09s-14.14,13.88-13.77,80.4'
							transform='translate(-1.55 0.07)'
							fill='#585c9e'
						/>
						<path
							id='Path_694'
							data-name='Path 694'
							d='M756.32,1356.88c.47,83.35,55.11,484.39,55.11,484.39l33.5-1.44C823.79,1763.7,802.36,1388,801,1349.1c-.86-25.23,8.54-54.28,15.77-72.62H770.09s-14.14,13.88-13.77,80.4'
							transform='translate(-1.55 0.07)'
							fill='#515599'
						/>
						<path
							id='Path_695'
							data-name='Path 695'
							d='M850.57,1826.81c-9.8-52.68-18.4-115.19-24-180.38-.84-10-1.65-20.21-2.4-30.47-.83-11.31-1.59-22.77-2.27-34-.23-3.87.77-8.34,1.74-12.67.9-4,1.84-8.17,1.66-11.52-2.26-42.89-2.37-82.16-2.48-116.8q0-13.63-.12-26.7c-.56-78.78-1.16-123.42-1.19-123.86,0,.44,3.27,44.88,3.83,123.77.07,8.72.09,17.62.12,26.71.1,34.61.22,73.84,2.48,116.66.19,3.73-.79,8.09-1.73,12.3s-1.88,8.4-1.67,11.87c.67,11.27,1.44,22.71,2.26,34,.75,10.25,1.55,20.49,2.4,30.44,5.55,65.09,12.31,128.14,22.08,180.74h-.75Z'
							transform='translate(-1.55 0.07)'
							fill='#36367e'
						/>
						<path
							id='Path_696'
							data-name='Path 696'
							d='M896.31,856.53s-1.62-72-71.89-63-76.18,101.13-62,131.84-28.34,31.29-40.75,58.46,7.68,57.87,7.68,65.55-13.58,39,33.07,37.8,148.23,3.54,143.5-38.39-8.2-65-23.25-83.86S896.32,856.5,896.32,856.5'
							transform='translate(-1.55 0.07)'
							fill='#36367e'
						/>
						<path
							id='Path_697'
							data-name='Path 697'
							d='M892.65,966.16c-1,0-9.12-1.45-23-2.15-7.73-21.28-3.77-44.3-3.77-44.3L813.6,903.79c-2.83,62.34-8.76,63.5-8.76,63.5h0a405.129,405.129,0,0,0-43.26,8.63s42.21,193.38,27.87,229.83a386.091,386.091,0,0,0-19.78,68.8l155.55,1.93s-2.18-125.11,5-169.39-37.55-140.93-37.55-140.93'
							transform='translate(-1.55 0.07)'
							fill='#8d5f38'
						/>
						<path
							id='Path_698'
							data-name='Path 698'
							d='M1039,1254.1c-5.58-26.31-28.47-28.59-32.33-28.79-23.3-25.33-40.18-47-64.95-76.34-6.58-20.85,12.52-74-12.45-163-3.55-12.64-42.3-20.53-42.3-20.53l5.89,80.89s-7.1,107.13,6.85,125.44c17.3,22.72,67.35,51.62,92,65,2.33,8.54,11.45,17.18,23.12,20.45,12.18,3.41,8.64,3.6,17.24,6.2s7-9.35,7-9.35Z'
							transform='translate(-1.55 0.07)'
							fill='#8d5f38'
						/>
						<path
							id='Path_699'
							data-name='Path 699'
							d='M948.34,1060.13c-11.19-86.1-27.2-85.78-27.2-85.78s-6.43-7.06-34.17-8.86c0,0,1.42,31.9-10.53,46.84,0,0-70.06-32.07-77.75-44.11,0,0-49,4.08-60,16.62-10.42,11.88,17.7,77.88,20.75,84.94l.27.61s37.3,90.1,27.43,118.77-25.57,87.32-17,87.32c1.79,0,12.13,2,26.7,4h0a370.745,370.745,0,0,0,49.48,3.77c30.44,0,63.23-3.59,76.41-5.2a7.66,7.66,0,0,0,6.69-6.83c1.13-11.12,2.93-35.38-.31-54.28-5.45-31.71,4.41-97.49,5.51-134.19a190.715,190.715,0,0,0-.78-20c5.92-2.66,14.54-3.66,14.54-3.66'
							transform='translate(-1.55 0.07)'
							fill='#e6cf75'
						/>
						<path
							id='Path_700'
							data-name='Path 700'
							d='M796.8,1280.52h0c-14.57-2-24.91-4-26.7-4s-2.45-2.37-2.44-6.4c0-16,11.6-58,19.49-80.92a39.157,39.157,0,0,0,1.66-12.36c0-25.12-14-66.63-22.59-89.68-3.78-10.16-6.5-16.73-6.5-16.73l-.27-.61,46.57,3s6.31-31.23,16.37-31.23c1.63,0,3.35.81,5.16,2.7,13,13.59,18.2,96,13.22,113.37s-38.06,67.51-31.38,89,13.57,28.91-12.58,33.87'
							transform='translate(-1.55 0.07)'
							fill='#dfc16b'
						/>
						<path
							id='Path_701'
							data-name='Path 701'
							d='M1018.75,1265.34c-16.64-28.48-45.21-19.08-45.21-19.08l-119.07-92.48L791,969.51s-51.21,6.6-58,21.39,76.34,193.48,92,208.93c13.3,13.16,101.76,51.29,136.94,63.32,5.31,8.52,18.3,14.74,32.14,14.09,14.18-.67,10.47.79,20.55.52S1018.75,1265.34,1018.75,1265.34Z'
							transform='translate(-1.55 0.07)'
							fill='#9c6f46'
						/>
						<path
							id='Path_702'
							data-name='Path 702'
							d='M798.69,968.22s-57,5.28-65.65,22.68,32.83,95.32,32.83,95.32,34.76-23.87,58.93-18.63Z'
							transform='translate(-1.55 0.07)'
							fill='#e6cf75'
						/>
						<path
							id='Path_703'
							data-name='Path 703'
							d='M876,933s-63.77,2.91-65-36.84S800.82,830,841.49,826.5s49,11.38,52.67,24.55S892.6,931.22,876,933Z'
							transform='translate(-1.55 0.07)'
							fill='#9c6f46'
						/>
						<path
							id='Path_704'
							data-name='Path 704'
							d='M890.43,831.07c-8.73-13.83-40.88-12.28-40.88-12.28h0c-10.8-2.66-29.54-4.74-43.92,7.17-21.46,17.77,2.92,87.5,2.92,87.5s1.25-40.4,25-59.52C849,841.58,854.76,831.67,857,826.2a120.161,120.161,0,0,0,14.68,9.8c18.62,10.8,22.54,48.54,22.54,48.54,9.32-14.88,5-39.63-3.74-53.47Z'
							transform='translate(-1.55 0.07)'
							fill='#36367e'
						/>
						<path
							id='Path_705'
							data-name='Path 705'
							d='M859.47,908.49s1.86,5,14.26,2.69c0,0,10.42-2,9.36-7.65,0,0-10.72-2.79-23.62,5Z'
							transform='translate(-1.55 0.07)'
							fill='#fff'
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const ArrowLeft = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='11.9'
			height='19.97'
			viewBox='0 0 11.9 19.97'
		>
			<path
				id='left-arrow'
				d='M13.506,16.785l6.718-6.721a1.9,1.9,0,1,0-2.687-2.688L9.476,15.441h0a1.857,1.857,0,0,0,0,2.688l8.061,8.065a1.742,1.742,0,0,0,1.344.576h0a1.742,1.742,0,0,0,1.344-.576,1.857,1.857,0,0,0,0-2.688Z'
				transform='translate(-8.9 -6.8)'
			/>
		</svg>
	);
};

export const ArrowRight = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='11.896'
			height='19.97'
			viewBox='0 0 11.896 19.97'
		>
			<path
				id='right-arrow'
				d='M20.212,15.392,12.137,7.318A1.906,1.906,0,1,0,9.433,10l6.742,6.742L9.433,23.486a1.906,1.906,0,0,0,2.7,2.685L20.212,18.1a1.9,1.9,0,0,0,0-2.7Z'
				transform='translate(-8.879 -6.754)'
			/>
		</svg>
	);
};

export const Location = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='15.35'
			height='19.401'
			viewBox='0 0 15.35 19.401'
		>
			<path
				id='location'
				d='M13.175,19.336S6,15.583,6,8.175a7.175,7.175,0,0,1,14.35,0C20.35,15.583,13.175,19.336,13.175,19.336Zm0-17.539A6.385,6.385,0,0,0,6.8,8.175c0,5.883,4.968,9.368,6.379,10.239,1.413-.868,6.377-4.338,6.377-10.239A6.385,6.385,0,0,0,13.175,1.8Zm0,9.965a3.588,3.588,0,1,1,3.588-3.588A3.587,3.587,0,0,1,13.175,11.763Zm0-6.378a2.79,2.79,0,1,0,2.79,2.79A2.79,2.79,0,0,0,13.175,5.385Z'
				transform='translate(-5.5 -0.5)'
				stroke='#707070'
				strokeWidth='1'
				fillRule='evenodd'
			/>
		</svg>
	);
};

export const Money = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='88.276'
			height='61.793'
			viewBox='0 0 88.276 61.793'
		>
			<path
				id='Icon_awesome-money-check'
				data-name='Icon awesome-money-check'
				d='M0,59.63a4.414,4.414,0,0,0,4.414,4.414H83.863a4.414,4.414,0,0,0,4.414-4.414V15.491H0ZM61.793,30.94A2.206,2.206,0,0,1,64,28.733H77.242a2.206,2.206,0,0,1,2.207,2.207v4.414a2.206,2.206,0,0,1-2.207,2.207H64a2.206,2.206,0,0,1-2.207-2.207Zm0,16.552a1.1,1.1,0,0,1,1.1-1.1H78.345a1.1,1.1,0,0,1,1.1,1.1V49.7a1.1,1.1,0,0,1-1.1,1.1H62.9a1.1,1.1,0,0,1-1.1-1.1ZM8.828,34.25a1.1,1.1,0,0,1,1.1-1.1H51.862a1.1,1.1,0,0,1,1.1,1.1v2.207a1.1,1.1,0,0,1-1.1,1.1H9.931a1.1,1.1,0,0,1-1.1-1.1Zm0,13.241a1.1,1.1,0,0,1,1.1-1.1H34.207a1.1,1.1,0,0,1,1.1,1.1V49.7a1.1,1.1,0,0,1-1.1,1.1H9.931a1.1,1.1,0,0,1-1.1-1.1ZM86.069,2.25H2.207A2.206,2.206,0,0,0,0,4.457v6.621H88.276V4.457A2.206,2.206,0,0,0,86.069,2.25Z'
				transform='translate(0 -2.25)'
			/>
		</svg>
	);
};

export const VerifySvg = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 667.96 418.18'>
			<g id='Background_Complete' data-name='Background Complete'>
				<path
					d='M291.33,444.91a55.09,55.09,0,0,0-26.84-27.57c-11.88-5.56-38.37-3-38.37-3l-69.62-.15c1.43,6.12,6,21.82,9.35,27.1s8.4,9.74,14.44,11.45c7.39,2.09,15.22-.07,22.89-.57,13.49-.87,26.69,3.49,39.68,7.24s26.78,6.93,39.92,3.75c3.73-.91,7.64-2.57,9.45-5.95C294.24,453.48,293,448.83,291.33,444.91Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M77.56,198.11s-7.92-.57-7.19,17.19,2.54,27.23,2.54,27.23-.23,3.93-3.28,3.16S60.84,241.09,58,244s-1.89,7.53,2,12.9,12,17.44,12.74,18.54,1,3.09-1.16,2.89-16.76-5.14-18.69,1.93,11.38,20.24,12.81,21.71,1.51,2.39.93,3.28-5.33-1.24-9.54-2.47S47.79,300.79,47,305s5.09,16.38,27.06,29.2l10.57,5.28,10-6.38c20.57-15,25.19-27.69,24-31.76s-6.19-2.87-10.25-1.22-8.58,4.24-9.24,3.42-.68-1.76.59-3.36,13.21-16,10.58-22.88-16.66-.46-18.79-.05-2-1.62-1.44-2.76,7.47-14,10.82-19.72,3.92-10.38.7-13-8.43,1.82-11.39,2.9-3.58-2.83-3.58-2.83.85-9.59-.2-27.34-9.06-16.31-9.06-16.31'
					transform='translate(-41.02 -46.31)'
					fill='#ebebeb'
				/>
				<path
					d='M78.19,214s0,.12,0,.37,0,.62.08,1.09c.07,1,.16,2.38.29,4.19.24,3.65.55,8.92.91,15.44.73,13,1.57,31.05,2.44,50.95s1.67,37.93,2.32,51c.33,6.51.6,11.78.79,15.44.09,1.81.16,3.22.21,4.2,0,.47,0,.83,0,1.09a3.64,3.64,0,0,1,0,.38s0-.13,0-.37,0-.63-.08-1.09c-.07-1-.17-2.39-.29-4.2-.24-3.64-.55-8.91-.91-15.43-.73-13-1.57-31.06-2.44-51s-1.67-37.92-2.32-51c-.34-6.5-.6-11.77-.79-15.44-.09-1.81-.16-3.22-.21-4.2,0-.46,0-.83,0-1.09A3.39,3.39,0,0,1,78.19,214Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M65.82,249.64a3.22,3.22,0,0,1,.65.54c.41.37,1,.92,1.68,1.61,1.4,1.39,3.27,3.34,5.3,5.55L78.62,263l1.57,1.71a3.11,3.11,0,0,1,.55.65,3.4,3.4,0,0,1-.66-.54c-.4-.37-1-.92-1.67-1.62-1.38-1.4-3.23-3.38-5.26-5.58L68,252c-.63-.66-1.15-1.23-1.59-1.7A3.22,3.22,0,0,1,65.82,249.64Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M81.79,265c-.08-.08,3.79-4.12,8.63-9s8.85-8.83,8.93-8.75-3.79,4.12-8.64,9S81.87,265.08,81.79,265Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M81.75,295.63a4.07,4.07,0,0,1,.74-.47L84.55,294c1.75-1,4.15-2.34,6.75-3.94s4.91-3.11,6.57-4.23l2-1.31a3.53,3.53,0,0,1,.75-.45,3.56,3.56,0,0,1-.66.58c-.44.34-1.09.83-1.9,1.42-1.63,1.18-3.92,2.74-6.53,4.34s-5,2.93-6.82,3.84c-.89.46-1.62.82-2.13,1.05A3.2,3.2,0,0,1,81.75,295.63Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M64.24,284.91a3.64,3.64,0,0,1,.73.34l1.92,1.07c1.61.91,3.81,2.2,6.24,3.64s4.61,2.77,6.18,3.75c.79.49,1.42.89,1.86,1.18a3.53,3.53,0,0,1,.65.47,2.81,2.81,0,0,1-.74-.34L79.17,294c-1.61-.92-3.82-2.2-6.25-3.65s-4.61-2.77-6.18-3.74c-.79-.49-1.42-.89-1.85-1.18A3.25,3.25,0,0,1,64.24,284.91Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M60.77,312a4.35,4.35,0,0,1,.93.45l2.46,1.35c2.06,1.16,4.91,2.79,8,4.61s6,3.49,8,4.71l2.4,1.47a5.14,5.14,0,0,1,.85.59,6.15,6.15,0,0,1-.93-.45L80,323.32c-2.07-1.16-4.91-2.79-8-4.61S66,315.22,64,314l-2.39-1.47A5,5,0,0,1,60.77,312Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M83,324.66a5.09,5.09,0,0,1,.92-.62l2.57-1.56c2.16-1.32,5.15-3.16,8.4-5.27s6.13-4.1,8.22-5.55l2.47-1.72a5.74,5.74,0,0,1,.93-.59,5.35,5.35,0,0,1-.84.72c-.56.44-1.37,1.06-2.4,1.82-2,1.51-4.91,3.54-8.16,5.66s-6.27,3.92-8.48,5.18c-1.11.62-2,1.12-2.64,1.45A6.39,6.39,0,0,1,83,324.66Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<polygon
					points='57.83 296.59 28.59 296.59 38.14 368.83 48.29 368.83 57.83 296.59'
					fill='#e0e0e0'
				/>
				<path
					d='M71.13,351.78s0,.1.16.26a1.82,1.82,0,0,0,.7.5,3.54,3.54,0,0,0,3.09-.38c1.18-.65,2.21-1.93,3.79-2.49a8.29,8.29,0,0,1,5.38.1,23.23,23.23,0,0,1,5,2.43,34.89,34.89,0,0,0,4.08,2.18,11.09,11.09,0,0,0,3,.87,5,5,0,0,0,.85.06c.19,0,.29,0,.29,0a15.19,15.19,0,0,1-4-1.2,40,40,0,0,1-4-2.26,22.35,22.35,0,0,0-5.09-2.5,8.59,8.59,0,0,0-5.68-.06,7.4,7.4,0,0,0-2.13,1.32,15.49,15.49,0,0,1-1.68,1.29,3.45,3.45,0,0,1-2.84.5A3,3,0,0,1,71.13,351.78Z'
					transform='translate(-41.02 -46.31)'
					fill='#f5f5f5'
				/>
				<path
					d='M72.2,365.08s.23-.29.69-.77a6.45,6.45,0,0,1,2.33-1.48,10.45,10.45,0,0,1,4.07-.61,40.89,40.89,0,0,1,5.08.69,17.84,17.84,0,0,0,5.21.22,14.14,14.14,0,0,0,4.1-1.18,12.7,12.7,0,0,0,2.47-1.46,3.37,3.37,0,0,0,.78-.7,26.7,26.7,0,0,1-3.38,1.86,15.26,15.26,0,0,1-4,1,18.12,18.12,0,0,1-5.08-.25,38.25,38.25,0,0,0-5.15-.66,10.27,10.27,0,0,0-4.21.74,6,6,0,0,0-2.34,1.66,4.11,4.11,0,0,0-.44.65C72.22,365,72.18,365.08,72.2,365.08Z'
					transform='translate(-41.02 -46.31)'
					fill='#f5f5f5'
				/>
				<path
					d='M95.54,372.21a2.42,2.42,0,0,0-.81-.42,8.25,8.25,0,0,0-2.42-.52,15.34,15.34,0,0,0-3.66.21c-1.37.22-2.83.6-4.36.92a18.1,18.1,0,0,1-4.36.49,9.47,9.47,0,0,1-3.45-.74,7.86,7.86,0,0,1-2.63-2,2.18,2.18,0,0,0,.5.77,6.09,6.09,0,0,0,2,1.49,9.23,9.23,0,0,0,3.58.88,17.21,17.21,0,0,0,4.47-.46c1.56-.33,3-.72,4.34-1a16.87,16.87,0,0,1,3.57-.3A13.2,13.2,0,0,1,95.54,372.21Z'
					transform='translate(-41.02 -46.31)'
					fill='#f5f5f5'
				/>
				<path
					d='M74.78,382.23a4.69,4.69,0,0,1,2.84-.29,14,14,0,0,1,3,1.11,11.37,11.37,0,0,0,3.85,1.06,11.54,11.54,0,0,0,7-1.62,10.31,10.31,0,0,0,1.74-1.34c.36-.38.54-.6.51-.62a23.93,23.93,0,0,1-2.42,1.67,12.08,12.08,0,0,1-6.78,1.44c-2.77-.16-4.9-1.81-6.82-2a4.31,4.31,0,0,0-2.2.19C75,382,74.77,382.21,74.78,382.23Z'
					transform='translate(-41.02 -46.31)'
					fill='#f5f5f5'
				/>
				<path
					d='M76.41,396.09a5.52,5.52,0,0,0,2.44-.48c1.47-.49,3.29-1.62,5.41-2.46a8.63,8.63,0,0,1,3.11-.65,5.66,5.66,0,0,1,2.5.57,5.37,5.37,0,0,1,1.8,1.55,1.36,1.36,0,0,0-.28-.61A3.85,3.85,0,0,0,90,392.77a5.71,5.71,0,0,0-2.65-.71,8.76,8.76,0,0,0-3.28.64c-2.2.88-4,2-5.37,2.59S76.4,396,76.41,396.09Z'
					transform='translate(-41.02 -46.31)'
					fill='#f5f5f5'
				/>
				<path
					d='M77.84,402.54a6.82,6.82,0,0,0,1.85.61,37,37,0,0,0,4.63.78,34.22,34.22,0,0,0,4.69.13,7.16,7.16,0,0,0,1.94-.23c0-.14-3,0-6.58-.38S77.88,402.4,77.84,402.54Z'
					transform='translate(-41.02 -46.31)'
					fill='#f5f5f5'
				/>
				<rect
					x='539.55'
					y='230.19'
					width='91.21'
					height='61.48'
					transform='translate(-84.45 90.61) rotate(-12.87)'
					fill='#f5f5f5'
				/>
				<path
					d='M623.22,221.46a6.16,6.16,0,0,1-.65,1l-2,2.73-7.41,10c-6.37,8.44-15.09,20-24.76,32.8l-.2.27-.31-.15-.73-.35-37.47-18.2-11.32-5.59-3-1.56a6.54,6.54,0,0,1-1.05-.6,6.85,6.85,0,0,1,1.12.45l3.12,1.42L550,249l37.57,18,.74.36-.51.12c9.74-12.74,18.53-24.25,25-32.65,3.17-4.1,5.76-7.43,7.62-9.82l2.1-2.64A5.69,5.69,0,0,1,623.22,221.46Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M548,301.72c-.2-.11,4.61-9.85,10.74-21.76s11.28-21.49,11.48-21.39-4.61,9.85-10.74,21.77S548.19,301.82,548,301.72Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M599.6,251.07c.14-.18,8.61,6.47,18.92,14.84s18.54,15.31,18.39,15.49-8.61-6.47-18.92-14.85S599.45,251.25,599.6,251.07Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<rect
					x='230.67'
					y='54.69'
					width='36.25'
					height='53.78'
					transform='translate(72.3 259.32) rotate(-77)'
					fill='#f5f5f5'
				/>
				<path
					d='M279.14,70.44a4,4,0,0,1-.6.36l-1.75.94-6.5,3.38-21.57,11-.18.09-.13-.15-.3-.38L232.92,66.42l-4.56-5.89-1.22-1.61a2.94,2.94,0,0,1-.4-.58,3.72,3.72,0,0,1,.47.52l1.3,1.56,4.68,5.78L248.5,85.41l.3.37-.3-.06,21.63-10.9,6.57-3.25,1.8-.86A3.24,3.24,0,0,1,279.14,70.44Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M218.58,93.66c-.08-.11,5-4,11.3-8.78s11.51-8.5,11.59-8.39-5,4-11.3,8.78S218.66,93.77,218.58,93.66Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M259,80.07c.12-.06,2.91,5.65,6.22,12.74s5.89,12.89,5.77,13-2.9-5.65-6.21-12.74S258.87,80.12,259,80.07Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<rect
					x='524.39'
					y='73.77'
					width='41.67'
					height='28.09'
					transform='translate(-31.4 176.09) rotate(-23.25)'
					fill='#f5f5f5'
				/>
				<path
					d='M559.08,67a3.38,3.38,0,0,1-.21.49l-.66,1.39c-.61,1.24-1.47,3-2.51,5.1l-8.43,16.78-.07.14-.15,0-.36-.09-18.33-5.1L522.81,84l-1.5-.45-.52-.18a2.59,2.59,0,0,1,.54.11l1.52.38,5.58,1.47,18.36,5,.36.1-.21.1c3.32-6.53,6.33-12.43,8.52-16.73,1.09-2.1,2-3.82,2.62-5l.72-1.36A2.46,2.46,0,0,1,559.08,67Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M531.88,109.21c-.1,0,1.26-4.81,3-10.67S538.22,88,538.32,88s-1.26,4.8-3,10.66S532,109.24,531.88,109.21Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
				<path
					d='M550.9,82.2c.05-.1,4.41,2.19,9.73,5.11s9.59,5.35,9.54,5.44-4.4-2.19-9.72-5.11S550.85,82.29,550.9,82.2Z'
					transform='translate(-41.02 -46.31)'
					fill='#e0e0e0'
				/>
			</g>
			<g id='Plant'>
				<path
					d='M609.52,327.76A31.52,31.52,0,0,0,596,323.09c-2.21-.22-4.63-.16-6.41,1.18a1.35,1.35,0,0,0-.66,1.17,1.5,1.5,0,0,0,.63.8,19.37,19.37,0,0,0,20,1.52'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M609.17,327.37a66.07,66.07,0,0,1-8.75-7.7,22,22,0,0,1-5.48-10.14,4.09,4.09,0,0,1,.43-3.4c7,5.45,12.45,12.5,13.8,21.24'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M609.45,327.7a31.41,31.41,0,0,1,.16-11.48,15.51,15.51,0,0,1,6.12-9.48c1.2,2.81.69,6.06-.16,9a43.65,43.65,0,0,1-6.07,12.78'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M616.29,340c-4.16.51-7.77,2.7-10.87,5.5a20.54,20.54,0,0,0-6.21,10.67c4.07-.25,7.52-3.12,10-6.34s4.24-6.75,7-9.76'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M617.77,341.91a26.81,26.81,0,0,1,3.09-25.34c2.37,8.41,1.5,17.91-3.09,25.34'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M626.8,352.67a19.39,19.39,0,0,0-18.52,10.67,1.44,1.44,0,0,0-.13,1.45,1.38,1.38,0,0,0,1.23.36c3.65-.24,6.89-2.43,9.56-4.93s5-5.4,7.95-7.56'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M626.52,352.09a34.46,34.46,0,0,1-.35-19.28c.68-2.48,1.82-5.09,4.11-6.26a.84.84,0,0,1,.63-.11.86.86,0,0,1,.4.46,11.52,11.52,0,0,1,1,5.53,34.3,34.3,0,0,1-.86,5.6c-.73,3.42-1.11,7.1-3,10.05a20.42,20.42,0,0,0-1.19,2.21c-.36.75-.36,1-.68,1.61'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M650.43,355.65c-1.77-6.74.11-14.91,4.36-20.44.31-.4.72-.84,1.23-.79.79.07,1,1.11,1,1.9a36.88,36.88,0,0,1-6.54,19.33'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M652.59,357.12a29.73,29.73,0,0,0,24.39-5,19.79,19.79,0,0,0-13.21-1.62c-4.41,1-8.44,3-11.18,6.58'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M654.4,352.63c4.59-7.47,13.38-12.35,22.14-12.8-1,3.57-3.94,6.34-7.24,8A40.4,40.4,0,0,1,658.67,351c-1.41.27-3.35.57-4.27,1.68'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M650.89,330.86a64.24,64.24,0,0,0,2.83-13,21.58,21.58,0,0,0-2.59-12.83c-4.28,8.29-4.71,18-.37,26.24'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M665.31,323.57c5-9.1,15.23-16.37,25.57-17.39-4,9.93-14.87,17.61-25.57,17.39'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M662.15,325.36c7.48,1.13,13.84,5.91,20.82,8.8a9.31,9.31,0,0,0,4.71.9,3.68,3.68,0,0,0,2.3-6.52,10,10,0,0,0-3.41-2.07c-7.61-3.17-15.76-3.25-23.77-1.33'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M657.83,330.6c1.69.48,2.27,1.36,3.61,2.5a38.88,38.88,0,0,0,15.79,8.11c.6.15,1.39.2,1.69-.34s-.07-1.05-.41-1.48a21.84,21.84,0,0,0-9.53-6.47c-3.64-1.35-6.8-3-11.15-2.64'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M653,299a29.88,29.88,0,0,0,22.91,7.79,1.54,1.54,0,0,0,1-.37c.58-.63-.12-1.6-.79-2.12-6.73-5.25-14.89-7.43-23.16-5.3'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M658.74,296.83a31.93,31.93,0,0,1,28.58-4.71,22.73,22.73,0,0,1-13.62,6,43.15,43.15,0,0,1-15-1.27'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M656.44,282.29c-.66-6.72-.23-12-.7-18.78,0-.54-.15-1.19-.66-1.38-.7-.27-1.29.59-1.52,1.31a21.54,21.54,0,0,0,2.87,18.7'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M656,283a39.4,39.4,0,0,0,11.13-10.82c2.2-3,4-6.61,3.55-10.3a10.65,10.65,0,0,0-8,4,22.33,22.33,0,0,0-4.09,8.23c-.89,3-1.52,6-2.56,8.9'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M666.89,280a89.74,89.74,0,0,0,27.4-16.16c-3.27-1.32-7-.53-10.29.79a32.46,32.46,0,0,0-17.25,15.29'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M659,286.71a56.15,56.15,0,0,0,15.21.08c4.94-.83,9.6-2.78,14.21-4.72a1.64,1.64,0,0,0,1-.74,1.11,1.11,0,0,0-.34-1.21,3,3,0,0,0-1.21-.57c-5-1.4-10.42-.74-15.35.92A71.35,71.35,0,0,0,659,286.71'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M630.15,299.18c-3.45-7-3.23-15.09-.25-22.27,2.1,3.19,2.36,7.27,2,11.07s-1.54,7.72-1.61,11.55'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M616.36,292.23a31,31,0,0,0-23.08,9.83,21.53,21.53,0,0,0,12.64-2.34,64.16,64.16,0,0,0,10.83-7.25'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M607.1,289.13c-4.22-.34-8.27-.87-12.33.38a14.78,14.78,0,0,0-9.39,8,22.27,22.27,0,0,0,11.55-2.18,67.16,67.16,0,0,0,10.17-6.16'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M620.82,289.27c-3.79-2.49-7.69-5-12.1-6s-9.53-.27-12.61,3c3.57,2.1,7.91,2.35,12,2.35s9.23-.05,13.13,1.33'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M620.84,289.47c-6.48-6.37-8.94-17.8-6.33-26.5a40.38,40.38,0,0,1,6.33,26.5'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M638.67,271.43c1.22-2.84,2.08-5.82,3.17-8.71a25.15,25.15,0,0,1,4.54-8,11.91,11.91,0,0,1,8-4.16,32.36,32.36,0,0,1-15.59,21'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M635.44,275.19c-2-2.78-4.36-6.56-7.1-8.64s-6.32-3.34-9.67-2.54a22.5,22.5,0,0,0,16.77,11.18'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M636.09,271.67a47.58,47.58,0,0,1-3.2-10.36,16.14,16.14,0,0,1,1.62-10.53c3.56,6.73,4.7,14,1.76,21'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M638.7,250.78c2-6.67,8.12-11.58,14.71-13.83a5.59,5.59,0,0,1,2.58-.39,2.24,2.24,0,0,1,1.9,1.59c.24,1.13-.69,2.15-1.58,2.9a50.09,50.09,0,0,1-17.61,9.73'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M638.77,245.33c.26-4.3.53-8.66,1.92-12.74s4.1-7.89,8-9.67c.67,4.34-1.25,8.66-3.56,12.39s-5.1,7.27-6.48,11.43'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M638.67,248.29c-1.67-4.86-1.84-11-4.75-15.27-2-3-5.29-5-7-8.11a12.4,12.4,0,0,0,.41,9.21,26.64,26.64,0,0,0,5.39,7.7c2.15,2.3,4,4,6,6.47'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M638.7,391.39c-.13,0-.24-32.41-.25-72.39s.09-72.41.22-72.41.24,32.41.25,72.41S638.83,391.39,638.7,391.39Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M667,294.29a7.59,7.59,0,0,1-1.22.46l-3.36,1.13c-2.82,1-6.71,2.36-10.93,4.08s-8.11,3.25-10.35,5.19a7.63,7.63,0,0,0-2.08,2.76c-.32.76-.38,1.22-.42,1.21s0-.11,0-.34a5.14,5.14,0,0,1,.24-.94,7.25,7.25,0,0,1,2-2.93,18.11,18.11,0,0,1,4.49-2.8c1.8-.83,3.79-1.71,5.91-2.58,4.23-1.73,8.14-3.08,11-4,1.43-.44,2.6-.77,3.41-1A7,7,0,0,1,667,294.29Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M676.31,271.48a1.66,1.66,0,0,1-.34.36l-1,1-3.88,3.53-12.93,11.51c-5,4.49-9.4,8.78-12.42,12-1.52,1.62-2.71,2.95-3.52,3.88l-.94,1.08a2.19,2.19,0,0,1-.35.35s.08-.15.28-.41.48-.65.87-1.13c.77-1,1.93-2.35,3.41-4a164.79,164.79,0,0,1,12.36-12.14c5.06-4.48,9.67-8.51,13-11.41l4-3.42c.44-.36.81-.66,1.1-.91A2.15,2.15,0,0,1,676.31,271.48Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M652.68,292.42c-.14-.05.92-2.49,2-5.57s1.56-5.67,1.69-5.65a19.18,19.18,0,0,1-1.25,5.8,37.55,37.55,0,0,1-1.57,3.9A6.36,6.36,0,0,1,652.68,292.42Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M638.73,312.05a6,6,0,0,1-.78-.91l-2-2.55c-1.67-2.16-4-5.15-6.58-8.42s-5-6.19-6.7-8.31l-2-2.52a6.71,6.71,0,0,1-.7-1,5.66,5.66,0,0,1,.84.84c.52.56,1.25,1.39,2.15,2.42,1.79,2.07,4.22,5,6.82,8.24s4.87,6.3,6.47,8.51c.81,1.11,1.45,2,1.88,2.65A6.21,6.21,0,0,1,638.73,312.05Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M632.52,304.07a11.34,11.34,0,0,1-2.61-4.87,14.14,14.14,0,0,1-.59-4.91l.21,0c-.09.37-.16.57-.2.56s0-.21,0-.6l.2,0a22.94,22.94,0,0,0,.83,4.78A35.43,35.43,0,0,0,632.52,304.07Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M624.5,294a9.1,9.1,0,0,0-1.82-1.05,12.15,12.15,0,0,0-5-.4,30.8,30.8,0,0,0-5.08.82,16.37,16.37,0,0,1-2.09.5,6.91,6.91,0,0,1,2-.82,23.21,23.21,0,0,1,5.13-1,11,11,0,0,1,5.2.56A3.22,3.22,0,0,1,624.5,294Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M622.6,291.54c0,.07-1.06-.42-2.79-1a28,28,0,0,0-14-1.07c-1.8.32-2.88.65-2.91.58a2.75,2.75,0,0,1,.74-.32,18.36,18.36,0,0,1,2.1-.59,24.87,24.87,0,0,1,14.21,1.08,17.36,17.36,0,0,1,2,.91A2.61,2.61,0,0,1,622.6,291.54Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M638.67,281.2a55.31,55.31,0,0,1-2-7.05,56,56,0,0,1-1.58-7.17,57.85,57.85,0,0,1,2,7.06A58.24,58.24,0,0,1,638.67,281.2Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M638.8,281.2a35.77,35.77,0,0,0-2.25-4.22,18.87,18.87,0,0,0-3.32-3.42,3.14,3.14,0,0,1,1.28.66,10.29,10.29,0,0,1,2.42,2.49A9.49,9.49,0,0,1,638.8,281.2Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M638.7,374.11c-.05,0-.15-.78-.51-2.15a30.45,30.45,0,0,0-2.17-5.62,77.71,77.71,0,0,0-11.49-16.19c-2.57-2.93-5.06-5.7-7.17-8.34a58.65,58.65,0,0,1-5.13-7.4,36.54,36.54,0,0,1-2.59-5.48c-.23-.68-.41-1.21-.5-1.57a3.11,3.11,0,0,1-.14-.56s.28.74.81,2.06a41.34,41.34,0,0,0,2.71,5.39,63.15,63.15,0,0,0,5.17,7.29c2.13,2.62,4.62,5.37,7.19,8.3,5.19,5.83,9.26,11.71,11.44,16.36a27.74,27.74,0,0,1,2,5.71,14.78,14.78,0,0,1,.29,1.63A3,3,0,0,1,638.7,374.11Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M664.3,345.2A14.86,14.86,0,0,1,663,346a29.74,29.74,0,0,0-3.48,2.3,39.35,39.35,0,0,0-4.57,4.17c-1.61,1.7-3.26,3.66-4.95,5.77-3.37,4.23-6.52,8-8.41,11-1,1.49-1.66,2.74-2.11,3.61a10.89,10.89,0,0,1-.74,1.35s0-.13.12-.38.24-.6.45-1.05a34.57,34.57,0,0,1,2-3.7,118.87,118.87,0,0,1,8.33-11.08c1.69-2.11,3.36-4.09,5-5.78a37.28,37.28,0,0,1,4.69-4.13,24.94,24.94,0,0,1,3.59-2.2c.45-.22.81-.36,1-.46S664.29,345.18,664.3,345.2Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M664.8,354.58A19.18,19.18,0,0,1,662,355a37.53,37.53,0,0,0-6.72,1.33,19.85,19.85,0,0,0-6,3.16c-1.39,1.07-2.05,2-2.11,1.9a2.33,2.33,0,0,1,.42-.65,10.08,10.08,0,0,1,1.48-1.51,18.16,18.16,0,0,1,6.08-3.35,30,30,0,0,1,6.84-1.21A15.4,15.4,0,0,1,664.8,354.58Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M647.94,360.35c-.15-.08,1.13-2,2.12-4.66s1.15-5,1.31-4.94a4.5,4.5,0,0,1,0,1.52,17,17,0,0,1-.83,3.58,17.53,17.53,0,0,1-1.65,3.29C648.35,359.93,648,360.39,647.94,360.35Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M672.59,320a3.54,3.54,0,0,1-.46.24l-1.33.6c-.58.25-1.29.57-2.09,1s-1.73.84-2.71,1.43l-1.55.88c-.53.3-1.06.67-1.63,1-1.14.7-2.28,1.55-3.5,2.42A65.38,65.38,0,0,0,652,334a66.94,66.94,0,0,0-6.18,7.52c-.83,1.25-1.64,2.42-2.29,3.59-.33.57-.68,1.12-1,1.66s-.56,1.08-.83,1.58c-.55,1-.94,1.94-1.33,2.76s-.69,1.53-.92,2.12-.41,1-.56,1.35a2.19,2.19,0,0,1-.22.46,1.75,1.75,0,0,1,.14-.49c.12-.37.28-.82.47-1.39s.48-1.33.85-2.16.74-1.79,1.27-2.8l.81-1.6c.28-.55.63-1.1,1-1.69.65-1.18,1.45-2.37,2.28-3.63a62.91,62.91,0,0,1,6.19-7.61,65.12,65.12,0,0,1,7.39-6.45c1.24-.87,2.4-1.71,3.55-2.39.58-.35,1.12-.71,1.66-1s1.07-.58,1.57-.86c1-.56,1.94-1,2.76-1.36a21.75,21.75,0,0,1,2.13-.92l1.37-.53A1.48,1.48,0,0,1,672.59,320Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M652.33,333.59a3.25,3.25,0,0,1,1.11-1.66,7.07,7.07,0,0,1,4.49-1.72,12.37,12.37,0,0,1,4.72.92,6.89,6.89,0,0,1,1.79.87,10.27,10.27,0,0,1-1.89-.55,14.1,14.1,0,0,0-4.6-.77,7.27,7.27,0,0,0-4.29,1.5A13,13,0,0,0,652.33,333.59Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M649.3,336.71a12,12,0,0,0,1-8.47,2.76,2.76,0,0,1,.53,1.21,8.57,8.57,0,0,1,.22,3.17,8.45,8.45,0,0,1-.95,3C649.69,336.38,649.35,336.75,649.3,336.71Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M616.31,378.76c.7,12.39,4.43,25,10.17,37.72h25c5.48-12.61,8.95-25.19,9.57-37.72Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M657,398.8c0,.13-8.23.24-18.37.24s-18.36-.11-18.36-.24,8.22-.23,18.36-.23S657,398.68,657,398.8Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M656.42,403.29c0,.13-7.71.24-17.22.24s-17.21-.11-17.21-.24,7.71-.23,17.21-.23S656.42,403.16,656.42,403.29Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
			</g>
			<g id='Device'>
				<rect
					x='134.87'
					y='109.99'
					width='384.52'
					height='254.28'
					rx='14.57'
					fill='#455a64'
				/>
				<path
					d='M119.84,347.84H536.44a0,0,0,0,1,0,0v4.45a17.8,17.8,0,0,1-17.8,17.8h-381a17.8,17.8,0,0,1-17.8-17.8v-4.45a0,0,0,0,1,0,0Z'
					fill='#455a64'
				/>
				<rect
					x='145.19'
					y='120.09'
					width='362.8'
					height='214.73'
					fill='#263238'
				/>
				<polygon
					points='289.23 345.46 294.39 353.68 367.14 353.68 371.94 345.46 289.23 345.46'
					fill='#263238'
				/>
				<rect
					x='152.67'
					y='127.36'
					width='348.6'
					height='206.78'
					rx='3.27'
					fill='#ebebeb'
				/>
				<polygon
					points='500.89 334.44 152.29 334.44 152.67 142.81 500.89 142.81 500.89 334.44'
					fill='#fafafa'
				/>
				<path
					d='M222.28,181.66a2.79,2.79,0,1,1-2.79-2.78A2.78,2.78,0,0,1,222.28,181.66Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M205.4,181.66a2.79,2.79,0,1,1-2.78-2.78A2.77,2.77,0,0,1,205.4,181.66Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M213.5,181.66a2.79,2.79,0,1,1-2.78-2.78A2.77,2.77,0,0,1,213.5,181.66Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M557.1,391.77c0,.14-85.34.25-190.59.25s-190.62-.11-190.62-.25,85.33-.25,190.62-.25S557.1,391.64,557.1,391.77Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<g id='envelope'>
					<polygon
						points='264.29 217.67 406.12 216.35 410.27 312.76 263.41 311.71 264.29 217.67'
						fill='#218284'
					/>
					<path
						d='M305.31,264l67-54.45a7.72,7.72,0,0,1,9.74,0l65.08,53.12'
						transform='translate(-41.02 -46.31)'
						fill='#218284'
					/>
					<g opacity='0.3'>
						<path
							d='M305.31,264l67-54.45a7.72,7.72,0,0,1,9.74,0l65.08,53.12'
							transform='translate(-41.02 -46.31)'
						/>
					</g>
					<path
						d='M304.43,358c-.17-.17,11.15-12.59,25.3-27.74S355.5,303,355.68,303.14s-11.15,12.58-25.31,27.74S304.61,358.18,304.43,358Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M451.29,359.07c-.18.17-11.26-12-24.75-27.07s-24.28-27.5-24.1-27.66,11.26,12,24.76,27.08S451.47,358.91,451.29,359.07Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<g opacity='0.5'>
						<polyline points='406.12 216.35 335.02 273.39 264.29 217.67' />
					</g>
					<polygon
						points='271.45 222.93 271.13 178.63 395.32 176.9 396.81 223.51 335.01 272.64 271.45 222.93'
						fill='#fafafa'
					/>
					<path
						d='M312.47,269.24s.41.29,1.18.88l3.38,2.61,12.86,10c11.08,8.65,27,21,46.27,36.08h-.26l61.77-49.17-.09.21c-.29-8.89-.59-18.22-.89-27.71-.21-6.39-.41-12.71-.61-18.9l.26.25-124.18,1.64.16-.17c.06,13.93.12,25,.15,32.58,0,3.79,0,6.71,0,8.7,0,1,0,1.73,0,2.25s0,.77,0,.77,0-.25,0-.75,0-1.26,0-2.23c0-2-.06-4.9-.1-8.68-.07-7.61-.18-18.68-.31-32.64v-.16h.16L436.33,223h.26v.26c.2,6.19.4,12.5.61,18.89.3,9.49.6,18.82.88,27.71v.13l-.1.08-61.84,49.1-.13.11-.13-.11-46.22-36.27-12.76-10.06-3.33-2.64Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M416.76,245.56c0,.14-19,.41-42.42.6s-42.42.23-42.42.09,19-.41,42.42-.61S416.76,245.41,416.76,245.56Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M416.78,258.07c0,.14-19,.42-42.41.61s-42.42.23-42.42.08,19-.41,42.42-.6S416.78,257.93,416.78,258.07Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M416.81,272.49c0,.15-19,.42-42.41.61s-42.42.23-42.42.08,19-.41,42.42-.6S416.81,272.35,416.81,272.49Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M416.84,286.91c0,.15-18.11.41-40.46.59s-40.47.22-40.47.07,18.11-.41,40.47-.59S416.84,286.77,416.84,286.91Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M401,299.6a1.65,1.65,0,0,1-.5.06l-1.43.06-5.24.13-17.31.32c-6.76.12-12.89.16-17.32.16l-5.24,0-1.43,0a2,2,0,0,1-.5-.05,1.65,1.65,0,0,1,.5-.06l1.42-.06,5.25-.13,17.31-.31c6.76-.13,12.88-.17,17.31-.17l5.25,0,1.43,0A2.55,2.55,0,0,1,401,299.6Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M385,311.8a76.73,76.73,0,0,1-9,.28,77.38,77.38,0,0,1-9-.24,79.42,79.42,0,0,1,9-.28A80.12,80.12,0,0,1,385,311.8Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
				</g>
			</g>
			<g id='Floor'>
				<path
					d='M709,415.55c0,.15-149.54.26-334,.26s-334-.11-334-.26,149.51-.26,334-.26S709,415.41,709,415.55Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
			</g>
			<g id='Envelope_3' data-name='Envelope 3'>
				<path
					d='M401.76,222.83c.14,0,.2.58.13,1.27s-.24,1.23-.38,1.22-.2-.59-.13-1.28S401.61,222.81,401.76,222.83Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M403.09,213.09a6.09,6.09,0,0,1-.11,2.46,6.18,6.18,0,0,1-.63,2.39,11.6,11.6,0,0,1,.74-4.85Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M405.05,203.45a6,6,0,0,1-.27,2.46,6.14,6.14,0,0,1-.79,2.34,5.91,5.91,0,0,1,.28-2.45A6,6,0,0,1,405.05,203.45Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M407.72,194a11.53,11.53,0,0,1-1.43,4.71,6.14,6.14,0,0,1,.47-2.43A5.88,5.88,0,0,1,407.72,194Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M411.15,184.78a6.15,6.15,0,0,1-.67,2.38,6,6,0,0,1-1.15,2.19A6.19,6.19,0,0,1,410,187,5.92,5.92,0,0,1,411.15,184.78Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M415.41,175.93a11.85,11.85,0,0,1-2.24,4.37,6,6,0,0,1,.89-2.3C414.68,176.79,415.28,175.86,415.41,175.93Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M420.55,167.55a6.12,6.12,0,0,1-1.15,2.19c-.72,1.14-1.41,2-1.53,1.93a5.81,5.81,0,0,1,1.09-2.22C419.72,168.32,420.43,167.47,420.55,167.55Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M426.61,159.81a6.23,6.23,0,0,1-1.37,2.06c-.87,1-1.66,1.81-1.78,1.72s.5-1,1.38-2.05S426.5,159.72,426.61,159.81Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M433.53,152.84c.1.11-.62.95-1.6,1.88s-1.86,1.6-2,1.5.61-.94,1.6-1.88S433.44,152.73,433.53,152.84Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M441.27,146.78c.08.12-.74.87-1.83,1.67a6.06,6.06,0,0,1-2.13,1.24c-.09-.11.73-.86,1.83-1.66A5.9,5.9,0,0,1,441.27,146.78Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M449.75,141.81a11.7,11.7,0,0,1-4.33,2.34c-.07-.13.84-.75,2-1.4A5.91,5.91,0,0,1,449.75,141.81Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M458.85,138.11a6.24,6.24,0,0,1-2.22,1.08,5.93,5.93,0,0,1-2.4.59,6.09,6.09,0,0,1,2.22-1.08A5.77,5.77,0,0,1,458.85,138.11Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M468.41,135.88a6.2,6.2,0,0,1-2.37.66,6,6,0,0,1-2.45.25,9.83,9.83,0,0,1,4.82-.91Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M478.22,135.34a6.08,6.08,0,0,1-2.45.28,5.85,5.85,0,0,1-2.46-.23,6.1,6.1,0,0,1,2.45-.29A5.84,5.84,0,0,1,478.22,135.34Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M488,136.49a6.07,6.07,0,0,1-2.47-.14,5.94,5.94,0,0,1-2.39-.65,11.87,11.87,0,0,1,4.86.79Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M497.39,139.3a11.61,11.61,0,0,1-4.65-1.62,6.32,6.32,0,0,1,2.41.56A5.91,5.91,0,0,1,497.39,139.3Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M506.14,143.76a6.23,6.23,0,0,1-2.26-1,6.06,6.06,0,0,1-2-1.45,6,6,0,0,1,2.26,1C505.32,143,506.22,143.64,506.14,143.76Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M513.84,149.84a6.27,6.27,0,0,1-2-1.43c-1-.88-1.76-1.7-1.67-1.81s1,.52,2,1.42S513.94,149.74,513.84,149.84Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M518.7,155.44c-.12.08-.55-.29-1-.83s-.67-1.05-.56-1.15.54.28,1,.83S518.82,155.35,518.7,155.44Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M564.94,215.69a6.13,6.13,0,0,1-2.37-.82c-1.26-.58-2.23-1.16-2.16-1.29a6.52,6.52,0,0,1,2.38.82A6.28,6.28,0,0,1,564.94,215.69Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M574.38,219a12.16,12.16,0,0,1-4.78-1.46,12,12,0,0,1,4.78,1.46Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M584.25,220.55a6.18,6.18,0,0,1-2.52,0,6.1,6.1,0,0,1-2.45-.53,6.38,6.38,0,0,1,2.51,0A6.29,6.29,0,0,1,584.25,220.55Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M594.23,220.24a6.2,6.2,0,0,1-2.47.44,6,6,0,0,1-2.52-.07,6.56,6.56,0,0,1,2.48-.45A6.1,6.1,0,0,1,594.23,220.24Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M604.05,218.4a6.42,6.42,0,0,1-2.37.84,6.27,6.27,0,0,1-2.51.25,6.29,6.29,0,0,1,2.4-.75A6.1,6.1,0,0,1,604.05,218.4Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M613.33,214.71c.07.13-.9.7-2.16,1.29a6,6,0,0,1-2.38.8,12.16,12.16,0,0,1,4.54-2.09Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M621.62,209.14c.09.11-.69.93-1.8,1.77a5.52,5.52,0,0,1-2.19,1.24c-.08-.12.78-.83,1.88-1.65A7,7,0,0,1,621.62,209.14Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M628.42,201.84a5.56,5.56,0,0,1-1.33,2.15c-.89,1.07-1.75,1.81-1.85,1.71s.58-1,1.45-2S628.3,201.76,628.42,201.84Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M633.1,193a5.34,5.34,0,0,1-.69,2.43,5.56,5.56,0,0,1-1.34,2.14,7.37,7.37,0,0,1,.86-2.36A7.59,7.59,0,0,1,633.1,193Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M635,183.26a5.28,5.28,0,0,1,.11,2.52,5.18,5.18,0,0,1-.62,2.45,7.78,7.78,0,0,1,.1-2.5A7.6,7.6,0,0,1,635,183.26Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M633.51,173.4a5.45,5.45,0,0,1,.9,2.36,5.32,5.32,0,0,1,.21,2.51,7.43,7.43,0,0,1-.72-2.39A7.59,7.59,0,0,1,633.51,173.4Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M629.16,164.44c.11-.09.87.77,1.57,2a5.2,5.2,0,0,1,.94,2.33c-.13.07-.71-.89-1.39-2.07A7.72,7.72,0,0,1,629.16,164.44Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M622.22,157.3a5.22,5.22,0,0,1,2.13,1.36c1.06.91,1.75,1.81,1.65,1.91s-1-.63-2-1.52S622.14,157.42,622.22,157.3Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M613.15,153.24a5,5,0,0,1,2.5.41,5.18,5.18,0,0,1,2.25,1.15,7.82,7.82,0,0,1-2.41-.66A8.19,8.19,0,0,1,613.15,153.24Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M603.24,153.41a4.83,4.83,0,0,1,2.42-.73,5,5,0,0,1,2.53.08,26.92,26.92,0,0,1-5,.65Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M594.62,158.23c-.11-.09.58-1,1.71-1.87a4.71,4.71,0,0,1,2.26-1.15c.07.14-.87.75-2,1.57S594.73,158.33,594.62,158.23Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M590.66,167.21a4.57,4.57,0,0,1,.15-2.53,4.42,4.42,0,0,1,1.05-2.31,10.86,10.86,0,0,1-.55,2.43A9.63,9.63,0,0,1,590.66,167.21Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M592.61,176.9a4.86,4.86,0,0,1-1.21-2.22,4.72,4.72,0,0,1-.42-2.5,9,9,0,0,1,.91,2.33A8.62,8.62,0,0,1,592.61,176.9Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M599.15,184.34A5,5,0,0,1,597,183c-1.06-.92-1.71-1.86-1.6-1.95s.92.66,1.94,1.56S599.23,184.22,599.15,184.34Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M608.23,188.41a5.28,5.28,0,0,1-2.48-.47,5.06,5.06,0,0,1-2.25-1.15,7.82,7.82,0,0,1,2.41.66A7.4,7.4,0,0,1,608.23,188.41Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M618.15,189.35a9.23,9.23,0,0,1-5-.11,7.9,7.9,0,0,1,2.5-.12A7.28,7.28,0,0,1,618.15,189.35Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M628,187.53a9.36,9.36,0,0,1-4.84,1.24,7.13,7.13,0,0,1,2.37-.79A7.63,7.63,0,0,1,628,187.53Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M637,183.38a6.27,6.27,0,0,1-2.09,1.4,6.2,6.2,0,0,1-2.33.94,12.18,12.18,0,0,1,4.42-2.34Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M645,177.42c.1.11-.69.91-1.76,1.79a6.49,6.49,0,0,1-2.1,1.39c-.09-.12.71-.92,1.77-1.79A6.58,6.58,0,0,1,645,177.42Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M651.85,170.11c.11.09-.53,1-1.43,2.07s-1.72,1.83-1.82,1.73.53-1,1.42-2.07S651.73,170,651.85,170.11Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M657.34,161.77a6.14,6.14,0,0,1-1.06,2.28c-.72,1.19-1.39,2.09-1.51,2a6.19,6.19,0,0,1,1.06-2.28C656.54,162.6,657.21,161.7,657.34,161.77Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M661.4,152.63a6.44,6.44,0,0,1-.67,2.43,5.66,5.66,0,0,1-1.18,2.22,7.14,7.14,0,0,1,.69-2.41A6.29,6.29,0,0,1,661.4,152.63Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M664.19,143a6.07,6.07,0,0,1-.37,2.48,6.26,6.26,0,0,1-.88,2.36,11.95,11.95,0,0,1,1.25-4.84Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M665.94,133.2a6,6,0,0,1-.12,2.51,6.31,6.31,0,0,1-.63,2.43,6,6,0,0,1,.12-2.51A6.38,6.38,0,0,1,665.94,133.2Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M666.86,123.24a11.93,11.93,0,0,1-.37,5,6.47,6.47,0,0,1-.07-2.52A6.31,6.31,0,0,1,666.86,123.24Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M667.18,113.25a6,6,0,0,1,.21,2.5,6,6,0,0,1-.31,2.5,6.55,6.55,0,0,1-.21-2.51A6.39,6.39,0,0,1,667.18,113.25Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M667.11,103.25a6.27,6.27,0,0,1,.3,2.5,6,6,0,0,1-.23,2.5,6.31,6.31,0,0,1-.3-2.5A6.43,6.43,0,0,1,667.11,103.25Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M667,97.1c.14,0,.27.25.28.57s-.1.57-.25.58-.27-.25-.27-.57S666.82,97.1,667,97.1Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<g id='envelope-3' className='envelope'>
					<rect
						x='623.19'
						y='70.99'
						width='68.37'
						height='46.09'
						transform='translate(-47.33 25.21) rotate(-6.2)'
						fill='#218284'
					/>
					<path
						d='M625.85,120.66v0l-5-45.84h0l68-7.38v0l5,45.85h0Zm-4.92-45.82,5,45.77,67.92-7.38-5-45.77Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M689.15,68a4.68,4.68,0,0,1-.57.68l-1.71,1.87-6.39,6.78L659.19,99.55l-.17.19-.22-.14-.52-.33L632,82.46,624,77.31l-2.14-1.43a5.91,5.91,0,0,1-.73-.53,4.5,4.5,0,0,1,.8.42l2.2,1.33,8,5,26.41,16.66.52.33-.39,0L680.17,77l6.53-6.64,1.79-1.78A4.87,4.87,0,0,1,689.15,68Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M626.15,121.16c-.14-.09,4.29-6.93,9.89-15.26s10.27-15,10.41-14.92-4.28,6.93-9.89,15.26S626.29,121.26,626.15,121.16Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M669,88c.13-.12,5.86,5.57,12.8,12.7s12.47,13,12.35,13.13-5.85-5.56-12.8-12.7S668.86,88.07,669,88Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
				</g>
			</g>
			<g id='Envelope_2' data-name='Envelope 2'>
				<path
					d='M378.47,206.35c.14,0,.35.51.47,1.19s.09,1.25-.05,1.28-.35-.51-.47-1.2S378.33,206.37,378.47,206.35Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M376.87,196.59a6.2,6.2,0,0,1,.65,2.4,6.11,6.11,0,0,1,.14,2.48,5.94,5.94,0,0,1-.65-2.4A6.11,6.11,0,0,1,376.87,196.59Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M375.44,186.81a6,6,0,0,1,.6,2.41,6.17,6.17,0,0,1,.09,2.48,5.84,5.84,0,0,1-.6-2.41A6.17,6.17,0,0,1,375.44,186.81Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M374.32,177a6.22,6.22,0,0,1,.52,2.43,5.88,5.88,0,0,1,0,2.48,6.12,6.12,0,0,1-.51-2.43A6,6,0,0,1,374.32,177Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M373.63,167.12a11.89,11.89,0,0,1,.28,4.94,11.87,11.87,0,0,1-.28-4.94Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M373.53,157.23a12.14,12.14,0,0,1,0,5,5.85,5.85,0,0,1-.25-2.47A6,6,0,0,1,373.53,157.23Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M374.15,147.37a6.33,6.33,0,0,1,.05,2.49,6.14,6.14,0,0,1-.46,2.44,5.93,5.93,0,0,1-.06-2.48A6.06,6.06,0,0,1,374.15,147.37Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M375.63,137.6a5.84,5.84,0,0,1-.17,2.48,6,6,0,0,1-.69,2.39,12.16,12.16,0,0,1,.86-4.87Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M378.16,128.05a6.27,6.27,0,0,1-.46,2.44,6.34,6.34,0,0,1-.95,2.3,6,6,0,0,1,.45-2.45A5.88,5.88,0,0,1,378.16,128.05Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M381.85,118.88a6.06,6.06,0,0,1-.76,2.37,6.21,6.21,0,0,1-1.23,2.16,12,12,0,0,1,2-4.53Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M386.67,110.26a6.17,6.17,0,0,1-1.05,2.25c-.7,1.16-1.37,2-1.5,2a6.18,6.18,0,0,1,1.06-2.25C385.88,111.07,386.55,110.18,386.67,110.26Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M392.6,102.35c.11.1-.49,1-1.34,2.09s-1.64,1.85-1.76,1.76a6.26,6.26,0,0,1,1.35-2.09C391.71,103.05,392.5,102.26,392.6,102.35Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M399.63,95.4c.09.12-.65.95-1.65,1.87s-1.9,1.57-2,1.47.64-.93,1.65-1.86S399.54,95.29,399.63,95.4Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M407.71,89.72c.07.13-.8.82-1.95,1.55a6.09,6.09,0,0,1-2.22,1.11c-.08-.11.79-.81,1.94-1.55A6.34,6.34,0,0,1,407.71,89.72Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M416.71,85.67a6,6,0,0,1-2.21,1.14,6.05,6.05,0,0,1-2.39.66,6.08,6.08,0,0,1,2.21-1.14A6,6,0,0,1,416.71,85.67Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M423.93,83.89c0,.14-.5.36-1.17.49s-1.25.12-1.28,0,.5-.36,1.18-.49S423.91,83.75,423.93,83.89Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<g id='envelope-2' className='envelope'>
					<rect
						x='371.32'
						y='45.95'
						width='50.11'
						height='74.34'
						transform='translate(134.87 376.53) rotate(-68.86)'
						fill='#218284'
					/>
					<path
						d='M422,119.93h0L352.64,93.1v0l18.09-46.76h0l69.36,26.82v0ZM352.7,93.07,422,119.86l18.06-46.69-69.3-26.79Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M440.08,73.81a4.77,4.77,0,0,1-.88.37l-2.59.94-9.55,3.36L395.38,89.36l-.26.09-.14-.24-.34-.58-17-29.37-5.09-8.94-1.35-2.45a5,5,0,0,1-.44-.88,5.53,5.53,0,0,1,.55.81l1.47,2.39L378,59c4.44,7.54,10.5,17.87,17.19,29.27l.34.58-.4-.15L426.91,78l9.62-3.15,2.63-.83A4.38,4.38,0,0,1,440.08,73.81Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M352.67,93.73c-.09-.16,7.6-4.55,17.18-9.8s17.41-9.38,17.5-9.22-7.6,4.55-17.18,9.81S352.76,93.89,352.67,93.73Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M410.63,83c.18-.05,2.87,8.3,6,18.65s5.55,18.8,5.37,18.85-2.87-8.29-6-18.65S410.45,83.09,410.63,83Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
				</g>
			</g>
			<g id='Envelope_1' data-name='Envelope 1'>
				<path
					d='M349.35,217.29c.14,0,.21.58.16,1.27s-.22,1.24-.36,1.23-.22-.58-.16-1.27S349.21,217.28,349.35,217.29Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M349.6,207.12a6.33,6.33,0,0,1,.26,2.55,6.55,6.55,0,0,1-.27,2.54,6.41,6.41,0,0,1-.25-2.54A6.63,6.63,0,0,1,349.6,207.12Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M348.91,197a12.78,12.78,0,0,1,.47,5.07,6.17,6.17,0,0,1-.49-2.51A6.61,6.61,0,0,1,348.91,197Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M347.22,186.94a6.51,6.51,0,0,1,.74,2.45,6.44,6.44,0,0,1,.23,2.55,6.59,6.59,0,0,1-.74-2.45A6.22,6.22,0,0,1,347.22,186.94Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M344.45,177.15A12.48,12.48,0,0,1,346,182a6.42,6.42,0,0,1-1-2.35A6.35,6.35,0,0,1,344.45,177.15Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M340.56,167.76a6.32,6.32,0,0,1,1.28,2.21,6.54,6.54,0,0,1,.81,2.43,6.57,6.57,0,0,1-1.28-2.21A6.43,6.43,0,0,1,340.56,167.76Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M335.51,158.93c.12-.08.84.82,1.6,2a6.65,6.65,0,0,1,1.08,2.33c-.13.07-.81-.85-1.53-2.06A6.45,6.45,0,0,1,335.51,158.93Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M329.28,150.9c.11-.1.93.7,1.83,1.78a6.58,6.58,0,0,1,1.43,2.13c-.12.08-.93-.72-1.83-1.79A6.49,6.49,0,0,1,329.28,150.9Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M322,143.82c.09-.11,1,.57,2.06,1.51s1.81,1.8,1.71,1.9a6.51,6.51,0,0,1-2.06-1.51C322.65,144.78,321.88,143.93,322,143.82Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M313.73,137.88a6.34,6.34,0,0,1,2.26,1.19c1.17.78,2.06,1.51,2,1.63a6.62,6.62,0,0,1-2.26-1.2C314.54,138.73,313.65,138,313.73,137.88Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M304.67,133.26a6.35,6.35,0,0,1,2.42.83,6.43,6.43,0,0,1,2.2,1.3,6.35,6.35,0,0,1-2.42-.83A6.56,6.56,0,0,1,304.67,133.26Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M295,130.19a6.59,6.59,0,0,1,2.53.41,6.4,6.4,0,0,1,2.39.92,6.75,6.75,0,0,1-2.53-.41A6.6,6.6,0,0,1,295,130.19Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M284.89,128.9a10.39,10.39,0,0,1,5.07.41,15.84,15.84,0,0,1-5.07-.41Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M274.75,129.6a12.53,12.53,0,0,1,5.06-.6,6.34,6.34,0,0,1-2.5.56A6.66,6.66,0,0,1,274.75,129.6Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M264.93,132.22a6.32,6.32,0,0,1,2.35-1,6.25,6.25,0,0,1,2.5-.52,6.53,6.53,0,0,1-2.35,1A6.64,6.64,0,0,1,264.93,132.22Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M255.77,136.63c-.07-.13.87-.77,2.12-1.44a6.32,6.32,0,0,1,2.36-1,12.86,12.86,0,0,1-4.48,2.43Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M247.65,142.73c-.1-.1.7-.92,1.78-1.83a6.58,6.58,0,0,1,2.13-1.43c.08.12-.72.94-1.79,1.83A6.28,6.28,0,0,1,247.65,142.73Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M241,150.41a5.73,5.73,0,0,1,1.29-2.22c.87-1.12,1.72-1.9,1.82-1.81s-.55,1-1.41,2.13S241.12,150.49,241,150.41Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M237.29,157c-.13-.06,0-.61.31-1.24s.65-1.08.78-1,0,.62-.31,1.24S237.42,157.07,237.29,157Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M173.75,216c0-.14.53-.32,1.21-.41s1.25,0,1.27.11-.51.33-1.21.41S173.76,216.17,173.75,216Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M163.85,214.9a7.91,7.91,0,0,1,2.48.37,7.73,7.73,0,0,1,2.42.66,8.57,8.57,0,0,1-4.9-1Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M154.89,210.47a7.54,7.54,0,0,1,2.24,1.14c1.18.7,2.13,1.29,2.07,1.43a5.58,5.58,0,0,1-2.33-1C155.67,211.34,154.81,210.59,154.89,210.47Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M147.45,203.79c.11-.09.93.67,1.9,1.65s1.72,1.81,1.63,1.92-1-.56-2-1.55S147.34,203.89,147.45,203.79Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M141.57,195.69c.13-.07.84.8,1.59,2a6.42,6.42,0,0,1,1.16,2.23c-.12.09-.83-.79-1.59-1.95A6.18,6.18,0,0,1,141.57,195.69Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M137.25,186.66a6.28,6.28,0,0,1,1.22,2.2,6.65,6.65,0,0,1,.75,2.41,6.21,6.21,0,0,1-1.23-2.2A6.39,6.39,0,0,1,137.25,186.66Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M134.38,177.06a6.36,6.36,0,0,1,.89,2.36,6.2,6.2,0,0,1,.38,2.49,6.08,6.08,0,0,1-.89-2.36A6.22,6.22,0,0,1,134.38,177.06Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M132.64,167.19a6.54,6.54,0,0,1,.63,2.44,6.29,6.29,0,0,1,.12,2.52,6.19,6.19,0,0,1-.63-2.44A6.08,6.08,0,0,1,132.64,167.19Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M131.68,157.22a12.12,12.12,0,0,1,.4,5,6.2,6.2,0,0,1-.46-2.47A6.1,6.1,0,0,1,131.68,157.22Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M131.26,149.71c.15,0,.29.55.32,1.24s-.06,1.25-.2,1.26-.29-.55-.32-1.24S131.12,149.72,131.26,149.71Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<g id='envelope-1' className='envelope'>
					<rect
						x='87.04'
						y='91.01'
						width='83.24'
						height='56.11'
						transform='translate(-46.48 -40.12) rotate(-2.7)'
						fill='#218284'
					/>
					<path
						d='M88.38,149.07v0L85.74,93h0l83.18-3.92v0l2.64,56.07h0ZM85.79,93l2.64,56,83.1-3.92-2.64-56Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M169.21,89.74a5.48,5.48,0,0,1-.74.78l-2.22,2.14L158,100.43,130.46,125.9l-.23.21-.25-.18-.6-.44L98.65,103.11c-3.86-2.86-7-5.19-9.26-6.85l-2.49-1.9a5.48,5.48,0,0,1-.84-.7,6.86,6.86,0,0,1,.93.58L89.57,96l9.4,6.66,30.85,22.2.61.44-.48,0L157.63,100l8.42-7.59,2.32-2A5.14,5.14,0,0,1,169.21,89.74Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M88.7,149.71c-.16-.13,5.73-8.11,13.16-17.82s13.59-17.48,13.75-17.36-5.72,8.11-13.15,17.82S88.87,149.83,88.7,149.71Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
					<path
						d='M143.22,112.53c.16-.14,6.7,7.2,14.6,16.38s14.19,16.74,14,16.88-6.69-7.2-14.6-16.39S143.06,112.67,143.22,112.53Z'
						transform='translate(-41.02 -46.31)'
						fill='#263238'
					/>
				</g>
			</g>
			<g id='Character'>
				<path
					d='M234.57,288.16a2.27,2.27,0,0,0-1.72-2.53l-2.23.15-8-2.77a2.39,2.39,0,0,0-3,2.17c0,2.29-1,8.53-2.81,6.57l-.14-.13c-2.63-2.93-5.67-4.35-6.84-4.18a1.34,1.34,0,0,0-.58,2.36,1.41,1.41,0,0,0,.48.33c.08,0,.18.1.26.14a20.21,20.21,0,0,1,3.05,2.73,10.6,10.6,0,0,1,2,3c.53,1.24.95,2.32,1.28,3.25l.12,7.33-3.18,34.27s-21.1-22.16-20.61-22.37L193.88,353l12.78,10.57A16.07,16.07,0,0,0,233,350.92l-.73-44.31.52-5.81Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M116.11,336.88,93,389.72,74.76,427.84,61.19,432.4s-10.74,3.12-10.74,5.34,2.83,1.72,2.83,1.72c.52,3.32,5.12,1.44,8.34,0S72,437.62,72,437.62a2.91,2.91,0,0,0-.2,4.66c1.14.8,3.12-.17,4.46-1.6s4.8-2.09,8.65-3.47,4.48-6.54,4.48-6.54L135.6,352.8Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M192.75,356.07l5.81,7.67,12.59-27.93s-12.22-14.91-16.69-21.16-7.75-7.28-7.75-7.28S178.59,305,174.54,305l-20.06,1.2-20.37,8.89a28.22,28.22,0,0,0-12.27,10.33l-19.18,30.81,27.16,11.61L138.93,420c1.74,7.81,3.27,15.18,10.48,18.78l50.37-48.41-5.9-9.3Z'
					transform='translate(-41.02 -46.31)'
					fill='#218284'
				/>
				<path
					d='M144.59,346.52c.12.08-3,4.9-6.93,10.78s-7.25,10.56-7.36,10.48,3-4.9,6.93-10.78S144.47,346.44,144.59,346.52Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M186.82,396a9.38,9.38,0,0,1-1.34.8c-.87.48-2.15,1.16-3.74,2-3.19,1.65-7.61,3.86-12.56,6.19s-9.47,4.34-12.77,5.74c-1.65.7-3,1.26-3.92,1.63a9.79,9.79,0,0,1-1.47.52,8.81,8.81,0,0,1,1.39-.71l3.85-1.77c3.26-1.49,7.76-3.55,12.7-5.88s9.39-4.49,12.61-6l3.82-1.84A9.17,9.17,0,0,1,186.82,396Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M143,335.24a17.83,17.83,0,0,1-1.77-2.23,35.61,35.61,0,0,0-4.47-5.1,15.79,15.79,0,0,0-5.77-3.39c-1.65-.52-2.75-.5-2.75-.6a2,2,0,0,1,.77-.06,9.88,9.88,0,0,1,2.08.3,14.71,14.71,0,0,1,6,3.36,28.75,28.75,0,0,1,4.42,5.28A14.31,14.31,0,0,1,143,335.24Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M184.42,360.61a2.07,2.07,0,0,1,0,.56c0,.36,0,.89,0,1.58a36.9,36.9,0,0,1-.81,5.77,41.34,41.34,0,0,1-23.27,29,38,38,0,0,1-5.46,2c-.66.2-1.19.31-1.54.39a2.2,2.2,0,0,1-.54.1s.72-.25,2-.68a44.81,44.81,0,0,0,5.36-2.18,42.32,42.32,0,0,0,23.08-28.77,46.33,46.33,0,0,0,1-5.71C184.33,361.37,184.38,360.61,184.42,360.61Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<g opacity='0.3'>
					<path
						d='M133.34,388c-.09-.5,6.46-34.36,6.46-34.36l-9.88,14.83'
						transform='translate(-41.02 -46.31)'
					/>
				</g>
				<path
					d='M191.46,323.57a2.45,2.45,0,0,1,.07.58c0,.44.06,1,.11,1.68.07,1.52.18,3.6.31,6.15.25,5.26.6,12.41,1,20.3s.68,15.12.83,20.32c.08,2.6.13,4.71.15,6.16v1.68a2.17,2.17,0,0,1,0,.58,2.45,2.45,0,0,1-.07-.58c0-.44-.06-1-.11-1.67-.07-1.52-.18-3.61-.31-6.15-.25-5.26-.6-12.41-1-20.31s-.67-15.11-.83-20.32c-.08-2.6-.13-4.7-.15-6.16v-1.67A2.23,2.23,0,0,1,191.46,323.57Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<g opacity='0.2'>
					<path
						d='M151.26,412.79c-1.62-1.34-1.25-4.08.18-5.62S155,405,157,404.32c9.57-3.1,19.19-7.48,25.5-15.32a15.45,15.45,0,0,1,2.83-3,3.91,3.91,0,0,1,3.93-.54c1.93,1,2,3.8,1.19,5.83a11.18,11.18,0,0,1-5.27,5.76'
						transform='translate(-41.02 -46.31)'
					/>
				</g>
				<g opacity='0.2'>
					<polygon points='150.65 283.27 156.24 315.7 151.88 309.95 150.65 283.27' />
				</g>
				<path
					d='M244.85,414.79l-9.45,32.42,40.27,12c.91-3.92-17.63-17.83-17.63-17.83L265,420.82Z'
					transform='translate(-41.02 -46.31)'
					fill='#363d3d'
				/>
				<g opacity='0.6'>
					<path
						d='M246.11,435.9a1.71,1.71,0,0,0-1.7,1.53,1.66,1.66,0,0,0,1.51,1.7,1.82,1.82,0,0,0,1.79-1.64,1.71,1.71,0,0,0-1.77-1.59'
						transform='translate(-41.02 -46.31)'
						fill='#fff'
					/>
				</g>
				<g opacity='0.6'>
					<path
						d='M235.4,447.21l1.08-3.23,38.21,12.68s1.56,1.31,1,2.51Z'
						transform='translate(-41.02 -46.31)'
						fill='#fff'
					/>
				</g>
				<path
					d='M258.75,441.33c-.06.19-1.07,0-2.23.34s-1.91,1-2.07.88.47-1.18,1.88-1.57S258.85,441.16,258.75,441.33Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M262.46,444.33c0,.21-1,.29-1.88.92s-1.37,1.46-1.56,1.39,0-1.22,1.16-2S262.51,444.14,262.46,444.33Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M263.36,450.1c-.2,0-.18-1.08.65-2s1.87-1.08,1.9-.9-.7.6-1.37,1.37S263.56,450.14,263.36,450.1Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M259.81,436.48c-.14.15-1-.39-2.09-.64s-2.11-.16-2.16-.36,1-.65,2.32-.34S260,436.35,259.81,436.48Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M260.27,431.42a4,4,0,0,1-2-.61,9.14,9.14,0,0,1-1.92-1.28,9.78,9.78,0,0,1-1-1,2.47,2.47,0,0,1-.46-.65.9.9,0,0,1,.22-1.08,1.13,1.13,0,0,1,1-.19,2.91,2.91,0,0,1,.73.33,8,8,0,0,1,1.12.8,7.35,7.35,0,0,1,1.5,1.78,3.47,3.47,0,0,1,.7,2c-.11,0-.38-.72-1.12-1.71a8,8,0,0,0-1.5-1.55,7.37,7.37,0,0,0-1.05-.7c-.39-.24-.75-.35-.92-.19s-.07.08,0,.23a1.86,1.86,0,0,0,.34.48,11.34,11.34,0,0,0,.89.93,12.56,12.56,0,0,0,1.72,1.33C259.56,431,260.31,431.31,260.27,431.42Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M259.93,431.62a3.31,3.31,0,0,1,.05-2.1,6.55,6.55,0,0,1,.93-2.13,6.17,6.17,0,0,1,.88-1.07,1.73,1.73,0,0,1,1.59-.64,1,1,0,0,1,.67.81,3,3,0,0,1,0,.8,4.7,4.7,0,0,1-.4,1.36,5,5,0,0,1-1.48,1.83c-1.1.81-2,.8-2,.73s.76-.29,1.66-1.12a4.74,4.74,0,0,0,1.2-1.7,4.1,4.1,0,0,0,.31-1.18c.07-.45,0-.84-.16-.84s-.64.16-.91.45a7.88,7.88,0,0,0-.82.94,7.56,7.56,0,0,0-1,1.9C260.06,430.82,260.05,431.62,259.93,431.62Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M286.2,366.52c1,7.48-1.54,15.91-4.25,23L264.29,431l-19.55-3s-4.07,4.54-9.28,6.28c-2.33.77-10,2.28-16.31-2.26h0s-8.93,12.44-23,16.2-35.32,5.84-45.62-10.6l49-47.24c1,.24,42.23-27.56,64.5-33.89C264.07,356.49,284.32,352.77,286.2,366.52Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M243.29,427.84s.08-.06.26-.16l.8-.42c.71-.38,1.75-.91,3.07-1.64a49.88,49.88,0,0,0,4.68-2.88,24.65,24.65,0,0,0,5.29-4.91,17,17,0,0,0,3.43-7.94,26.38,26.38,0,0,0-.42-10,16.15,16.15,0,0,0-5.39-9.39,20.41,20.41,0,0,0-11-3.92,33.91,33.91,0,0,0-6.05.05,45.45,45.45,0,0,0-5.81,1,69.19,69.19,0,0,0-10.55,3.65c-6.53,2.86-12.2,5.94-17.18,8.07a61.15,61.15,0,0,1-12.15,4.05c-.74.17-1.41.28-2,.36s-1.06.17-1.46.2l-.9.09h-.31l.31-.07.89-.13c.39-.06.88-.13,1.45-.25s1.23-.22,2-.4a64.21,64.21,0,0,0,12-4.2c4.94-2.16,10.59-5.27,17.14-8.17a69,69,0,0,1,10.62-3.7,46.41,46.41,0,0,1,5.87-1,35.05,35.05,0,0,1,6.15-.05,20.82,20.82,0,0,1,11.32,4.05,14.24,14.24,0,0,1,3.67,4.46,20.3,20.3,0,0,1,1.87,5.22,27.06,27.06,0,0,1,.38,10.17,17.49,17.49,0,0,1-3.57,8.09,24.36,24.36,0,0,1-5.42,4.92,49.2,49.2,0,0,1-4.74,2.82c-1.34.7-2.4,1.21-3.12,1.55l-.83.38A1.27,1.27,0,0,1,243.29,427.84Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M255.55,373.35a57.67,57.67,0,0,1-4.1,6.69,60.53,60.53,0,0,1-4.53,6.4,59.41,59.41,0,0,1,4.1-6.69A60.53,60.53,0,0,1,255.55,373.35Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M241.45,424.54a34.55,34.55,0,0,1-3.55.92c-2.19.54-5.2,1.37-8.46,2.51s-6.13,2.37-8.18,3.31-3.31,1.57-3.35,1.5a4,4,0,0,1,.82-.55c.55-.33,1.36-.77,2.37-1.28a68.25,68.25,0,0,1,16.72-5.85c1.11-.23,2-.39,2.65-.47A4,4,0,0,1,241.45,424.54Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M263.94,428.28c-.09,0-.32-.88-1.15-2.1a8.47,8.47,0,0,0-10.06-3.27c-1.39.5-2.12,1.11-2.18,1s.14-.2.48-.47a7.08,7.08,0,0,1,1.56-.9A8.33,8.33,0,0,1,263.1,426a6.89,6.89,0,0,1,.73,1.65C264,428,264,428.28,263.94,428.28Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M179.36,412.79a2.69,2.69,0,0,1,.26.93,15.17,15.17,0,0,1,.22,2.63,16.28,16.28,0,0,1-2.3,8.36,12.8,12.8,0,0,1-6.7,5.44,9.62,9.62,0,0,1-2.6.5,2.68,2.68,0,0,1-1,0,18.68,18.68,0,0,0,3.45-.8,13,13,0,0,0,6.38-5.37,17.1,17.1,0,0,0,2.38-8.08C179.57,414.15,179.27,412.8,179.36,412.79Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M157.31,435.22c-.11.09-.63-.36-1.12-1s-.75-1.33-.62-1.4.57.43,1.05,1.09S157.42,435.13,157.31,435.22Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M161.42,439.57c-.09.11-.65-.28-1.25-.86s-1-1.13-.9-1.22.67.28,1.26.85S161.52,439.46,161.42,439.57Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M166.28,443.08c-.07.12-.7-.14-1.4-.6s-1.2-.92-1.12-1,.72.16,1.4.6S166.35,443,166.28,443.08Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M171.78,445.44c0,.14-.71,0-1.5-.26s-1.38-.62-1.32-.76.73,0,1.49.27S171.82,445.3,171.78,445.44Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M177.69,446.37c0,.14-.68.2-1.52.12s-1.49-.25-1.47-.39.71-.2,1.52-.12S177.69,446.23,177.69,446.37Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M183.67,446.05c0,.14-.65.3-1.48.36a6.7,6.7,0,0,1-1.12,0h0c-.25,0-.4-.06-.41-.13s.13-.14.37-.21h0a6.37,6.37,0,0,1,1.1-.16C183,445.83,183.65,445.9,183.67,446.05Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M189.56,445c0,.14-.59.39-1.41.57s-1.49.2-1.51.06.6-.4,1.41-.57S189.53,444.84,189.56,445Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M195.3,443.23c0,.14-.55.46-1.34.73s-1.47.36-1.51.23.56-.46,1.34-.73S195.25,443.1,195.3,443.23Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M200.81,440.89c.07.13-.5.52-1.25.86s-1.42.52-1.48.39.51-.52,1.26-.86S200.75,440.76,200.81,440.89Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M206.07,438c.07.12-.45.56-1.17,1s-1.36.65-1.42.53.45-.57,1.16-1S206,437.89,206.07,438Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M211,434.63c.09.12-.39.6-1.07,1.09s-1.29.78-1.37.66.4-.61,1.07-1.09S210.93,434.52,211,434.63Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M215.64,430.81c.1.11-.34.64-1,1.18s-1.22.9-1.31.79.34-.64,1-1.18S215.54,430.71,215.64,430.81Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M220,426.69c.1.11-.31.66-.91,1.22s-1.18.94-1.27.84.3-.64.91-1.22S219.91,426.59,220,426.69Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M224.74,423c.08.12-.39.61-1.06,1.09s-1.28.78-1.37.67.39-.6,1.06-1.09S224.66,422.89,224.74,423Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M230,420.11c.06.13-.5.53-1.23.9s-1.39.56-1.46.43.48-.53,1.23-.9S229.94,420,230,420.11Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M235.72,418.33c0,.14-.6.42-1.39.61s-1.48.25-1.52.12.58-.42,1.39-.62S235.7,418.19,235.72,418.33Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M241.7,418c0,.15-.69.2-1.51.18s-1.48-.09-1.49-.23.66-.3,1.5-.29S241.71,417.88,241.7,418Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M247.48,419.54c-.07.13-.71-.06-1.47-.33s-1.39-.54-1.36-.68.73-.1,1.53.19S247.54,419.41,247.48,419.54Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M246.21,423.89c-.09-.12.36-.61.89-1.21s1-1.1,1.09-1-.12.73-.7,1.37S246.3,424,246.21,423.89Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M240.92,426.64c0-.14.53-.5,1.28-.81s1.42-.46,1.49-.33-.51.49-1.29.81S241,426.78,240.92,426.64Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M235.2,428.48c0-.14.55-.46,1.34-.73s1.46-.37,1.51-.23-.56.46-1.34.72S235.25,428.61,235.2,428.48Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M229.6,430.61c-.06-.13.52-.48,1.3-.79s1.44-.44,1.49-.31-.53.49-1.3.8S229.65,430.75,229.6,430.61Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M224.07,433c-.06-.13.51-.51,1.27-.83s1.43-.49,1.48-.36-.51.51-1.27.83S224.12,433.08,224.07,433Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M212.89,261.47s6.54-2,15.23-11.65,12.19-22,13.34-22,6-2.72,17,17.26,7.66,25.07,5.77,25.17-15-2.52-23-1-18,6.46-18,6.46Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M199.6,273.8l2.59,4.15,1.16,1.85a5.65,5.65,0,0,0,7.53,1.95l13.88-6-9.71-18.33L201.37,266A5.65,5.65,0,0,0,199.6,273.8Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M208.33,280.1l5.21,8.56,2.22-.8,15.73,11L235,290.4s-9-3.13-10.9-6.13,0-3.85,0-3.85L219.63,276Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M257.75,245.52c5.89,10.83,8.74,20.66,6.36,22s-9.08-6.43-15-17.26-8.74-20.66-6.36-22S251.85,234.68,257.75,245.52Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<polygon
					points='157.82 233.81 161.6 232.31 158.87 227.94 156.1 229.96 157.82 233.81'
					fill='#455a64'
				/>
				<polygon
					points='180.14 231.22 170.25 238.62 168.77 236.18 180.14 231.22'
					fill='#455a64'
				/>
				<polygon
					points='158.87 227.94 161.6 232.31 160.82 232.62 158.54 228.19 158.87 227.94'
					fill='#455a64'
				/>
				<path
					d='M202.63,275.11a21.52,21.52,0,0,0,4.18-2,21.53,21.53,0,0,0,3.94-2.43,21.83,21.83,0,0,0-4.18,2A21.53,21.53,0,0,0,202.63,275.11Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M201.24,272.49a18.27,18.27,0,0,0,3.77-1.93,19,19,0,0,0,3.53-2.36,35.8,35.8,0,0,0-7.3,4.29Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M204.34,277.84a3.33,3.33,0,0,0,1.19-.36l1.25-.52c.46-.21.94-.49,1.45-.77a16.5,16.5,0,0,0,3.52-2.33,20.42,20.42,0,0,0-3.76,1.89c-.51.28-1,.58-1.42.8s-.85.43-1.19.61C204.72,277.52,204.31,277.77,204.34,277.84Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M247.24,243.79s5.52-4,9.26,3.56-2.24,9.31-2.24,9.31A52.11,52.11,0,0,1,247.24,243.79Z'
					transform='translate(-41.02 -46.31)'
					fill='#455a64'
				/>
				<path
					d='M240.41,234.94a7.34,7.34,0,0,0,.33,1.48c.26.94.62,2.3,1.12,4,.3.82.64,1.71,1,2.67l.56,1.49c.1.25.19.51.29.78s.24.51.36.77l1.56,3.27c.13.29.27.57.41.86s.31.56.47.84l1,1.71,1,1.71c.17.27.32.56.5.82s.37.53.54.79l2.08,3c.17.23.32.47.49.69l.54.65,1,1.22,1.83,2.2c1.21,1.26,2.21,2.24,2.9,2.93a8,8,0,0,0,1.12,1,10.49,10.49,0,0,0-1-1.15l-2.78-3L254,261.38l-1-1.23-.52-.65c-.17-.22-.32-.46-.48-.69l-2-3-.53-.78c-.19-.26-.33-.55-.5-.82l-1-1.7c-.33-.57-.66-1.14-1-1.69-.15-.28-.33-.55-.47-.84s-.27-.57-.41-.85l-1.57-3.23c-.12-.26-.26-.51-.36-.77s-.21-.52-.31-.77c-.2-.51-.39-1-.58-1.47l-1.05-2.64c-.53-1.63-.95-3-1.26-3.91A10.21,10.21,0,0,0,240.41,234.94Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M225.54,280.44a1.69,1.69,0,0,1,1.17,2.05c-.43,1.7-1.13,4.37-1.69,6a4.49,4.49,0,0,1-.75,1.48,1.4,1.4,0,0,1-2.55-.72,4.46,4.46,0,0,1,.15-1.74c.35-1.59,1-4,1.56-5.91a1.69,1.69,0,0,1,2.11-1.16Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M228.25,283.2a1.69,1.69,0,0,1,1.17,2.05c-.43,1.7-1.13,4.37-1.7,6a4.31,4.31,0,0,1-.75,1.48,1.53,1.53,0,0,1-1.48.56,1.57,1.57,0,0,1-1.06-1.29,4.67,4.67,0,0,1,.14-1.74c.36-1.58,1-4,1.56-5.91a1.71,1.71,0,0,1,2.12-1.16Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M230.86,284.86a1.48,1.48,0,0,1,1,1.78c-.37,1.47-1,3.78-1.47,5.19a3.83,3.83,0,0,1-.65,1.29,1.21,1.21,0,0,1-2.2-.63,3.87,3.87,0,0,1,.12-1.51c.31-1.37.87-3.43,1.35-5.12a1.48,1.48,0,0,1,1.83-1Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M233.83,285.19a1.48,1.48,0,0,1,1,1.79c-.37,1.48-1,3.8-1.48,5.22a3.74,3.74,0,0,1-.65,1.29,1.21,1.21,0,0,1-2.21-.63,3.92,3.92,0,0,1,.12-1.52c.31-1.37.87-3.45,1.36-5.14a1.48,1.48,0,0,1,1.84-1Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M224.6,290a10.36,10.36,0,0,1,.73-3.2,10.57,10.57,0,0,1,1.24-3.05,10.21,10.21,0,0,1-.74,3.2A10.73,10.73,0,0,1,224.6,290Z'
					transform='translate(-41.02 -46.31)'
					fill='#eb996e'
				/>
				<path
					d='M230.23,292.27A41,41,0,0,1,232.1,286a13.93,13.93,0,0,1-1.87,6.28Z'
					transform='translate(-41.02 -46.31)'
					fill='#eb996e'
				/>
				<path
					d='M227.44,291.91a41.54,41.54,0,0,1,1.87-6.29,13.92,13.92,0,0,1-1.87,6.29Z'
					transform='translate(-41.02 -46.31)'
					fill='#eb996e'
				/>
				<path
					d='M278.25,207.35c.11.08-4,5.65-9.16,12.43s-9.46,12.21-9.57,12.12,4-5.65,9.15-12.43S278.13,207.26,278.25,207.35Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M305.08,223.22c.06.13-8.56,4.26-19.26,9.22s-19.41,8.88-19.47,8.75,8.56-4.26,19.25-9.22S305,223.09,305.08,223.22Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M301.08,256.24c0,.14-6.16-.33-13.72-1.06s-13.69-1.44-13.68-1.58,6.16.33,13.73,1.06S301.1,256.1,301.08,256.24Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M143.42,274.76l6.79,38.6a12.7,12.7,0,0,0,14.3,10.28h0a12.56,12.56,0,0,0,10.8-14.44l-1.1-6.64s9.5-2.58,8.51-12.12c-.48-4.6-2.24-14-3.94-22.46A18.21,18.21,0,0,0,158,253.75h0A17.76,17.76,0,0,0,143.42,274.76Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M174.23,302.58a22.93,22.93,0,0,1-13-2.11S165,307,174.54,305Z'
					transform='translate(-41.02 -46.31)'
					fill='#eb996e'
				/>
				<path
					d='M176.71,274.42a1.37,1.37,0,0,1-1.17,1.52,1.32,1.32,0,0,1-1.56-1.06,1.37,1.37,0,0,1,1.17-1.53A1.32,1.32,0,0,1,176.71,274.42Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M177,272.11c-.15.2-1.29-.45-2.77-.27s-2.49,1-2.67.86,0-.41.48-.8a3.94,3.94,0,0,1,2.11-.92,3.68,3.68,0,0,1,2.24.45C176.91,271.72,177.11,272,177,272.11Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M162.74,276.1a1.38,1.38,0,0,1-1.17,1.53,1.33,1.33,0,0,1-1.57-1.07,1.37,1.37,0,0,1,1.17-1.52A1.33,1.33,0,0,1,162.74,276.1Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M162.67,274c-.15.19-1.28-.45-2.77-.28s-2.49,1-2.67.87.05-.41.49-.81a3.8,3.8,0,0,1,2.11-.91,3.74,3.74,0,0,1,2.23.44C162.56,273.64,162.75,274,162.67,274Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M169.33,285.16a10.52,10.52,0,0,1,2.37-.7c.37-.08.72-.2.76-.46a1.93,1.93,0,0,0-.39-1.08l-1.45-2.72c-2-3.87-3.55-7.08-3.39-7.16s1.94,3,4,6.88c.49.95,1,1.86,1.4,2.74a2.1,2.1,0,0,1,.37,1.44.94.94,0,0,1-.56.62,2.53,2.53,0,0,1-.63.16A10.06,10.06,0,0,1,169.33,285.16Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M165.08,286.67c.24,0,.43,1.54,1.94,2.52s3.21.6,3.24.82-.34.35-1.07.45a4.09,4.09,0,0,1-2.7-.59,3.48,3.48,0,0,1-1.52-2.13C164.83,287.08,165,286.67,165.08,286.67Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M162.39,269.14c-.1.41-1.61.39-3.33.79s-3.07,1-3.34.71c-.13-.16.07-.57.6-1a6.09,6.09,0,0,1,5.08-1.14C162.07,268.66,162.43,268.94,162.39,269.14Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M176.21,268.82c-.22.36-1.29.13-2.52.25s-2.25.48-2.53.16c-.12-.15,0-.51.42-.87a3.47,3.47,0,0,1,2-.78,3.58,3.58,0,0,1,2.09.44C176.12,268.32,176.3,268.64,176.21,268.82Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M178.83,251.68a3.37,3.37,0,0,0-4.39.27,3,3,0,0,0-.85-4,5.16,5.16,0,0,0-4.37-.63,14.83,14.83,0,0,0-4.09,2,1.54,1.54,0,0,0-.67-1.56,3.7,3.7,0,0,0-1.72-.54,13.11,13.11,0,0,0-7.21,1.62,45,45,0,0,0-6.67,4.53h0a31.87,31.87,0,0,0-6.1,6.52l-.08.07c-1.41,1.26-2.6,5.06-2.39,6.92.79,6.87,3.07,10.84,4.35,17.34a2.28,2.28,0,0,0,.49,1.21c.79.82,2.21.12,3-.74a12.28,12.28,0,0,0,2.54-7.73c.09-2.76-.31-5.51-.24-8.27v-.2a15.5,15.5,0,0,1,.2-2.1c.12-.45,1.29-4.39,5.08-5,4-.68,11.95,3.22,15.88,2.6s4.14-3.39,4.14-3.39l2.31,4.7a14.23,14.23,0,0,0,.37-5.87,6.67,6.67,0,0,0,2-3.43A4.41,4.41,0,0,0,178.83,251.68Z'
					transform='translate(-41.02 -46.31)'
					fill='#263238'
				/>
				<path
					d='M147.19,278.86c-.17-.05-6.87-1.18-5.9,5.31s7.39,4.19,7.37,4S147.19,278.86,147.19,278.86Z'
					transform='translate(-41.02 -46.31)'
					fill='#ffbe9d'
				/>
				<path
					d='M146.28,286s-.1.1-.28.21a1.19,1.19,0,0,1-.86.15,2.85,2.85,0,0,1-1.69-2.32,3.86,3.86,0,0,1,.08-1.67,1.31,1.31,0,0,1,.74-1,.6.6,0,0,1,.72.21c.11.17.09.31.13.31s.12-.13,0-.39a.83.83,0,0,0-.32-.37.92.92,0,0,0-.66-.07,1.64,1.64,0,0,0-1,1.18,3.87,3.87,0,0,0-.12,1.87,3,3,0,0,0,2.09,2.56,1.25,1.25,0,0,0,1-.33C146.29,286.16,146.3,286,146.28,286Z'
					transform='translate(-41.02 -46.31)'
					fill='#eb996e'
				/>
				<path
					d='M132.4,325.85a1.2,1.2,0,0,1,.57-.09,2.24,2.24,0,0,1,1.48.74,3.22,3.22,0,0,1,.86,2.46,14.31,14.31,0,0,1-.76,3.36,4.58,4.58,0,0,0,.23,3.85c.71,1.24,2.16,2.19,2.75,3.92a4.61,4.61,0,0,1-1.45,5,4.68,4.68,0,0,1-2.7,1.05,9.88,9.88,0,0,1-2.89-.47,5.24,5.24,0,0,0-2.7-.17,3.92,3.92,0,0,0-2,1.62,13.82,13.82,0,0,1-1.7,2.13,3.4,3.4,0,0,1-2.53.93,5,5,0,0,1-4-2.65,9.78,9.78,0,0,1-1-4.08c-.07-1.28,0-2.43,0-3.43a17.18,17.18,0,0,0-.22-2.55,13.07,13.07,0,0,0-.61-2.1,2.07,2.07,0,0,1,.28.5,6.65,6.65,0,0,1,.52,1.56,14.26,14.26,0,0,1,.32,2.58c0,1,0,2.16.13,3.42a9.33,9.33,0,0,0,1,3.89,4.61,4.61,0,0,0,3.63,2.38,2.89,2.89,0,0,0,2.17-.82,13.33,13.33,0,0,0,1.63-2.06,4.43,4.43,0,0,1,2.26-1.82,5.6,5.6,0,0,1,3,.17,10.05,10.05,0,0,0,2.74.45,4.18,4.18,0,0,0,2.41-.93,4.13,4.13,0,0,0,1.32-4.47c-.49-1.53-1.9-2.5-2.68-3.85a4.06,4.06,0,0,1-.57-2.17,8.26,8.26,0,0,1,.36-2,14.47,14.47,0,0,0,.83-3.28,3,3,0,0,0-.72-2.31,2.24,2.24,0,0,0-1.34-.76C132.6,325.82,132.4,325.88,132.4,325.85Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M135.15,395.84s.07.24.3.62a2.61,2.61,0,0,0,1.55,1.08,3.15,3.15,0,0,0,2.86-.6,6,6,0,0,0,1.91-3.5c.32-1.49.26-3.19.55-5a8,8,0,0,1,.92-2.73,4.56,4.56,0,0,1,2.3-2.06,6.48,6.48,0,0,1,3.21-.29c1.09.11,2.16.36,3.24.5a7.85,7.85,0,0,0,3.27-.16,7.47,7.47,0,0,0,2.92-1.62,6.35,6.35,0,0,0,1.8-2.79,5.34,5.34,0,0,0-.06-3.19,5.49,5.49,0,0,0-4.35-3.87c-2-.22-3.8.75-5.69.79a5.4,5.4,0,0,1-2.64-.6,12.46,12.46,0,0,1-2.07-1.33,12.65,12.65,0,0,0-3.5-2.14,3.6,3.6,0,0,0-3,.2,2.72,2.72,0,0,0-1.28,1.39,6.4,6.4,0,0,0-.16.67,1.57,1.57,0,0,1,.06-.7,2.74,2.74,0,0,1,1.28-1.54,3.86,3.86,0,0,1,1.4-.48,4.26,4.26,0,0,1,1.74.19,12.54,12.54,0,0,1,3.64,2.12,7.12,7.12,0,0,0,4.47,1.79,13.88,13.88,0,0,0,2.73-.51,8.42,8.42,0,0,1,3-.32,5.94,5.94,0,0,1,4.77,4.18,5.72,5.72,0,0,1,.07,3.5,6.87,6.87,0,0,1-1.94,3,7.89,7.89,0,0,1-3.13,1.74,8.17,8.17,0,0,1-3.47.16c-1.12-.15-2.19-.39-3.23-.51a6.05,6.05,0,0,0-3,.25,4,4,0,0,0-2.08,1.84,7.89,7.89,0,0,0-.9,2.57c-.29,1.77-.26,3.49-.61,5a6.29,6.29,0,0,1-2.09,3.65,3.34,3.34,0,0,1-3.09.56,2.61,2.61,0,0,1-1.59-1.22A1.46,1.46,0,0,1,135.15,395.84Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M169.12,335.25a3.69,3.69,0,0,1,.69-.93,5.34,5.34,0,0,1,3-1.5,5.13,5.13,0,0,1,4.78,1.9,5.49,5.49,0,0,1,1.21,3.09,8.2,8.2,0,0,0,.76,3.48,2.7,2.7,0,0,0,1.46,1.09,7.88,7.88,0,0,0,2,.31c.7,0,1.42,0,2.17.1a4.08,4.08,0,0,1,2.19.78,2.69,2.69,0,0,1,.76,1,2.66,2.66,0,0,1,.2,1.25,4.17,4.17,0,0,1-1,2.26,6.39,6.39,0,0,1-2,1.57c-.75.38-1.54.69-2.31,1.05a8.14,8.14,0,0,0-2.13,1.31,4.13,4.13,0,0,0-1.25,2.13c-.41,1.68,0,3.5-.12,5.4a7,7,0,0,1-.76,2.8,3.33,3.33,0,0,1-2.38,1.79,3.69,3.69,0,0,1-2.87-1,8.75,8.75,0,0,1-1.91-2.33,24.83,24.83,0,0,0-1.54-2.45,4.52,4.52,0,0,0-2.13-1.66,3.83,3.83,0,0,0-2.62.17,15.5,15.5,0,0,0-2.44,1.3,13.88,13.88,0,0,1-2.48,1.29,7.68,7.68,0,0,1-2.75.46,8.66,8.66,0,0,1-5-1.76,7.1,7.1,0,0,1-2.74-4.23,4.9,4.9,0,0,1,1.19-4.57,4.78,4.78,0,0,1,2.06-1.06,17,17,0,0,1,2.15-.37,7,7,0,0,0,3.68-1.25,7.32,7.32,0,0,0,2-3c.43-1.07.71-2.13,1.08-3.1a9.08,9.08,0,0,1,1.35-2.55,11.79,11.79,0,0,1,1.74-1.68,6.16,6.16,0,0,1,3-1.45,1.39,1.39,0,0,1,1.11.31,1.78,1.78,0,0,0-1.1-.2,6.14,6.14,0,0,0-2.87,1.5,11.1,11.1,0,0,0-1.68,1.68,9.24,9.24,0,0,0-1.27,2.49c-.35,1-.62,2-1,3.12a7.56,7.56,0,0,1-2,3.13,7.23,7.23,0,0,1-3.87,1.36c-1.37.21-2.9.36-4,1.36a4.45,4.45,0,0,0-1,4.16,6.72,6.72,0,0,0,2.58,3.94,8.24,8.24,0,0,0,4.73,1.64,7,7,0,0,0,2.56-.43,13.79,13.79,0,0,0,2.4-1.26A15.79,15.79,0,0,1,165,356.4a4.32,4.32,0,0,1,3-.18,5,5,0,0,1,2.38,1.83,23.47,23.47,0,0,1,1.58,2.51,8.67,8.67,0,0,0,1.79,2.19,3.13,3.13,0,0,0,2.46.83,2.75,2.75,0,0,0,2-1.52,6.57,6.57,0,0,0,.7-2.58c.1-1.79-.3-3.66.15-5.49a4.64,4.64,0,0,1,1.4-2.37,8.36,8.36,0,0,1,2.26-1.39c.79-.36,1.57-.66,2.3-1a5.87,5.87,0,0,0,1.85-1.45,3.73,3.73,0,0,0,1-2,2.24,2.24,0,0,0-.16-1,2.34,2.34,0,0,0-.64-.82,3.68,3.68,0,0,0-2-.69c-.71-.08-1.43-.08-2.14-.12a8.16,8.16,0,0,1-2.09-.35,3.12,3.12,0,0,1-1.64-1.25,8.34,8.34,0,0,1-.78-3.64,5.24,5.24,0,0,0-1.1-3A5,5,0,0,0,172.8,333a5.37,5.37,0,0,0-2.91,1.37A9.74,9.74,0,0,0,169.12,335.25Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M152.29,318.37a3.48,3.48,0,0,1-2.08,1,6.51,6.51,0,0,1-2.54,0,4.44,4.44,0,0,1-2.73-1.57,5.85,5.85,0,0,1-1-3,8,8,0,0,1,.17-2.53,3.39,3.39,0,0,1,1.07-2,9,9,0,0,0-.7,2.12,8.57,8.57,0,0,0-.07,2.41,5.79,5.79,0,0,0,.93,2.71,4,4,0,0,0,2.41,1.41,7,7,0,0,0,2.38.09A10.22,10.22,0,0,0,152.29,318.37Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M195.34,315.82s0,.1-.07.27a2.76,2.76,0,0,1-.39.72,4.49,4.49,0,0,1-2.49,1.66,4.64,4.64,0,0,1-2.11,0,5.6,5.6,0,0,1-2.13-1.14,6.85,6.85,0,0,0-2.1-1.29,1.91,1.91,0,0,0-2.13.84,18,18,0,0,0-1.23,2.44,5,5,0,0,1-1.77,2,4.72,4.72,0,0,1-6.67-1.44,2,2,0,0,1-.41-1s.17.35.57.9a5,5,0,0,0,2.26,1.69,4.54,4.54,0,0,0,5.56-2.38,19,19,0,0,1,1.26-2.51,2.69,2.69,0,0,1,1.19-1,2.34,2.34,0,0,1,1.5-.06,7.17,7.17,0,0,1,2.27,1.4,5.21,5.21,0,0,0,1.93,1.1,4.34,4.34,0,0,0,1.93,0,4.45,4.45,0,0,0,2.41-1.42C195.16,316.17,195.3,315.8,195.34,315.82Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M202.47,355.08a5.3,5.3,0,0,1-1.11-.72,22.78,22.78,0,0,1-2.73-2.38,13,13,0,0,1-1.59-2,6.65,6.65,0,0,1-1-2.76,5.39,5.39,0,0,1,.51-3.21,4,4,0,0,1,1.13-1.34,12.16,12.16,0,0,1,1.47-.94,6.38,6.38,0,0,0,1.33-1,3.15,3.15,0,0,0,.77-1.32,7.74,7.74,0,0,0,.1-3,15,15,0,0,1-.21-2.88,3.52,3.52,0,0,1,.93-2.39,5.31,5.31,0,0,1,3.37-1.35,1.44,1.44,0,0,1,1.24.46,2.36,2.36,0,0,0-1.23-.26,5.32,5.32,0,0,0-3.12,1.41,3.16,3.16,0,0,0-.76,2.16,16.68,16.68,0,0,0,.25,2.79,7.86,7.86,0,0,1-.08,3.23,3.58,3.58,0,0,1-.89,1.54,6.4,6.4,0,0,1-1.44,1.05A5.38,5.38,0,0,0,197,344.3a5.06,5.06,0,0,0-.49,2.92,8,8,0,0,0,2.38,4.51C201,353.93,202.53,355,202.47,355.08Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M181.56,374.92a1.38,1.38,0,0,1,.46,0,10.92,10.92,0,0,1,1.34.08,12.92,12.92,0,0,1,4.74,1.38,8.63,8.63,0,0,1,4.48,5.67,6,6,0,0,1-.62,4.33,5.86,5.86,0,0,1-3.76,2.81,5.35,5.35,0,0,1-2.43-.13,3.3,3.3,0,0,0-2.08,0,4,4,0,0,0-1.62,1.25A11.57,11.57,0,0,0,181,392a6.71,6.71,0,0,1-2.61,3,4.93,4.93,0,0,1-3.43.41,4.32,4.32,0,0,1-2.39-1.56,4.78,4.78,0,0,1-.92-1.94,4.11,4.11,0,0,1-.07-1.35,1.54,1.54,0,0,1,.1-.46,7.2,7.2,0,0,0,.17,1.76,4.67,4.67,0,0,0,.95,1.81A4,4,0,0,0,175,395a4.6,4.6,0,0,0,3.15-.43,6.38,6.38,0,0,0,2.39-2.83,6.45,6.45,0,0,1,3-3.22,3.8,3.8,0,0,1,2.38,0,4.74,4.74,0,0,0,2.21.13,5.38,5.38,0,0,0,3.42-2.56,5.57,5.57,0,0,0,.59-4,8.34,8.34,0,0,0-4.19-5.45,13.64,13.64,0,0,0-4.58-1.5C182.2,375,181.55,375,181.56,374.92Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M162.83,408a6.81,6.81,0,0,0-.93-2.06,5.07,5.07,0,0,0-1.87-1.51,4,4,0,0,0-5.16,1.38A5,5,0,0,0,154,408a6.75,6.75,0,0,0,.22,2.25s-.17-.17-.33-.55a4.05,4.05,0,0,1-.26-1.74,5.18,5.18,0,0,1,.83-2.48,4.31,4.31,0,0,1,5.77-1.54,5.1,5.1,0,0,1,2,1.73,4,4,0,0,1,.64,1.63C162.89,407.72,162.86,408,162.83,408Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M166,422.5s-.09-.47-.45-1.23a5.25,5.25,0,0,0-2.4-2.46,5,5,0,0,0-4.87.37,7.65,7.65,0,0,0-2,2.28,7.23,7.23,0,0,1-1.14,1.3,2.74,2.74,0,0,1-1.75.65,4.36,4.36,0,0,1-3-1.81,10,10,0,0,0-2.12-2.21,3.74,3.74,0,0,0-2.59-.47,5.27,5.27,0,0,0-2.19.91,8.92,8.92,0,0,0-2.3,2.65,9.1,9.1,0,0,1-.69,1.13,4.57,4.57,0,0,1,.51-1.22,8.39,8.39,0,0,1,2.26-2.85,5.34,5.34,0,0,1,2.34-1,4.15,4.15,0,0,1,2.92.48,10.19,10.19,0,0,1,2.25,2.29,3.9,3.9,0,0,0,2.62,1.62c1.07,0,1.85-.87,2.46-1.73a8.25,8.25,0,0,1,2.17-2.38,5.18,5.18,0,0,1,7.73,2.41,4.11,4.11,0,0,1,.25,1C166.06,422.38,166.06,422.5,166,422.5Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
				<path
					d='M173.71,386.22a11.45,11.45,0,0,0-2.88-1.27,9.08,9.08,0,0,0-3.36-.18,8.11,8.11,0,0,0-3.8,1.48,7,7,0,0,0-2.4,3.25,7.2,7.2,0,0,0-.36,3.32,9.43,9.43,0,0,0,1.06,2.94s-.25-.2-.56-.67a6.07,6.07,0,0,1-.87-2.22,7.29,7.29,0,0,1,2.82-7,8.25,8.25,0,0,1,4-1.53,8.7,8.7,0,0,1,3.52.3,6.86,6.86,0,0,1,2.14,1C173.52,386,173.73,386.2,173.71,386.22Z'
					transform='translate(-41.02 -46.31)'
					fill='#fafafa'
				/>
			</g>
		</svg>
	);
};

export const Quotes = () => {
	return (
		<svg
			width='700pt'
			height='700pt'
			version='1.1'
			viewBox='0 0 700 700'
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
		>
			<defs>
				<symbol id='u' overflow='visible'>
					<path d='m18.766-1.125c-0.96875 0.5-1.9805 0.875-3.0312 1.125-1.043 0.25781-2.1367 0.39062-3.2812 0.39062-3.3984 0-6.0898-0.94531-8.0781-2.8438-1.9922-1.9062-2.9844-4.4844-2.9844-7.7344 0-3.2578 0.99219-5.8359 2.9844-7.7344 1.9883-1.9062 4.6797-2.8594 8.0781-2.8594 1.1445 0 2.2383 0.13281 3.2812 0.39062 1.0508 0.25 2.0625 0.625 3.0312 1.125v4.2188c-0.98047-0.65625-1.9453-1.1406-2.8906-1.4531-0.94922-0.3125-1.9492-0.46875-3-0.46875-1.875 0-3.3516 0.60547-4.4219 1.8125-1.0742 1.1992-1.6094 2.8555-1.6094 4.9688 0 2.1055 0.53516 3.7617 1.6094 4.9688 1.0703 1.1992 2.5469 1.7969 4.4219 1.7969 1.0508 0 2.0508-0.14844 3-0.45312 0.94531-0.3125 1.9102-0.80078 2.8906-1.4688z' />
				</symbol>
				<symbol id='b' overflow='visible'>
					<path d='m13.734-11.141c-0.4375-0.19531-0.87109-0.34375-1.2969-0.4375-0.41797-0.10156-0.83984-0.15625-1.2656-0.15625-1.2617 0-2.2305 0.40625-2.9062 1.2188-0.67969 0.80469-1.0156 1.9531-1.0156 3.4531v7.0625h-4.8906v-15.312h4.8906v2.5156c0.625-1 1.3438-1.7266 2.1562-2.1875 0.82031-0.46875 1.8008-0.70312 2.9375-0.70312 0.16406 0 0.34375 0.011719 0.53125 0.03125 0.19531 0.011719 0.47656 0.039062 0.84375 0.078125z' />
				</symbol>
				<symbol id='a' overflow='visible'>
					<path d='m17.641-7.7031v1.4062h-11.453c0.125 1.1484 0.53906 2.0078 1.25 2.5781 0.70703 0.57422 1.7031 0.85938 2.9844 0.85938 1.0312 0 2.082-0.14844 3.1562-0.45312 1.082-0.3125 2.1914-0.77344 3.3281-1.3906v3.7656c-1.1562 0.4375-2.3125 0.76562-3.4688 0.98438-1.1562 0.22656-2.3125 0.34375-3.4688 0.34375-2.7734 0-4.9297-0.70312-6.4688-2.1094-1.5312-1.4062-2.2969-3.3789-2.2969-5.9219 0-2.5 0.75391-4.4609 2.2656-5.8906 1.5078-1.4375 3.582-2.1562 6.2188-2.1562 2.4062 0 4.332 0.73047 5.7812 2.1875 1.4453 1.4492 2.1719 3.3828 2.1719 5.7969zm-5.0312-1.625c0-0.92578-0.27344-1.6719-0.8125-2.2344-0.54297-0.57031-1.25-0.85938-2.125-0.85938-0.94922 0-1.7188 0.26562-2.3125 0.79688s-0.96484 1.2969-1.1094 2.2969z' />
				</symbol>
				<symbol id='l' overflow='visible'>
					<path d='m9.2188-6.8906c-1.0234 0-1.793 0.17188-2.3125 0.51562-0.51172 0.34375-0.76562 0.85547-0.76562 1.5312 0 0.625 0.20703 1.1172 0.625 1.4688 0.41406 0.34375 0.98828 0.51562 1.7188 0.51562 0.92578 0 1.7031-0.32812 2.3281-0.98438 0.63281-0.66406 0.95312-1.4922 0.95312-2.4844v-0.5625zm7.4688-1.8438v8.7344h-4.9219v-2.2656c-0.65625 0.92969-1.3984 1.6055-2.2188 2.0312-0.82422 0.41406-1.8242 0.625-3 0.625-1.5859 0-2.8711-0.45703-3.8594-1.375-0.99219-0.92578-1.4844-2.1289-1.4844-3.6094 0-1.7891 0.61328-3.1016 1.8438-3.9375 1.2383-0.84375 3.1797-1.2656 5.8281-1.2656h2.8906v-0.39062c0-0.76953-0.30859-1.332-0.92188-1.6875-0.61719-0.36328-1.5703-0.54688-2.8594-0.54688-1.0547 0-2.0312 0.10547-2.9375 0.3125-0.89844 0.21094-1.7305 0.52344-2.5 0.9375v-3.7344c1.0391-0.25 2.0859-0.44141 3.1406-0.57812 1.0625-0.13281 2.125-0.20312 3.1875-0.20312 2.7578 0 4.75 0.54688 5.9688 1.6406 1.2266 1.0859 1.8438 2.8555 1.8438 5.3125z' />
				</symbol>
				<symbol id='d' overflow='visible'>
					<path d='m7.7031-19.656v4.3438h5.0469v3.5h-5.0469v6.5c0 0.71094 0.14062 1.1875 0.42188 1.4375s0.83594 0.375 1.6719 0.375h2.5156v3.5h-4.1875c-1.9375 0-3.3125-0.39844-4.125-1.2031-0.80469-0.8125-1.2031-2.1797-1.2031-4.1094v-6.5h-2.4219v-3.5h2.4219v-4.3438z' />
				</symbol>
				<symbol id='k' overflow='visible'>
					<path d='m12.766-13.078v-8.2031h4.9219v21.281h-4.9219v-2.2188c-0.66797 0.90625-1.4062 1.5703-2.2188 1.9844s-1.7578 0.625-2.8281 0.625c-1.8867 0-3.4336-0.75-4.6406-2.25-1.2109-1.5-1.8125-3.4258-1.8125-5.7812 0-2.3633 0.60156-4.2969 1.8125-5.7969 1.207-1.5 2.7539-2.25 4.6406-2.25 1.0625 0 2 0.21484 2.8125 0.64062 0.82031 0.42969 1.5664 1.0859 2.2344 1.9688zm-3.2188 9.9219c1.0391 0 1.8359-0.37891 2.3906-1.1406 0.55078-0.76953 0.82812-1.8828 0.82812-3.3438 0-1.457-0.27734-2.5664-0.82812-3.3281-0.55469-0.76953-1.3516-1.1562-2.3906-1.1562-1.043 0-1.8398 0.38672-2.3906 1.1562-0.55469 0.76172-0.82812 1.8711-0.82812 3.3281 0 1.4609 0.27344 2.5742 0.82812 3.3438 0.55078 0.76172 1.3477 1.1406 2.3906 1.1406z' />
				</symbol>
				<symbol id='j' overflow='visible'>
					<path d='m10.5-3.1562c1.0508 0 1.8516-0.37891 2.4062-1.1406 0.55078-0.76953 0.82812-1.8828 0.82812-3.3438 0-1.457-0.27734-2.5664-0.82812-3.3281-0.55469-0.76953-1.3555-1.1562-2.4062-1.1562-1.0547 0-1.8594 0.38672-2.4219 1.1562-0.55469 0.77344-0.82812 1.8828-0.82812 3.3281 0 1.4492 0.27344 2.5586 0.82812 3.3281 0.5625 0.77344 1.3672 1.1562 2.4219 1.1562zm-3.25-9.9219c0.67578-0.88281 1.4219-1.5391 2.2344-1.9688 0.82031-0.42578 1.7656-0.64062 2.8281-0.64062 1.8945 0 3.4453 0.75 4.6562 2.25 1.207 1.5 1.8125 3.4336 1.8125 5.7969 0 2.3555-0.60547 4.2812-1.8125 5.7812-1.2109 1.5-2.7617 2.25-4.6562 2.25-1.0625 0-2.0078-0.21094-2.8281-0.625-0.8125-0.42578-1.5586-1.0859-2.2344-1.9844v2.2188h-4.8906v-21.281h4.8906z' />
				</symbol>
				<symbol id='i' overflow='visible'>
					<path d='m0.34375-15.312h4.8906l4.125 10.391 3.5-10.391h4.8906l-6.4375 16.766c-0.64844 1.6953-1.4023 2.8828-2.2656 3.5625-0.86719 0.6875-2 1.0312-3.4062 1.0312h-2.8438v-3.2188h1.5312c0.83203 0 1.4375-0.13672 1.8125-0.40625 0.38281-0.26172 0.67969-0.73047 0.89062-1.4062l0.14062-0.42188z' />
				</symbol>
				<symbol id='h' overflow='visible'>
					<path d='m2.3594-15.312h4.8906v15.312h-4.8906zm0-5.9688h4.8906v4h-4.8906z' />
				</symbol>
				<symbol id='g' overflow='visible'>
					<path d='m14.719-14.828v3.9844c-0.65625-0.45703-1.3242-0.79688-2-1.0156-0.66797-0.21875-1.3594-0.32812-2.0781-0.32812-1.3672 0-2.4336 0.40234-3.2031 1.2031-0.76172 0.79297-1.1406 1.9062-1.1406 3.3438 0 1.4297 0.37891 2.543 1.1406 3.3438 0.76953 0.79297 1.8359 1.1875 3.2031 1.1875 0.75781 0 1.4844-0.10938 2.1719-0.32812 0.6875-0.22656 1.3203-0.56641 1.9062-1.0156v4c-0.76172 0.28125-1.5391 0.48828-2.3281 0.625-0.78125 0.14453-1.5742 0.21875-2.375 0.21875-2.7617 0-4.9219-0.70703-6.4844-2.125-1.5547-1.4141-2.3281-3.3828-2.3281-5.9062 0-2.5312 0.77344-4.5039 2.3281-5.9219 1.5625-1.4141 3.7227-2.125 6.4844-2.125 0.80078 0 1.5938 0.074219 2.375 0.21875 0.78125 0.13672 1.5547 0.35156 2.3281 0.64062z' />
				</symbol>
				<symbol id='c' overflow='visible'>
					<path d='m9.6406-12.188c-1.0859 0-1.9141 0.39062-2.4844 1.1719-0.57422 0.78125-0.85938 1.9062-0.85938 3.375s0.28516 2.5938 0.85938 3.375c0.57031 0.77344 1.3984 1.1562 2.4844 1.1562 1.0625 0 1.875-0.38281 2.4375-1.1562 0.57031-0.78125 0.85938-1.9062 0.85938-3.375s-0.28906-2.5938-0.85938-3.375c-0.5625-0.78125-1.375-1.1719-2.4375-1.1719zm0-3.5c2.6328 0 4.6914 0.71484 6.1719 2.1406 1.4766 1.418 2.2188 3.3867 2.2188 5.9062 0 2.5117-0.74219 4.4805-2.2188 5.9062-1.4805 1.418-3.5391 2.125-6.1719 2.125-2.6484 0-4.7148-0.70703-6.2031-2.125-1.4922-1.4258-2.2344-3.3945-2.2344-5.9062 0-2.5195 0.74219-4.4883 2.2344-5.9062 1.4883-1.4258 3.5547-2.1406 6.2031-2.1406z' />
				</symbol>
				<symbol id='f' overflow='visible'>
					<path d='m17.75-9.3281v9.3281h-4.9219v-7.1406c0-1.3203-0.03125-2.2344-0.09375-2.7344s-0.16797-0.86719-0.3125-1.1094c-0.1875-0.3125-0.44922-0.55469-0.78125-0.73438-0.32422-0.17578-0.69531-0.26562-1.1094-0.26562-1.0234 0-1.8242 0.39844-2.4062 1.1875-0.58594 0.78125-0.875 1.8711-0.875 3.2656v7.5312h-4.8906v-15.312h4.8906v2.2344c0.73828-0.88281 1.5195-1.5391 2.3438-1.9688 0.83203-0.42578 1.75-0.64062 2.75-0.64062 1.7695 0 3.1133 0.54688 4.0312 1.6406 0.91406 1.0859 1.375 2.6562 1.375 4.7188z' />
				</symbol>
				<symbol id='t' overflow='visible'>
					<path d='m14.312-14.828v3.7188c-1.043-0.4375-2.0547-0.76562-3.0312-0.98438-0.98047-0.21875-1.9023-0.32812-2.7656-0.32812-0.92969 0-1.6211 0.11719-2.0781 0.34375-0.44922 0.23047-0.67188 0.58984-0.67188 1.0781 0 0.38672 0.17188 0.68359 0.51562 0.89062 0.34375 0.21094 0.95703 0.36719 1.8438 0.46875l0.85938 0.125c2.5078 0.32422 4.1953 0.85156 5.0625 1.5781 0.86328 0.73047 1.2969 1.8711 1.2969 3.4219 0 1.6367-0.60547 2.8672-1.8125 3.6875-1.1992 0.8125-2.9922 1.2188-5.375 1.2188-1.0234 0-2.0742-0.078125-3.1562-0.23438-1.0742-0.15625-2.1797-0.39453-3.3125-0.71875v-3.7188c0.96875 0.48047 1.9609 0.83984 2.9844 1.0781 1.0312 0.23047 2.0781 0.34375 3.1406 0.34375 0.95703 0 1.6758-0.12891 2.1562-0.39062 0.47656-0.26953 0.71875-0.66406 0.71875-1.1875 0-0.4375-0.16797-0.75781-0.5-0.96875-0.33594-0.21875-0.99609-0.38281-1.9844-0.5l-0.85938-0.10938c-2.1797-0.26953-3.7031-0.77344-4.5781-1.5156-0.875-0.73828-1.3125-1.8594-1.3125-3.3594 0-1.625 0.55078-2.8281 1.6562-3.6094 1.1133-0.78906 2.8203-1.1875 5.125-1.1875 0.89453 0 1.8359 0.074219 2.8281 0.21875 1 0.13672 2.082 0.35156 3.25 0.64062z' />
				</symbol>
				<symbol id='s' overflow='visible'>
					<path d='m7.25-2.2188v8.0469h-4.8906v-21.141h4.8906v2.2344c0.67578-0.88281 1.4219-1.5391 2.2344-1.9688 0.82031-0.42578 1.7656-0.64062 2.8281-0.64062 1.8945 0 3.4453 0.75 4.6562 2.25 1.207 1.5 1.8125 3.4336 1.8125 5.7969 0 2.3555-0.60547 4.2812-1.8125 5.7812-1.2109 1.5-2.7617 2.25-4.6562 2.25-1.0625 0-2.0078-0.21094-2.8281-0.625-0.8125-0.42578-1.5586-1.0859-2.2344-1.9844zm3.25-9.9062c-1.0547 0-1.8594 0.38672-2.4219 1.1562-0.55469 0.77344-0.82812 1.8828-0.82812 3.3281 0 1.4492 0.27344 2.5586 0.82812 3.3281 0.5625 0.77344 1.3672 1.1562 2.4219 1.1562 1.0508 0 1.8516-0.37891 2.4062-1.1406 0.55078-0.76953 0.82812-1.8828 0.82812-3.3438 0-1.457-0.27734-2.5664-0.82812-3.3281-0.55469-0.76953-1.3555-1.1562-2.4062-1.1562z' />
				</symbol>
				<symbol id='e' overflow='visible'>
					<path d='m17.75-9.3281v9.3281h-4.9219v-7.1094c0-1.3438-0.03125-2.2656-0.09375-2.7656s-0.16797-0.86719-0.3125-1.1094c-0.1875-0.3125-0.44922-0.55469-0.78125-0.73438-0.32422-0.17578-0.69531-0.26562-1.1094-0.26562-1.0234 0-1.8242 0.39844-2.4062 1.1875-0.58594 0.78125-0.875 1.8711-0.875 3.2656v7.5312h-4.8906v-21.281h4.8906v8.2031c0.73828-0.88281 1.5195-1.5391 2.3438-1.9688 0.83203-0.42578 1.75-0.64062 2.75-0.64062 1.7695 0 3.1133 0.54688 4.0312 1.6406 0.91406 1.0859 1.375 2.6562 1.375 4.7188z' />
				</symbol>
				<symbol id='r' overflow='visible'>
					<path d='m12.422-21.281v3.2188h-2.7031c-0.6875 0-1.1719 0.125-1.4531 0.375-0.27344 0.25-0.40625 0.6875-0.40625 1.3125v1.0625h4.1875v3.5h-4.1875v11.812h-4.8906v-11.812h-2.4375v-3.5h2.4375v-1.0625c0-1.6641 0.46094-2.8984 1.3906-3.7031 0.92578-0.80078 2.3672-1.2031 4.3281-1.2031z' />
				</symbol>
				<symbol id='q' overflow='visible'>
					<path d='m16.547-12.766c0.61328-0.94531 1.3477-1.6719 2.2031-2.1719 0.85156-0.5 1.7891-0.75 2.8125-0.75 1.7578 0 3.0977 0.54688 4.0156 1.6406 0.92578 1.0859 1.3906 2.6562 1.3906 4.7188v9.3281h-4.9219v-7.9844-0.35938c0.007813-0.13281 0.015625-0.32031 0.015625-0.5625 0-1.082-0.16406-1.8633-0.48438-2.3438-0.3125-0.48828-0.82422-0.73438-1.5312-0.73438-0.92969 0-1.6484 0.38672-2.1562 1.1562-0.51172 0.76172-0.77344 1.8672-0.78125 3.3125v7.5156h-4.9219v-7.9844c0-1.6953-0.14844-2.7852-0.4375-3.2656-0.29297-0.48828-0.8125-0.73438-1.5625-0.73438-0.9375 0-1.6641 0.38672-2.1719 1.1562-0.51172 0.76172-0.76562 1.8594-0.76562 3.2969v7.5312h-4.9219v-15.312h4.9219v2.2344c0.60156-0.86328 1.2891-1.5156 2.0625-1.9531 0.78125-0.4375 1.6406-0.65625 2.5781-0.65625 1.0625 0 2 0.25781 2.8125 0.76562 0.8125 0.51172 1.4258 1.2305 1.8438 2.1562z' />
				</symbol>
				<symbol id='p' overflow='visible'>
					<path d='m2.5781-20.406h5.875l7.4219 14v-14h4.9844v20.406h-5.875l-7.4219-14v14h-4.9844z' />
				</symbol>
				<symbol id='o' overflow='visible'>
					<path d='m2.1875-5.9688v-9.3438h4.9219v1.5312c0 0.83594-0.007813 1.875-0.015625 3.125-0.011719 1.25-0.015625 2.0859-0.015625 2.5 0 1.2422 0.03125 2.1328 0.09375 2.6719 0.070313 0.54297 0.17969 0.93359 0.32812 1.1719 0.20703 0.32422 0.47266 0.57422 0.79688 0.75 0.32031 0.16797 0.69141 0.25 1.1094 0.25 1.0195 0 1.8203-0.39062 2.4062-1.1719 0.58203-0.78125 0.875-1.8672 0.875-3.2656v-7.5625h4.8906v15.312h-4.8906v-2.2188c-0.74219 0.89844-1.5234 1.5586-2.3438 1.9844-0.82422 0.41406-1.7344 0.625-2.7344 0.625-1.7617 0-3.1055-0.53906-4.0312-1.625-0.92969-1.082-1.3906-2.6602-1.3906-4.7344z' />
				</symbol>
				<symbol id='n' overflow='visible'>
					<path d='m2.5781-20.406h8.7344c2.5938 0 4.582 0.57812 5.9688 1.7344 1.3945 1.1484 2.0938 2.7891 2.0938 4.9219 0 2.1367-0.69922 3.7812-2.0938 4.9375-1.3867 1.1562-3.375 1.7344-5.9688 1.7344h-3.4844v7.0781h-5.25zm5.25 3.8125v5.7031h2.9219c1.0195 0 1.8047-0.25 2.3594-0.75 0.5625-0.5 0.84375-1.2031 0.84375-2.1094 0-0.91406-0.28125-1.6172-0.84375-2.1094-0.55469-0.48828-1.3398-0.73438-2.3594-0.73438z' />
				</symbol>
				<symbol id='m' overflow='visible'>
					<path d='m2.3594-15.312h4.8906v15.031c0 2.0508-0.49609 3.6172-1.4844 4.7031-0.98047 1.082-2.4062 1.625-4.2812 1.625h-2.4219v-3.2188h0.85938c0.92578 0 1.5625-0.21094 1.9062-0.625 0.35156-0.41797 0.53125-1.2461 0.53125-2.4844zm0-5.9688h4.8906v4h-4.8906z' />
				</symbol>
			</defs>
			<g>
				<path d='m520.1 436.8c39.195 0 70.699-31.508 70.699-70.699v-60.199c0-39.195-31.508-70.699-70.699-70.699h-52.5c5.6016-39.199 11.199-72.801 22.398-112-40.746 0-100.8 122.57-100.8 179.2v63.699c0 39.195 31.508 70.699 70.699 70.699zm-280 0c39.195 0 70.699-31.508 70.699-70.699v-60.199c0-39.195-31.508-70.699-70.699-70.699h-52.5c5.6016-39.199 11.199-72.801 22.398-112-40.746 0-100.8 122.57-100.8 179.2v63.699c0 39.195 31.508 70.699 70.699 70.699z' />
			</g>
		</svg>
	);
};
